/* tslint:disable */
/* eslint-disable */
/**
 * WENK.SLB.Aggregator.WebAPI [WENK-SIT] (0.0.3391.513)
 * API for WENK.SLB.Aggregator.WebAPI
 *
 * The version of the OpenAPI document: 0.0.3391.513
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Analyze Compare Overlap Session View UrlCode Top Rs Model
 * @export
 * @interface AnalyzeCompareOverlapSessionViewUrlCodeTopRs
 */
export interface AnalyzeCompareOverlapSessionViewUrlCodeTopRs {
    /**
     * UrlCode
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'urlCode'?: string | null;
    /**
     * 檢視資料筆數
     * @type {number}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'count'?: number;
    /**
     * UrlUid
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'urlUid'?: string | null;
    /**
     * 專案名稱
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'projectName'?: string | null;
    /**
     * MainTagName
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'mainTagName'?: string | null;
    /**
     * MainTagCode
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'mainTagCode'?: string | null;
    /**
     * SubTagName
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'subTagName'?: string | null;
    /**
     * SubTagNo
     * @type {string}
     * @memberof AnalyzeCompareOverlapSessionViewUrlCodeTopRs
     */
    'subTagNo'?: string | null;
}
/**
 * Analyze Tag Overlap Rq Model
 * @export
 * @interface AnalyzeTagOverlapRq
 */
export interface AnalyzeTagOverlapRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof AnalyzeTagOverlapRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof AnalyzeTagOverlapRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof AnalyzeTagOverlapRq
     */
    'startDate'?: string | null;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof AnalyzeTagOverlapRq
     */
    'endDate'?: string | null;
    /**
     * 數據標籤 Id
     * @type {number}
     * @memberof AnalyzeTagOverlapRq
     */
    'subTag1Id'?: number;
    /**
     * 數據標籤 Id
     * @type {number}
     * @memberof AnalyzeTagOverlapRq
     */
    'subTag2Id'?: number;
}
/**
 * Analyze Tag Overlap Rs Model
 * @export
 * @interface AnalyzeTagOverlapRs
 */
export interface AnalyzeTagOverlapRs {
    /**
     * 重疊 session id 資料筆數
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'overlapCount'?: number;
    /**
     * tag1 對於 tag2 重疊佔比
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'overlapTag1ToTag2'?: number;
    /**
     * tag2 對於 tag1 重疊佔比
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'overlapTag2ToTag1'?: number;
    /**
     * tag1 session 總數
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'tag1TotalSessionCount'?: number;
    /**
     * tag2 session 總數
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'tag2TotalSessionCount'?: number;
    /**
     * tag1 完整名稱
     * @type {string}
     * @memberof AnalyzeTagOverlapRs
     */
    'tag1FullName'?: string | null;
    /**
     * tag2 完整名稱
     * @type {string}
     * @memberof AnalyzeTagOverlapRs
     */
    'tag2FullName'?: string | null;
    /**
     * 計算 tag1 和 tag2 重疊百分比
     * @type {number}
     * @memberof AnalyzeTagOverlapRs
     */
    'overlapPercentage'?: number;
}
/**
 * 
 * @export
 * @interface AppInfoApiRs
 */
export interface AppInfoApiRs {
    /**
     * 
     * @type {string}
     * @memberof AppInfoApiRs
     */
    'applicationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppInfoApiRs
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppInfoApiRs
     */
    'machineName'?: string | null;
}
/**
 * 單一登入類型  0 = None (None)  1 = Google (Google)  2 = Line (Line)  3 = NativeAccount (NativeAccount)
 * @export
 * @enum {string}
 */

export const AuthProvider = {
    /**
    * None
    */
    None: 0,
    /**
    * Google
    */
    Google: 1,
    /**
    * Line
    */
    Line: 2,
    /**
    * NativeAccount
    */
    NativeAccount: 3
} as const;

export type AuthProvider = typeof AuthProvider[keyof typeof AuthProvider];


/**
 * BillInfo Rq
 * @export
 * @interface BillInfoRq
 */
export interface BillInfoRq {
    /**
     * company uuid
     * @type {string}
     * @memberof BillInfoRq
     */
    'companyUuid'?: string;
}
/**
 * BillInfo Rs
 * @export
 * @interface BillInfoRs
 */
export interface BillInfoRs {
    /**
     * 公司名稱
     * @type {string}
     * @memberof BillInfoRs
     */
    'companyName'?: string | null;
    /**
     * 訂閱項目名稱
     * @type {string}
     * @memberof BillInfoRs
     */
    'subscriptionDisplayName'?: string | null;
    /**
     * 
     * @type {CompanyStatus}
     * @memberof BillInfoRs
     */
    'companyStatusCode'?: CompanyStatus;
    /**
     * 訂閱生效日期
     * @type {string}
     * @memberof BillInfoRs
     */
    'subscriptionActivationDate'?: string;
    /**
     * 訂閱結束日期
     * @type {string}
     * @memberof BillInfoRs
     */
    'subscriptionExpirationDate'?: string;
    /**
     * 公司縮圖網址
     * @type {string}
     * @memberof BillInfoRs
     */
    'companyThumbUrl'?: string | null;
    /**
     * 公司成員數量 (包含公司負責人)
     * @type {number}
     * @memberof BillInfoRs
     */
    'companyMemberCount'?: number;
    /**
     * 公司訂閱期間, 建立短網址數量
     * @type {number}
     * @memberof BillInfoRs
     */
    'shortUrlsCreatedDuringSubscriptionCount'?: number;
    /**
     * 組織數量
     * @type {number}
     * @memberof BillInfoRs
     */
    'organizationCount'?: number;
    /**
     * 組織可建立上限
     * @type {number}
     * @memberof BillInfoRs
     */
    'organizationLimit'?: number;
    /**
     * 公司成員數量上限 (包含公司負責人)
     * @type {number}
     * @memberof BillInfoRs
     */
    'companyMemberLimit'?: number;
    /**
     * 公司訂閱期間, 建立短網址數量 上限
     * @type {number}
     * @memberof BillInfoRs
     */
    'shortUrlsCreatedDuringSubscriptionLimit'?: number;
}


/**
 * Billing Company Info Rq Model
 * @export
 * @interface BillingCompanyInfoRq
 */
export interface BillingCompanyInfoRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof BillingCompanyInfoRq
     */
    'term'?: string | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof BillingCompanyInfoRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof BillingCompanyInfoRq
     */
    'pageSize'?: number;
    /**
     * 
     * @type {BillingCompanyQuerySortingFields}
     * @memberof BillingCompanyInfoRq
     */
    'sortingField'?: BillingCompanyQuerySortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof BillingCompanyInfoRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * Billing Company Info Rs Model
 * @export
 * @interface BillingCompanyInfoRs
 */
export interface BillingCompanyInfoRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof BillingCompanyInfoRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof BillingCompanyInfoRs
     */
    'companyName'?: string | null;
    /**
     * 訂閱方案名稱
     * @type {string}
     * @memberof BillingCompanyInfoRs
     */
    'subscriptionDisplayName'?: string | null;
    /**
     * 公司縮圖網址
     * @type {string}
     * @memberof BillingCompanyInfoRs
     */
    'companyThumbUrl'?: string | null;
}
/**
 * BillingCompanyQuerySortingFields  0 = None (None)  1 = SubscriptionType (訂閱方案)
 * @export
 * @enum {string}
 */

export const BillingCompanyQuerySortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 訂閱方案
    */
    SubscriptionType: 1
} as const;

export type BillingCompanyQuerySortingFields = typeof BillingCompanyQuerySortingFields[keyof typeof BillingCompanyQuerySortingFields];


/**
 * Billing Company Subtotal Rs Model
 * @export
 * @interface BillingCompanySubtotalRs
 */
export interface BillingCompanySubtotalRs {
    /**
     * 公司總數量
     * @type {number}
     * @memberof BillingCompanySubtotalRs
     */
    'totalCount'?: number;
}
/**
 * Billing Get Contact Rq Model
 * @export
 * @interface BillingGetContactRq
 */
export interface BillingGetContactRq {
    /**
     * company uuid
     * @type {string}
     * @memberof BillingGetContactRq
     */
    'companyUuid'?: string;
}
/**
 * Billing Get Contact Rs Model
 * @export
 * @interface BillingGetContactRs
 */
export interface BillingGetContactRs {
    /**
     * 聯絡 email
     * @type {string}
     * @memberof BillingGetContactRs
     */
    'contactEmail'?: string | null;
}
/**
 * Company Update Billing Contact Rq Model
 * @export
 * @interface BillingUpdateContactRq
 */
export interface BillingUpdateContactRq {
    /**
     * company uuid
     * @type {string}
     * @memberof BillingUpdateContactRq
     */
    'companyUuid'?: string;
    /**
     * 聯絡 email
     * @type {string}
     * @memberof BillingUpdateContactRq
     */
    'contactEmail'?: string | null;
}
/**
 * FE Company Org Stats SubTag Clicks Rq Model
 * @export
 * @interface CompanyOrgStatsClicksRq
 */
export interface CompanyOrgStatsClicksRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof CompanyOrgStatsClicksRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof CompanyOrgStatsClicksRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * sub tag id
     * @type {number}
     * @memberof CompanyOrgStatsClicksRq
     */
    'subTagId'?: number;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof CompanyOrgStatsClicksRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof CompanyOrgStatsClicksRq
     */
    'endDate'?: string;
}
/**
 * FE Company Org Stats Query Sub Tag Info Rq Model
 * @export
 * @interface CompanyOrgStatsQueryRq
 */
export interface CompanyOrgStatsQueryRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof CompanyOrgStatsQueryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof CompanyOrgStatsQueryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 數據標籤 Id
     * @type {number}
     * @memberof CompanyOrgStatsQueryRq
     */
    'subTagId'?: number;
    /**
     * 開始日期
     * @type {string}
     * @memberof CompanyOrgStatsQueryRq
     */
    'startDate'?: string;
    /**
     * 結束日期
     * @type {string}
     * @memberof CompanyOrgStatsQueryRq
     */
    'endDate'?: string;
}
/**
 * FE Company Org Stats Query Sub Tag Info Rs Model
 * @export
 * @interface CompanyOrgStatsQuerySubTagInfoRs
 */
export interface CompanyOrgStatsQuerySubTagInfoRs {
    /**
     * 數據標籤代碼
     * @type {string}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'subTagNo'?: string | null;
    /**
     * 數據標籤名稱
     * @type {string}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'subTagName'?: string | null;
    /**
     * IP 點擊數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'ipClickCount'?: number;
    /**
     * 總點擊次數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'totalClicks'?: number;
    /**
     * label - IP 點擊數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'labelIPClickCount'?: number;
    /**
     * label - 總點擊次數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'labelTotalClicks'?: number;
    /**
     * 轉換數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'conversions'?: number | null;
    /**
     * label - 轉換數
     * @type {number}
     * @memberof CompanyOrgStatsQuerySubTagInfoRs
     */
    'labelConversions'?: number | null;
}
/**
 * 公司查詢 欄位選取  0 = None (None)  1 = SubscriptionType (訂閱方案)  2 = CompanyOwner (公司擁有者)  3 = CompanyContact (公司負責業務)  4 = Operator (執行人員)  5 = CompanyStatus (公司狀態)  6 = SubscriptionActivationDate (訂閱啟用日)  7 = SubscriptionExpirationDate (訂閱到期日)  8 = DataInputType (資料輸入方式)  9 = VATNumber (統一編號)
 * @export
 * @enum {string}
 */

export const CompanyQueryFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 訂閱方案
    */
    SubscriptionType: 1,
    /**
    * 公司擁有者
    */
    CompanyOwner: 2,
    /**
    * 公司負責業務
    */
    CompanyContact: 3,
    /**
    * 執行人員
    */
    Operator: 4,
    /**
    * 公司狀態
    */
    CompanyStatus: 5,
    /**
    * 訂閱啟用日
    */
    SubscriptionActivationDate: 6,
    /**
    * 訂閱到期日
    */
    SubscriptionExpirationDate: 7,
    /**
    * 資料輸入方式
    */
    DataInputType: 8,
    /**
    * 統一編號
    */
    VATNumber: 9
} as const;

export type CompanyQueryFields = typeof CompanyQueryFields[keyof typeof CompanyQueryFields];


/**
 * 公司查詢 - 欄位排序  0 = None (None)  1 = SubscriptionType (訂閱方案)  2 = SubscriptionExpirationDate (訂閱到期日)  3 = SubscriptionActivationDate (訂閱啟用日)
 * @export
 * @enum {string}
 */

export const CompanyQuerySortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 訂閱方案
    */
    SubscriptionType: 1,
    /**
    * 訂閱到期日
    */
    SubscriptionExpirationDate: 2,
    /**
    * 訂閱啟用日
    */
    SubscriptionActivationDate: 3
} as const;

export type CompanyQuerySortingFields = typeof CompanyQuerySortingFields[keyof typeof CompanyQuerySortingFields];


/**
 * Company Query Type  0 = None (None)  1 = All (總建立)  2 = Active (使用中)  3 = ExpiringSoon (將到期)  4 = Disabled (已停用)
 * @export
 * @enum {string}
 */

export const CompanyQueryType = {
    /**
    * None
    */
    None: 0,
    /**
    * 總建立
    */
    All: 1,
    /**
    * 使用中
    */
    Active: 2,
    /**
    * 將到期
    */
    ExpiringSoon: 3,
    /**
    * 已停用
    */
    Disabled: 4
} as const;

export type CompanyQueryType = typeof CompanyQueryType[keyof typeof CompanyQueryType];


/**
 * 公司狀態  0 = None (None)  1 = Active (使用中)  2 = Disabled (已停用)  3 = ExpiringSoon (將到期)  4 = Expired (到期)
 * @export
 * @enum {string}
 */

export const CompanyStatus = {
    /**
    * None
    */
    None: 0,
    /**
    * 使用中
    */
    Active: 1,
    /**
    * 已停用
    */
    Disabled: 2,
    /**
    * 將到期
    */
    ExpiringSoon: 3,
    /**
    * 到期
    */
    Expired: 4
} as const;

export type CompanyStatus = typeof CompanyStatus[keyof typeof CompanyStatus];


/**
 * 公司訂閱類型  0 = None (None)  1 = Professional (Professional)  2 = Enterprise (Enterprise)  3 = Basic (Basic)  4 = Trial (試用)
 * @export
 * @enum {string}
 */

export const CompanySubscriptionType = {
    /**
    * None
    */
    None: 0,
    /**
    * Professional
    */
    Professional: 1,
    /**
    * Enterprise
    */
    Enterprise: 2,
    /**
    * Basic
    */
    Basic: 3,
    /**
    * 試用
    */
    Trial: 4
} as const;

export type CompanySubscriptionType = typeof CompanySubscriptionType[keyof typeof CompanySubscriptionType];


/**
 * 資料狀態  0 = None (None)  1 = Inactive (未啟用)  2 = Active (啟用)
 * @export
 * @enum {string}
 */

export const DataStatus = {
    /**
    * None
    */
    None: 0,
    /**
    * 未啟用
    */
    Inactive: 1,
    /**
    * 啟用
    */
    Active: 2
} as const;

export type DataStatus = typeof DataStatus[keyof typeof DataStatus];


/**
 * Domain 狀態  0 = None (None)  1 = Unverified (未驗證)  2 = Pending (待驗證)  3 = Verified (已驗證)  4 = Active (已啟用)  5 = Failed (驗證失敗)  6 = Inactive (已停用)
 * @export
 * @enum {string}
 */

export const DomainStatus = {
    /**
    * None
    */
    None: 0,
    /**
    * 未驗證
    */
    Unverified: 1,
    /**
    * 待驗證
    */
    Pending: 2,
    /**
    * 已驗證
    */
    Verified: 3,
    /**
    * 已啟用
    */
    Active: 4,
    /**
    * 驗證失敗
    */
    Failed: 5,
    /**
    * 已停用
    */
    Inactive: 6
} as const;

export type DomainStatus = typeof DomainStatus[keyof typeof DomainStatus];


/**
 * EF Company Feature Rs Model
 * @export
 * @interface EFCompanyFeatureRs
 */
export interface EFCompanyFeatureRs {
    /**
     * 
     * @type {PROMFeatures}
     * @memberof EFCompanyFeatureRs
     */
    'feature'?: PROMFeatures;
    /**
     * 啟用
     * @type {boolean}
     * @memberof EFCompanyFeatureRs
     */
    'enable'?: boolean;
}


/**
 * EFCompanyOrganizationBaseRs
 * @export
 * @interface EFCompanyOrganizationBaseRs
 */
export interface EFCompanyOrganizationBaseRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof EFCompanyOrganizationBaseRs
     */
    'companyUuid'?: string;
    /**
     * 公司組織公開 id
     * @type {string}
     * @memberof EFCompanyOrganizationBaseRs
     */
    'companyOrganizationUuid'?: string;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof EFCompanyOrganizationBaseRs
     */
    'companyOrganizationName'?: string | null;
}
/**
 * EF Company Organization Option Rs Model
 * @export
 * @interface EFCompanyOrganizationOptionRs
 */
export interface EFCompanyOrganizationOptionRs {
    /**
     * 公司組織公開 id
     * @type {string}
     * @memberof EFCompanyOrganizationOptionRs
     */
    'companyOrganizationUuid'?: string;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof EFCompanyOrganizationOptionRs
     */
    'companyOrganizationName'?: string | null;
    /**
     * 是否具有編輯權限
     * @type {boolean}
     * @memberof EFCompanyOrganizationOptionRs
     */
    'hasEditPermissions'?: boolean;
}
/**
 * EF Company Organization Rs Model
 * @export
 * @interface EFCompanyOrganizationRs
 */
export interface EFCompanyOrganizationRs {
    /**
     * 
     * @type {CompanySubscriptionType}
     * @memberof EFCompanyOrganizationRs
     */
    'subscription'?: CompanySubscriptionType;
    /**
     * 訂閱方案名稱
     * @type {string}
     * @memberof EFCompanyOrganizationRs
     */
    'subscriptionDisplayName'?: string | null;
    /**
     * 公司縮圖網址
     * @type {string}
     * @memberof EFCompanyOrganizationRs
     */
    'companyThumbUrl'?: string | null;
    /**
     * organization options
     * @type {Array<EFCompanyOrganizationOptionRs>}
     * @memberof EFCompanyOrganizationRs
     */
    'options'?: Array<EFCompanyOrganizationOptionRs> | null;
}


/**
 * FECompanyBaseRs
 * @export
 * @interface FECompanyBaseRs
 */
export interface FECompanyBaseRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof FECompanyBaseRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof FECompanyBaseRs
     */
    'companyName'?: string | null;
}
/**
 * Short Url Company Count Rs Model
 * @export
 * @interface FECompanyCountRs
 */
export interface FECompanyCountRs {
    /**
     * 公司總數
     * @type {number}
     * @memberof FECompanyCountRs
     */
    'companyTotalCount'?: number;
}
/**
 * FECompanyUpdateOrganizationTagsRq
 * @export
 * @interface FECompanyCreateOrUpdateOrganizationTagsRq
 */
export interface FECompanyCreateOrUpdateOrganizationTagsRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FECompanyCreateOrUpdateOrganizationTagsRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FECompanyCreateOrUpdateOrganizationTagsRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 標籤
     * @type {Array<FECompanyUpdateOrganizationTagDetailRq>}
     * @memberof FECompanyCreateOrUpdateOrganizationTagsRq
     */
    'tag'?: Array<FECompanyUpdateOrganizationTagDetailRq> | null;
}
/**
 * FECompanyGetCompaniesAndOrganizationsRs
 * @export
 * @interface FECompanyGetCompaniesAndOrganizationsRs
 */
export interface FECompanyGetCompaniesAndOrganizationsRs {
    /**
     * 公司清單
     * @type {Array<FECompanyBaseRs>}
     * @memberof FECompanyGetCompaniesAndOrganizationsRs
     */
    'companyList'?: Array<FECompanyBaseRs> | null;
    /**
     * 組織清單
     * @type {Array<EFCompanyOrganizationBaseRs>}
     * @memberof FECompanyGetCompaniesAndOrganizationsRs
     */
    'organizationList'?: Array<EFCompanyOrganizationBaseRs> | null;
    /**
     * 公司總數
     * @type {number}
     * @memberof FECompanyGetCompaniesAndOrganizationsRs
     */
    'companyCount'?: number;
    /**
     * 組織總數
     * @type {number}
     * @memberof FECompanyGetCompaniesAndOrganizationsRs
     */
    'organizationCount'?: number;
}
/**
 * FECompanyOrganizationQueryMembersRq
 * @export
 * @interface FECompanyOrganizationQueryMembersRq
 */
export interface FECompanyOrganizationQueryMembersRq {
    /**
     * company uuid
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRq
     */
    'companyOrganizationUuid'?: string;
}
/**
 * FECompanyOrganizationQueryMembersRs
 * @export
 * @interface FECompanyOrganizationQueryMembersRs
 */
export interface FECompanyOrganizationQueryMembersRs {
    /**
     * public id
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'userUuid'?: string;
    /**
     * user name
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'userName'?: string | null;
    /**
     * Email
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'email'?: string | null;
    /**
     * photo url
     * @type {string}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'userStatusCode'?: UserStatus;
    /**
     * 
     * @type {OrganizationMemberRole}
     * @memberof FECompanyOrganizationQueryMembersRs
     */
    'memberRoleCode'?: OrganizationMemberRole;
}


/**
 * FECompanyOrganizationSendRegistrationInvitationRq
 * @export
 * @interface FECompanyOrganizationSendRegistrationInvitationRq
 */
export interface FECompanyOrganizationSendRegistrationInvitationRq {
    /**
     * company uuid
     * @type {string}
     * @memberof FECompanyOrganizationSendRegistrationInvitationRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof FECompanyOrganizationSendRegistrationInvitationRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * org members
     * @type {Array<FECompanyOrganizationSendRegistrationInvitationUserRq>}
     * @memberof FECompanyOrganizationSendRegistrationInvitationRq
     */
    'orgMembers'?: Array<FECompanyOrganizationSendRegistrationInvitationUserRq> | null;
}
/**
 * FECompanyOrganizationSendRegistrationInvitationUserRq
 * @export
 * @interface FECompanyOrganizationSendRegistrationInvitationUserRq
 */
export interface FECompanyOrganizationSendRegistrationInvitationUserRq {
    /**
     * user uuid
     * @type {string}
     * @memberof FECompanyOrganizationSendRegistrationInvitationUserRq
     */
    'userUuid'?: string | null;
    /**
     * user email
     * @type {string}
     * @memberof FECompanyOrganizationSendRegistrationInvitationUserRq
     */
    'email'?: string | null;
}
/**
 * FE Company Query Company Personnel List Rq Model
 * @export
 * @interface FECompanyQueryCompanyPersonnelListRq
 */
export interface FECompanyQueryCompanyPersonnelListRq {
    /**
     * company uuid
     * @type {string}
     * @memberof FECompanyQueryCompanyPersonnelListRq
     */
    'companyUuid'?: string;
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof FECompanyQueryCompanyPersonnelListRq
     */
    'term'?: string | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof FECompanyQueryCompanyPersonnelListRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof FECompanyQueryCompanyPersonnelListRq
     */
    'pageSize'?: number;
}
/**
 * FE Company Query Company Personnel List Rs Model
 * @export
 * @interface FECompanyQueryCompanyPersonnelListRs
 */
export interface FECompanyQueryCompanyPersonnelListRs {
    /**
     * user uuid
     * @type {string}
     * @memberof FECompanyQueryCompanyPersonnelListRs
     */
    'userUuId'?: string;
    /**
     * user name
     * @type {string}
     * @memberof FECompanyQueryCompanyPersonnelListRs
     */
    'userName'?: string | null;
    /**
     * 圖片網址
     * @type {string}
     * @memberof FECompanyQueryCompanyPersonnelListRs
     */
    'photoUrl'?: string | null;
}
/**
 * Short Url Query Organization Tags Rq Model
 * @export
 * @interface FECompanyQueryOrganizationTagsRq
 */
export interface FECompanyQueryOrganizationTagsRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FECompanyQueryOrganizationTagsRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FECompanyQueryOrganizationTagsRq
     */
    'companyOrganizationUuid'?: string;
}
/**
 * Short Url Query Organization Tags Rs Model
 * @export
 * @interface FECompanyQueryOrganizationTagsRs
 */
export interface FECompanyQueryOrganizationTagsRs {
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FECompanyQueryOrganizationTagsRs
     */
    'orgTagId'?: number;
    /**
     * 標籤 id
     * @type {string}
     * @memberof FECompanyQueryOrganizationTagsRs
     */
    'tagName'?: string | null;
    /**
     * 資料排序
     * @type {number}
     * @memberof FECompanyQueryOrganizationTagsRs
     */
    'order'?: number;
}
/**
 * Short Url Company Rs Model
 * @export
 * @interface FECompanyRs
 */
export interface FECompanyRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof FECompanyRs
     */
    'companyUuid'?: string;
    /**
     * 公司縮圖網址
     * @type {string}
     * @memberof FECompanyRs
     */
    'companyThumbUrl'?: string | null;
    /**
     * 公司名稱
     * @type {string}
     * @memberof FECompanyRs
     */
    'companyName'?: string | null;
    /**
     * 角色名稱
     * @type {string}
     * @memberof FECompanyRs
     */
    'roleName'?: string | null;
}
/**
 * Update Organization Tag Detail Rq Model
 * @export
 * @interface FECompanyUpdateOrganizationTagDetailRq
 */
export interface FECompanyUpdateOrganizationTagDetailRq {
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FECompanyUpdateOrganizationTagDetailRq
     */
    'orgTagId'?: number | null;
    /**
     * 標籤 id
     * @type {string}
     * @memberof FECompanyUpdateOrganizationTagDetailRq
     */
    'tagName'?: string | null;
    /**
     * 資料排序
     * @type {number}
     * @memberof FECompanyUpdateOrganizationTagDetailRq
     */
    'order'?: number;
}
/**
 * FE Url Grouping Append Tag To Urls Rq Model
 * @export
 * @interface FEUrlGroupingAppendTagToUrlGroupRq
 */
export interface FEUrlGroupingAppendTagToUrlGroupRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingAppendTagToUrlGroupRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingAppendTagToUrlGroupRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingAppendTagToUrlGroupRq
     */
    'orgTagId'?: number;
    /**
     * url group id list
     * @type {Array<string>}
     * @memberof FEUrlGroupingAppendTagToUrlGroupRq
     */
    'urlGroupIdList'?: Array<string> | null;
}
/**
 * FE Url Grouping Create Rq Model
 * @export
 * @interface FEUrlGroupingCreateRq
 */
export interface FEUrlGroupingCreateRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'projectName'?: string | null;
    /**
     * 數據標籤
     * @type {number}
     * @memberof FEUrlGroupingCreateRq
     */
    'subtagId'?: number;
    /**
     * 標題
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'description'?: string | null;
    /**
     * 使用 csv file 上傳
     * @type {boolean}
     * @memberof FEUrlGroupingCreateRq
     */
    'useCsvFileUpload'?: boolean;
    /**
     * csv 檔案內容 (base64(
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'csvData'?: string | null;
    /**
     * image url
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'imageUrl'?: string | null;
    /**
     * image base64
     * @type {string}
     * @memberof FEUrlGroupingCreateRq
     */
    'uploadImageBase64'?: string | null;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof FEUrlGroupingCreateRq
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingCreateRq
     */
    'orgTagId'?: number | null;
}
/**
 * FE Url Grouping Delete Rq Model
 * @export
 * @interface FEUrlGroupingDeleteRq
 */
export interface FEUrlGroupingDeleteRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingDeleteRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingDeleteRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingDeleteRq
     */
    'urlGroupId'?: string;
}
/**
 * FE Url Grouping Export Selected Rq Model
 * @export
 * @interface FEUrlGroupingExportSelectedRq
 */
export interface FEUrlGroupingExportSelectedRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingExportSelectedRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingExportSelectedRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 
     * @type {ShortUrlGroupQueryAllSortingFields}
     * @memberof FEUrlGroupingExportSelectedRq
     */
    'sortingField'?: ShortUrlGroupQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof FEUrlGroupingExportSelectedRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * url group id list
     * @type {Array<string>}
     * @memberof FEUrlGroupingExportSelectedRq
     */
    'urlGroupIdList'?: Array<string> | null;
}


/**
 * FE Url Grouping Query All Rq Model
 * @export
 * @interface FEUrlGroupingQueryAllRq
 */
export interface FEUrlGroupingQueryAllRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'term'?: string | null;
    /**
     * 子標籤 id
     * @type {Array<number>}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 
     * @type {ShortUrlGroupQueryAllSortingFields}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'sortingField'?: ShortUrlGroupQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 建立者
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'creatorUserUuid'?: string | null;
    /**
     * 開始日期
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'startDate'?: string | null;
    /**
     * 結束日期
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'endDate'?: string | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'orgTagId'?: number | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof FEUrlGroupingQueryAllRq
     */
    'pageSize'?: number;
}


/**
 * FE Url Grouping Query All Rs Model
 * @export
 * @interface FEUrlGroupingQueryAllRs
 */
export interface FEUrlGroupingQueryAllRs {
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'urlGroupId'?: string;
    /**
     * main tag name
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'mainTagName'?: string | null;
    /**
     * sub tag name
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'subTagName'?: string | null;
    /**
     * project name
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'projectName'?: string | null;
    /**
     * create time
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'createTime'?: string;
    /**
     * creator
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'creator'?: string | null;
    /**
     * photo url
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {ShortLinkProcessStatus}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'processStatusCode'?: ShortLinkProcessStatus;
    /**
     * process status display name
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'processStatusDisplayName'?: string | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'orgTagId'?: number | null;
    /**
     * 錯誤訊息
     * @type {string}
     * @memberof FEUrlGroupingQueryAllRs
     */
    'errorMessage'?: string | null;
}


/**
 * FEUrlGroupingQueryAllSubtotalRq
 * @export
 * @interface FEUrlGroupingQueryAllSubtotalRq
 */
export interface FEUrlGroupingQueryAllSubtotalRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'term'?: string | null;
    /**
     * 子標籤 id
     * @type {Array<number>}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 
     * @type {ShortUrlGroupQueryAllSortingFields}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'sortingField'?: ShortUrlGroupQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 建立者
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'creatorUserUuid'?: string | null;
    /**
     * 開始日期
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'startDate'?: string | null;
    /**
     * 結束日期
     * @type {string}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'endDate'?: string | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingQueryAllSubtotalRq
     */
    'orgTagId'?: number | null;
}


/**
 * FEUrlGroupingQueryAllSubtotalRs
 * @export
 * @interface FEUrlGroupingQueryAllSubtotalRs
 */
export interface FEUrlGroupingQueryAllSubtotalRs {
    /**
     * 總數量
     * @type {number}
     * @memberof FEUrlGroupingQueryAllSubtotalRs
     */
    'totalCount'?: number;
}
/**
 * FE Url Grouping Query Rq Model
 * @export
 * @interface FEUrlGroupingQueryRq
 */
export interface FEUrlGroupingQueryRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingQueryRq
     */
    'urlGroupId'?: string;
}
/**
 * FE Url Grouping Query Rs Model
 * @export
 * @interface FEUrlGroupingQueryRs
 */
export interface FEUrlGroupingQueryRs {
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingQueryRs
     */
    'urlGroupId'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof FEUrlGroupingQueryRs
     */
    'projectName'?: string | null;
    /**
     * 數據標籤
     * @type {number}
     * @memberof FEUrlGroupingQueryRs
     */
    'subtagId'?: number;
    /**
     * 標題
     * @type {string}
     * @memberof FEUrlGroupingQueryRs
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof FEUrlGroupingQueryRs
     */
    'description'?: string | null;
    /**
     * Thumbnail image url
     * @type {string}
     * @memberof FEUrlGroupingQueryRs
     */
    'thumbnailImageUrl'?: string | null;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof FEUrlGroupingQueryRs
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingQueryRs
     */
    'orgTagId'?: number | null;
}
/**
 * FE Url Grouping Query Url List Rq Model
 * @export
 * @interface FEUrlGroupingQueryUrlListRq
 */
export interface FEUrlGroupingQueryUrlListRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'urlGroupId'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListRq
     */
    'pageSize'?: number;
}


/**
 * FE Url Grouping Query Url List Rs Model
 * @export
 * @interface FEUrlGroupingQueryUrlListRs
 */
export interface FEUrlGroupingQueryUrlListRs {
    /**
     * UrlUid
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'urlUid'?: string;
    /**
     * Main Code
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'mainCode'?: string | null;
    /**
     * url code
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'urlCode'?: string | null;
    /**
     * 專案名稱
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'projectName'?: string | null;
    /**
     * 短網址 IP 點擊數
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'shortURLIPClickCount'?: number;
    /**
     * 短網址總點擊次數
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'shortURLTotalClicks'?: number;
    /**
     * 轉換數
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListRs
     */
    'conversions'?: number | null;
}
/**
 * FEUrlGroupingQueryUrlListSubtotalRq
 * @export
 * @interface FEUrlGroupingQueryUrlListSubtotalRq
 */
export interface FEUrlGroupingQueryUrlListSubtotalRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'urlGroupId'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * FEUrlGroupingQueryUrlListSubtotalRs
 * @export
 * @interface FEUrlGroupingQueryUrlListSubtotalRs
 */
export interface FEUrlGroupingQueryUrlListSubtotalRs {
    /**
     * 總數量
     * @type {number}
     * @memberof FEUrlGroupingQueryUrlListSubtotalRs
     */
    'totalCount'?: number;
}
/**
 * FE Url Grouping Remove Tag From Rq Model
 * @export
 * @interface FEUrlGroupingRemoveTagFromUrlGroupRq
 */
export interface FEUrlGroupingRemoveTagFromUrlGroupRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingRemoveTagFromUrlGroupRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingRemoveTagFromUrlGroupRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingRemoveTagFromUrlGroupRq
     */
    'orgTagId'?: number;
    /**
     * url group id list
     * @type {Array<string>}
     * @memberof FEUrlGroupingRemoveTagFromUrlGroupRq
     */
    'urlGroupIdList'?: Array<string> | null;
}
/**
 * FE Url Grouping Single Url Create Rq Model
 * @export
 * @interface FEUrlGroupingSingleUrlCreateRq
 */
export interface FEUrlGroupingSingleUrlCreateRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'urlGroupId'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'projectName'?: string | null;
    /**
     * 原始網址
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'originalUrl'?: string | null;
    /**
     * 跳轉網址 (處理 utm 後的網址)
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'directUrl'?: string | null;
    /**
     * 
     * @type {FEUrlGroupingSingleUrlCreateRqUtm}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'utm'?: FEUrlGroupingSingleUrlCreateRqUtm | null;
    /**
     * 中文標記
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'chineseTag'?: string | null;
    /**
     * 標題
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'description'?: string | null;
    /**
     * image url
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'imageUrl'?: string | null;
    /**
     * image base64
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'uploadImageBase64'?: string | null;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof FEUrlGroupingSingleUrlCreateRq
     */
    'enableTraceTapeId'?: boolean;
}
/**
 * UTM 參數標記
 * @export
 * @interface FEUrlGroupingSingleUrlCreateRqUtm
 */
export interface FEUrlGroupingSingleUrlCreateRqUtm {
    /**
     * Campaign Source
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRqUtm
     */
    'campaignSource'?: string | null;
    /**
     * Campaign Medium
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRqUtm
     */
    'campaignMedium'?: string | null;
    /**
     * Campaign Name
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRqUtm
     */
    'campaignName'?: string | null;
    /**
     * Campaign Term
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRqUtm
     */
    'campaignTerm'?: string | null;
    /**
     * Campaign Content
     * @type {string}
     * @memberof FEUrlGroupingSingleUrlCreateRqUtm
     */
    'campaignContent'?: string | null;
}
/**
 * FE Url Grouping Update Rq Model
 * @export
 * @interface FEUrlGroupingUpdateRq
 */
export interface FEUrlGroupingUpdateRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'urlGroupId'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'projectName'?: string | null;
    /**
     * 標題
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'description'?: string | null;
    /**
     * 使用 csv file 上傳
     * @type {boolean}
     * @memberof FEUrlGroupingUpdateRq
     */
    'useCsvFileUpload'?: boolean;
    /**
     * csv 檔案內容 (base64(
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'csvData'?: string | null;
    /**
     * 有變更 image 設置
     * @type {boolean}
     * @memberof FEUrlGroupingUpdateRq
     */
    'hasUpdateImage'?: boolean;
    /**
     * image url
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'newImageUrl'?: string | null;
    /**
     * image base64
     * @type {string}
     * @memberof FEUrlGroupingUpdateRq
     */
    'newUploadImageBase64'?: string | null;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof FEUrlGroupingUpdateRq
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof FEUrlGroupingUpdateRq
     */
    'orgTagId'?: number | null;
}
/**
 * FE User Profile Get Phone Number Rs Model
 * @export
 * @interface FEUserProfileGetPhoneNumberRs
 */
export interface FEUserProfileGetPhoneNumberRs {
    /**
     * 電話
     * @type {string}
     * @memberof FEUserProfileGetPhoneNumberRs
     */
    'phone'?: string | null;
}
/**
 * FE User Profile Request Email Change Rq Model
 * @export
 * @interface FEUserProfileRequestEmailChangeRq
 */
export interface FEUserProfileRequestEmailChangeRq {
    /**
     * 新電子郵件地址
     * @type {string}
     * @memberof FEUserProfileRequestEmailChangeRq
     */
    'newEmail': string;
    /**
     * 確認新電子郵件地址
     * @type {string}
     * @memberof FEUserProfileRequestEmailChangeRq
     */
    'confirmNewEmail': string;
}
/**
 * FE User Profile Request Email Change Rs Model
 * @export
 * @interface FEUserProfileRequestEmailChangeRs
 */
export interface FEUserProfileRequestEmailChangeRs {
    /**
     * Correlation Id
     * @type {string}
     * @memberof FEUserProfileRequestEmailChangeRs
     */
    'correlationId'?: string;
}
/**
 * FE User Profile Resend Verification Code Rq Model
 * @export
 * @interface FEUserProfileResendVerificationCodeRq
 */
export interface FEUserProfileResendVerificationCodeRq {
    /**
     * Correlation Id
     * @type {string}
     * @memberof FEUserProfileResendVerificationCodeRq
     */
    'correlationId'?: string;
    /**
     * New Email
     * @type {string}
     * @memberof FEUserProfileResendVerificationCodeRq
     */
    'newEmail'?: string | null;
}
/**
 * FE User Profile Resend Verification Code Rs
 * @export
 * @interface FEUserProfileResendVerificationCodeRs
 */
export interface FEUserProfileResendVerificationCodeRs {
    /**
     * Correlation Id
     * @type {string}
     * @memberof FEUserProfileResendVerificationCodeRs
     */
    'correlationId'?: string;
}
/**
 * FE User Profile Update Name Rq Model
 * @export
 * @interface FEUserProfileUpdateNameRq
 */
export interface FEUserProfileUpdateNameRq {
    /**
     * 新 顯示名稱
     * @type {string}
     * @memberof FEUserProfileUpdateNameRq
     */
    'newDisplayName'?: string | null;
}
/**
 * FE User Profile Update Password Rq Model
 * @export
 * @interface FEUserProfileUpdatePasswordRq
 */
export interface FEUserProfileUpdatePasswordRq {
    /**
     * 當前密碼
     * @type {string}
     * @memberof FEUserProfileUpdatePasswordRq
     */
    'currentPassword': string;
    /**
     * 新密碼
     * @type {string}
     * @memberof FEUserProfileUpdatePasswordRq
     */
    'newPassword': string;
    /**
     * 確認新密碼
     * @type {string}
     * @memberof FEUserProfileUpdatePasswordRq
     */
    'confirmNewPassword': string;
}
/**
 * FE User Profile Update Password Rs
 * @export
 * @interface FEUserProfileUpdatePasswordRs
 */
export interface FEUserProfileUpdatePasswordRs {
    /**
     * 執行狀態
     * @type {boolean}
     * @memberof FEUserProfileUpdatePasswordRs
     */
    'status'?: boolean;
    /**
     * 訊息
     * @type {string}
     * @memberof FEUserProfileUpdatePasswordRs
     */
    'message'?: string | null;
}
/**
 * FE User Profile Update Phone Number Rq Model
 * @export
 * @interface FEUserProfileUpdatePhoneNumberRq
 */
export interface FEUserProfileUpdatePhoneNumberRq {
    /**
     * 新 PhoneNumber
     * @type {string}
     * @memberof FEUserProfileUpdatePhoneNumberRq
     */
    'newPhoneNumber'?: string | null;
}
/**
 * FE User Profile Verify Email Change Rq Model
 * @export
 * @interface FEUserProfileVerifyEmailChangeRq
 */
export interface FEUserProfileVerifyEmailChangeRq {
    /**
     * Correlation Id
     * @type {string}
     * @memberof FEUserProfileVerifyEmailChangeRq
     */
    'correlationId'?: string;
    /**
     * New Email
     * @type {string}
     * @memberof FEUserProfileVerifyEmailChangeRq
     */
    'newEmail'?: string | null;
    /**
     * Verification Code
     * @type {string}
     * @memberof FEUserProfileVerifyEmailChangeRq
     */
    'verificationCode'?: string | null;
}
/**
 * FE User Profile Verify Email Change Rs Model
 * @export
 * @interface FEUserProfileVerifyEmailChangeRs
 */
export interface FEUserProfileVerifyEmailChangeRs {
    /**
     * 執行狀態
     * @type {boolean}
     * @memberof FEUserProfileVerifyEmailChangeRs
     */
    'status'?: boolean;
    /**
     * 訊息
     * @type {string}
     * @memberof FEUserProfileVerifyEmailChangeRs
     */
    'message'?: string | null;
}
/**
 * Ga Data Update Rq Model
 * @export
 * @interface GaDataUpdateRq
 */
export interface GaDataUpdateRq {
    /**
     * 查詢日期 D-N, D=Today
     * @type {number}
     * @memberof GaDataUpdateRq
     */
    'dateSubtract'?: number;
}
/**
 * 帳戶資訊 for 查詢
 * @export
 * @interface IdentityInfoModel
 */
export interface IdentityInfoModel {
    /**
     * 使用者 id
     * @type {string}
     * @memberof IdentityInfoModel
     */
    'userUuid'?: string | null;
    /**
     * 使用者姓名
     * @type {string}
     * @memberof IdentityInfoModel
     */
    'userName'?: string | null;
    /**
     * 使用者 email
     * @type {string}
     * @memberof IdentityInfoModel
     */
    'email'?: string | null;
    /**
     * 照片連結
     * @type {string}
     * @memberof IdentityInfoModel
     */
    'photoUrl'?: string | null;
}
/**
 * Identity Picker Type 類型  0 = None (None)  1 = CompanyContact (公司業務)  2 = CompanyOwner (公司負責人)  3 = CompanyOperator (公司操作者)  4 = Guest (一般用戶)
 * @export
 * @enum {string}
 */

export const IdentityPickerType = {
    /**
    * None
    */
    None: 0,
    /**
    * 公司業務
    */
    CompanyContact: 1,
    /**
    * 公司負責人
    */
    CompanyOwner: 2,
    /**
    * 公司操作者
    */
    CompanyOperator: 3,
    /**
    * 一般用戶
    */
    Guest: 4
} as const;

export type IdentityPickerType = typeof IdentityPickerType[keyof typeof IdentityPickerType];


/**
 * Main Tag Delete Rq Model
 * @export
 * @interface MainTagDeleteRq
 */
export interface MainTagDeleteRq {
    /**
     * 主標籤 id 列表
     * @type {Array<number>}
     * @memberof MainTagDeleteRq
     */
    'mainTagIdList'?: Array<number> | null;
}
/**
 * 主標籤 update model
 * @export
 * @interface MainTagUpdateRq
 */
export interface MainTagUpdateRq {
    /**
     * MainTagId (update 為必填)
     * @type {number}
     * @memberof MainTagUpdateRq
     */
    'mainTagId'?: number | null;
    /**
     * 主標籤名稱
     * @type {string}
     * @memberof MainTagUpdateRq
     */
    'mainTagName'?: string | null;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof MainTagUpdateRq
     */
    'mainTagCode'?: string | null;
    /**
     * 是否為客製標籤
     * @type {boolean}
     * @memberof MainTagUpdateRq
     */
    'isCustom'?: boolean;
    /**
     * 子標籤清單
     * @type {Array<SubTagUpdateRq>}
     * @memberof MainTagUpdateRq
     */
    'subs'?: Array<SubTagUpdateRq> | null;
}
/**
 * Option Company Org Rs Model
 * @export
 * @interface OptionCompanyOrgRs
 */
export interface OptionCompanyOrgRs {
    /**
     * 公司組織公開 id
     * @type {string}
     * @memberof OptionCompanyOrgRs
     */
    'companyOrganizationUuid'?: string;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof OptionCompanyOrgRs
     */
    'companyOrganizationName'?: string | null;
}
/**
 * Option Company Rs Model
 * @export
 * @interface OptionCompanyRs
 */
export interface OptionCompanyRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof OptionCompanyRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof OptionCompanyRs
     */
    'companyName'?: string | null;
}
/**
 * 選單 model
 * @export
 * @interface OptionModel
 */
export interface OptionModel {
    /**
     * value
     * @type {number}
     * @memberof OptionModel
     */
    'value'?: number;
    /**
     * text
     * @type {string}
     * @memberof OptionModel
     */
    'text'?: string | null;
}
/**
 * Option Sub Tag Rs Model
 * @export
 * @interface OptionSubTagRs
 */
export interface OptionSubTagRs {
    /**
     * 子標籤 id
     * @type {number}
     * @memberof OptionSubTagRs
     */
    'subTagId'?: number;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof OptionSubTagRs
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof OptionSubTagRs
     */
    'subTagNo'?: string | null;
}
/**
 * Oraanization Info Rs Model
 * @export
 * @interface OraanizationInfoRs
 */
export interface OraanizationInfoRs {
    /**
     * 公司組織 id
     * @type {string}
     * @memberof OraanizationInfoRs
     */
    'companyOrganizationUuid'?: string;
    /**
     * 公司 id
     * @type {string}
     * @memberof OraanizationInfoRs
     */
    'companyUuid'?: string;
    /**
     * 主標籤 id
     * @type {number}
     * @memberof OraanizationInfoRs
     */
    'mainTagId'?: number;
    /**
     * 子標籤 id list
     * @type {Array<number>}
     * @memberof OraanizationInfoRs
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof OraanizationInfoRs
     */
    'companyOrganizationName'?: string | null;
    /**
     * 公司網域 id
     * @type {number}
     * @memberof OraanizationInfoRs
     */
    'companyDomainId'?: number | null;
    /**
     * GTM
     * @type {Array<string>}
     * @memberof OraanizationInfoRs
     */
    'gtmList'?: Array<string> | null;
    /**
     * 專案 ID
     * @type {string}
     * @memberof OraanizationInfoRs
     */
    'projectId'?: string | null;
}
/**
 * Organization Delete Member Rq Model
 * @export
 * @interface OrganizationDeleteMemberRq
 */
export interface OrganizationDeleteMemberRq {
    /**
     * company uuid
     * @type {string}
     * @memberof OrganizationDeleteMemberRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof OrganizationDeleteMemberRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * user uuid
     * @type {string}
     * @memberof OrganizationDeleteMemberRq
     */
    'userUuid'?: string;
}
/**
 * 公司組織 刪除 rq model
 * @export
 * @interface OrganizationDeleteRq
 */
export interface OrganizationDeleteRq {
    /**
     * 公司組織 id
     * @type {Array<string>}
     * @memberof OrganizationDeleteRq
     */
    'companyOrganizationUuidList'?: Array<string> | null;
}
/**
 * Organization Export All Rq Model
 * @export
 * @interface OrganizationExportAllRq
 */
export interface OrganizationExportAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof OrganizationExportAllRq
     */
    'term'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof OrganizationExportAllRq
     */
    'companyUuid'?: string | null;
}
/**
 * Organization Export Selected Rq Model
 * @export
 * @interface OrganizationExportSelectedRq
 */
export interface OrganizationExportSelectedRq {
    /**
     * company uuids
     * @type {Array<string>}
     * @memberof OrganizationExportSelectedRq
     */
    'companyUuids'?: Array<string> | null;
}
/**
 * Organization Get Company Domain Option Rs Model
 * @export
 * @interface OrganizationGetCompanyDomainOptionRs
 */
export interface OrganizationGetCompanyDomainOptionRs {
    /**
     * domain id
     * @type {number}
     * @memberof OrganizationGetCompanyDomainOptionRs
     */
    'companyDomainId'?: number;
    /**
     * domain name
     * @type {string}
     * @memberof OrganizationGetCompanyDomainOptionRs
     */
    'customDomain'?: string | null;
}
/**
 * 組織成員角色  0 = None (None)  1 = Leader (組長)  2 = Member (組員)
 * @export
 * @enum {string}
 */

export const OrganizationMemberRole = {
    /**
    * None
    */
    None: 0,
    /**
    * 組長
    */
    Leader: 1,
    /**
    * 組員
    */
    Member: 2
} as const;

export type OrganizationMemberRole = typeof OrganizationMemberRole[keyof typeof OrganizationMemberRole];


/**
 * Organization QueryAll Rq Model
 * @export
 * @interface OrganizationQueryAllRq
 */
export interface OrganizationQueryAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof OrganizationQueryAllRq
     */
    'term'?: string | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof OrganizationQueryAllRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof OrganizationQueryAllRq
     */
    'pageSize'?: number;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof OrganizationQueryAllRq
     */
    'companyUuid'?: string | null;
}
/**
 * 公司組織查詢
 * @export
 * @interface OrganizationQueryAllRs
 */
export interface OrganizationQueryAllRs {
    /**
     * 公司公開id
     * @type {string}
     * @memberof OrganizationQueryAllRs
     */
    'companyUuid'?: string | null;
    /**
     * 公司名稱
     * @type {string}
     * @memberof OrganizationQueryAllRs
     */
    'companyName'?: string | null;
    /**
     * 建立組織筆數
     * @type {number}
     * @memberof OrganizationQueryAllRs
     */
    'organizationCount'?: number;
    /**
     * 組織可建立上限
     * @type {number}
     * @memberof OrganizationQueryAllRs
     */
    'organizationLimit'?: number;
    /**
     * 已建立短網址數量(加總)
     * @type {number}
     * @memberof OrganizationQueryAllRs
     */
    'totalOrganizationUrlCount'?: number;
    /**
     * 公司人員數量 (包含組織)
     * @type {number}
     * @memberof OrganizationQueryAllRs
     */
    'totalMemberCount'?: number;
}
/**
 * 公司組織查詢 - 明細
 * @export
 * @interface OrganizationQueryDetailRs
 */
export interface OrganizationQueryDetailRs {
    /**
     * 公司組織公開 id
     * @type {string}
     * @memberof OrganizationQueryDetailRs
     */
    'companyOrganizationUuid'?: string | null;
    /**
     * 公司公開 id
     * @type {string}
     * @memberof OrganizationQueryDetailRs
     */
    'companyUuid'?: string | null;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof OrganizationQueryDetailRs
     */
    'companyOrganizationName'?: string | null;
    /**
     * 自訂網域
     * @type {string}
     * @memberof OrganizationQueryDetailRs
     */
    'customDomain'?: string | null;
    /**
     * 主標籤 id
     * @type {number}
     * @memberof OrganizationQueryDetailRs
     */
    'mainTagId'?: number;
    /**
     * 是否為自定義標籤
     * @type {boolean}
     * @memberof OrganizationQueryDetailRs
     */
    'isCustom'?: boolean;
    /**
     * 主標籤名稱
     * @type {string}
     * @memberof OrganizationQueryDetailRs
     */
    'mainTagName'?: string | null;
    /**
     * 公司已建立短網址數量
     * @type {number}
     * @memberof OrganizationQueryDetailRs
     */
    'organizationUrlCount'?: number;
    /**
     * 組織成員人數
     * @type {number}
     * @memberof OrganizationQueryDetailRs
     */
    'organizationMemberCount'?: number;
}
/**
 * GCP 專案資訊
 * @export
 * @interface OrganizationQueryGAProjectsRs
 */
export interface OrganizationQueryGAProjectsRs {
    /**
     * 專案名稱
     * @type {string}
     * @memberof OrganizationQueryGAProjectsRs
     */
    'projectName'?: string | null;
    /**
     * 專案 ID
     * @type {string}
     * @memberof OrganizationQueryGAProjectsRs
     */
    'projectId'?: string | null;
}
/**
 * Organization Query Members Rq Model
 * @export
 * @interface OrganizationQueryMembersRq
 */
export interface OrganizationQueryMembersRq {
    /**
     * company uuid
     * @type {string}
     * @memberof OrganizationQueryMembersRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof OrganizationQueryMembersRq
     */
    'companyOrganizationUuid'?: string;
}
/**
 * Organization Query Members Rs Model
 * @export
 * @interface OrganizationQueryMembersRs
 */
export interface OrganizationQueryMembersRs {
    /**
     * public id
     * @type {string}
     * @memberof OrganizationQueryMembersRs
     */
    'userUuid'?: string;
    /**
     * user name
     * @type {string}
     * @memberof OrganizationQueryMembersRs
     */
    'userName'?: string | null;
    /**
     * Email
     * @type {string}
     * @memberof OrganizationQueryMembersRs
     */
    'email'?: string | null;
    /**
     * photo url
     * @type {string}
     * @memberof OrganizationQueryMembersRs
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof OrganizationQueryMembersRs
     */
    'userStatusCode'?: UserStatus;
    /**
     * 
     * @type {OrganizationMemberRole}
     * @memberof OrganizationQueryMembersRs
     */
    'memberRoleCode'?: OrganizationMemberRole;
}


/**
 * Organization QuerySubtotal Rq Model
 * @export
 * @interface OrganizationQuerySubtotalRq
 */
export interface OrganizationQuerySubtotalRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof OrganizationQuerySubtotalRq
     */
    'term'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof OrganizationQuerySubtotalRq
     */
    'companyUuid'?: string | null;
}
/**
 * Organization Query Subtotal Rs Model
 * @export
 * @interface OrganizationQuerySubtotalRs
 */
export interface OrganizationQuerySubtotalRs {
    /**
     * 公司總數
     * @type {number}
     * @memberof OrganizationQuerySubtotalRs
     */
    'companyTotalCount'?: number;
    /**
     * 公司組織總數量
     * @type {number}
     * @memberof OrganizationQuerySubtotalRs
     */
    'companyOrganizationTotalCount'?: number;
}
/**
 * Organization Send Registration Invitation Rq Model
 * @export
 * @interface OrganizationSendRegistrationInvitationRq
 */
export interface OrganizationSendRegistrationInvitationRq {
    /**
     * company uuid
     * @type {string}
     * @memberof OrganizationSendRegistrationInvitationRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof OrganizationSendRegistrationInvitationRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * org members
     * @type {Array<OrganizationSendRegistrationInvitationUserRq>}
     * @memberof OrganizationSendRegistrationInvitationRq
     */
    'orgMembers'?: Array<OrganizationSendRegistrationInvitationUserRq> | null;
}
/**
 * Organization Send Registration Invitation User Rq Model
 * @export
 * @interface OrganizationSendRegistrationInvitationUserRq
 */
export interface OrganizationSendRegistrationInvitationUserRq {
    /**
     * user uuid
     * @type {string}
     * @memberof OrganizationSendRegistrationInvitationUserRq
     */
    'userUuid'?: string | null;
    /**
     * user email
     * @type {string}
     * @memberof OrganizationSendRegistrationInvitationUserRq
     */
    'email'?: string | null;
}
/**
 * Organization Update Member Permission Rq Model
 * @export
 * @interface OrganizationUpdateMemberPermissionRq
 */
export interface OrganizationUpdateMemberPermissionRq {
    /**
     * company uuid
     * @type {string}
     * @memberof OrganizationUpdateMemberPermissionRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof OrganizationUpdateMemberPermissionRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * user uuid
     * @type {string}
     * @memberof OrganizationUpdateMemberPermissionRq
     */
    'userUuid'?: string;
    /**
     * 
     * @type {OrganizationMemberRole}
     * @memberof OrganizationUpdateMemberPermissionRq
     */
    'memberRoleCode'?: OrganizationMemberRole;
}


/**
 * 公司組織 更新 req model
 * @export
 * @interface OrganizationUpdateRq
 */
export interface OrganizationUpdateRq {
    /**
     * 公司組織 id
     * @type {string}
     * @memberof OrganizationUpdateRq
     */
    'companyOrganizationUuid'?: string | null;
    /**
     * 公司 id
     * @type {string}
     * @memberof OrganizationUpdateRq
     */
    'companyUuid'?: string;
    /**
     * 主標籤 id
     * @type {number}
     * @memberof OrganizationUpdateRq
     */
    'mainTagId'?: number;
    /**
     * 子標籤 id list
     * @type {Array<number>}
     * @memberof OrganizationUpdateRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof OrganizationUpdateRq
     */
    'companyOrganizationName'?: string | null;
    /**
     * 公司 domain id
     * @type {number}
     * @memberof OrganizationUpdateRq
     */
    'companyDomainId'?: number | null;
    /**
     * GTM
     * @type {Array<string>}
     * @memberof OrganizationUpdateRq
     */
    'gtmList'?: Array<string> | null;
    /**
     * 專案 ID
     * @type {string}
     * @memberof OrganizationUpdateRq
     */
    'projectId'?: string | null;
}
/**
 * Organization Update Rs Model
 * @export
 * @interface OrganizationUpdateRs
 */
export interface OrganizationUpdateRs {
    /**
     * 公司組織 id
     * @type {string}
     * @memberof OrganizationUpdateRs
     */
    'companyOrganizationUuid'?: string;
}
/**
 * CommonCodeTypes  0 = None (None)  1 = CompanySubscriptionType (公司訂閱類型)  2 = CompanyStatus (公司狀態)  3 = CompanyDataInputType (公司資料輸入類別)  4 = UserStatus (使用者狀態)  5 = DataStatus (資料狀態)  6 = OrganizationMemberRole (組織成員角色)  7 = ShortLinkProcessStatus (短網址處理狀態)  8 = UserChangePasswordProcess (使用者密碼變更進程)  9 = AuthProvider (單一登入類型)  11 = PaymentCycles (計價區間)  12 = DomainStatus (Domain 狀態)  13 = UrlType (網址類別)
 * @export
 * @enum {string}
 */

export const PROMCodeTypes = {
    /**
    * None
    */
    None: 0,
    /**
    * 公司訂閱類型
    */
    CompanySubscriptionType: 1,
    /**
    * 公司狀態
    */
    CompanyStatus: 2,
    /**
    * 公司資料輸入類別
    */
    CompanyDataInputType: 3,
    /**
    * 使用者狀態
    */
    UserStatus: 4,
    /**
    * 資料狀態
    */
    DataStatus: 5,
    /**
    * 組織成員角色
    */
    OrganizationMemberRole: 6,
    /**
    * 短網址處理狀態
    */
    ShortLinkProcessStatus: 7,
    /**
    * 使用者密碼變更進程
    */
    UserChangePasswordProcess: 8,
    /**
    * 單一登入類型
    */
    AuthProvider: 9,
    /**
    * 計價區間
    */
    PaymentCycles: 11,
    /**
    * Domain 狀態
    */
    DomainStatus: 12,
    /**
    * 網址類別
    */
    UrlType: 13
} as const;

export type PROMCodeTypes = typeof PROMCodeTypes[keyof typeof PROMCodeTypes];


/**
 * PROMFeatures  0 = None (None)  1 = OrganizationCount (組織數量)  2 = CollaborativeAccount (協作帳號)  3 = CustomTag (自定義標籤)  4 = ShortUrlLimit (短網址數量上限)  5 = BatchShortUrlCreation (批次建立 AND A / B Test)  6 = ClickProfileAnalysis (點擊輪廓分析)  7 = GtmDataIntegration (GTM 數據串接)  8 = CustomPreviewThumbnail (自訂預覽縮圖)  9 = TagProfileAnalysis (標籤輪廓分析)  10 = SslCertificate (SSL 加密憑證)  11 = DedicatedDomainRequest (專屬域名設定)  12 = DataTagStatistics (數據標籤統計)  13 = Pricing (定價)  14 = QrCodeDownload (QR Code下載)  15 = IndustryProfileAnalysis (產業輪廓分析)  16 = ChineseTagging (中文標記)  17 = CreateCopy (新建短網址副本)  18 = ReportExport (報表匯出)  19 = ChartDownload (圖表下載)  20 = OrganizationTagDataComparison (組織標籤數據比較(作廢))  21 = UrlCategoryLabel (分類標記)  22 = CRMModule (CRM 數據導入)  23 = DataOverlapAnalysis (數據重疊度分析)  24 = TeamCollaborationInterface (協作介面)
 * @export
 * @enum {string}
 */

export const PROMFeatures = {
    /**
    * None
    */
    None: 0,
    /**
    * 組織數量
    */
    OrganizationCount: 1,
    /**
    * 協作帳號
    */
    CollaborativeAccount: 2,
    /**
    * 自定義標籤
    */
    CustomTag: 3,
    /**
    * 短網址數量上限
    */
    ShortUrlLimit: 4,
    /**
    * 批次建立 AND A / B Test
    */
    BatchShortUrlCreation: 5,
    /**
    * 點擊輪廓分析
    */
    ClickProfileAnalysis: 6,
    /**
    * GTM 數據串接
    */
    GtmDataIntegration: 7,
    /**
    * 自訂預覽縮圖
    */
    CustomPreviewThumbnail: 8,
    /**
    * 標籤輪廓分析
    */
    TagProfileAnalysis: 9,
    /**
    * SSL 加密憑證
    */
    SslCertificate: 10,
    /**
    * 專屬域名設定
    */
    DedicatedDomainRequest: 11,
    /**
    * 數據標籤統計
    */
    DataTagStatistics: 12,
    /**
    * 定價
    */
    Pricing: 13,
    /**
    * QR Code下載
    */
    QrCodeDownload: 14,
    /**
    * 產業輪廓分析
    */
    IndustryProfileAnalysis: 15,
    /**
    * 中文標記
    */
    ChineseTagging: 16,
    /**
    * 新建短網址副本
    */
    CreateCopy: 17,
    /**
    * 報表匯出
    */
    ReportExport: 18,
    /**
    * 圖表下載
    */
    ChartDownload: 19,
    /**
    * 組織標籤數據比較(作廢)
    */
    OrganizationTagDataComparison: 20,
    /**
    * 分類標記
    */
    UrlCategoryLabel: 21,
    /**
    * CRM 數據導入
    */
    CRMModule: 22,
    /**
    * 數據重疊度分析
    */
    DataOverlapAnalysis: 23,
    /**
    * 協作介面
    */
    TeamCollaborationInterface: 24
} as const;

export type PROMFeatures = typeof PROMFeatures[keyof typeof PROMFeatures];


/**
 * 預計算資料時間
 * @export
 * @interface PrecomputedDataTimestampRs
 */
export interface PrecomputedDataTimestampRs {
    /**
     * 點擊次數更新時間
     * @type {string}
     * @memberof PrecomputedDataTimestampRs
     */
    'clickCountUpdatedAt'?: string;
}
/**
 * Profile Add Domain Rq Model
 * @export
 * @interface ProfileAddDomainRq
 */
export interface ProfileAddDomainRq {
    /**
     * company uuid
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'companyUuid'?: string;
    /**
     * domain name
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'customDomain': string;
    /**
     * domain 首頁
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'domainHomePage': string;
    /**
     * 到期日
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'expiryDate'?: string | null;
    /**
     * 購買時間
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'purchaseTime'?: string | null;
    /**
     * 購買金額
     * @type {number}
     * @memberof ProfileAddDomainRq
     */
    'purchaseAmount'?: number | null;
    /**
     * 備註
     * @type {string}
     * @memberof ProfileAddDomainRq
     */
    'notes'?: string | null;
}
/**
 * 公司 停用 update model
 * @export
 * @interface ProfileDisableRq
 */
export interface ProfileDisableRq {
    /**
     * company uuid
     * @type {Array<string>}
     * @memberof ProfileDisableRq
     */
    'companyUuidList'?: Array<string> | null;
}
/**
 * 公司 啟用 update model
 * @export
 * @interface ProfileEnableRq
 */
export interface ProfileEnableRq {
    /**
     * company id
     * @type {string}
     * @memberof ProfileEnableRq
     */
    'companyUuid'?: string;
}
/**
 * Profile Export All Rq Model
 * @export
 * @interface ProfileExportAllRq
 */
export interface ProfileExportAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof ProfileExportAllRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {CompanyQueryType}
     * @memberof ProfileExportAllRq
     */
    'queryType'?: CompanyQueryType | null;
    /**
     * 回傳欄位
     * @type {Array<CompanyQueryFields>}
     * @memberof ProfileExportAllRq
     */
    'fields'?: Array<CompanyQueryFields> | null;
    /**
     * 
     * @type {CompanyQuerySortingFields}
     * @memberof ProfileExportAllRq
     */
    'sortingField'?: CompanyQuerySortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ProfileExportAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * Profile Export Selected Rq
 * @export
 * @interface ProfileExportSelectedRq
 */
export interface ProfileExportSelectedRq {
    /**
     * company uuids
     * @type {Array<string>}
     * @memberof ProfileExportSelectedRq
     */
    'companyUuids'?: Array<string> | null;
    /**
     * 回傳欄位
     * @type {Array<CompanyQueryFields>}
     * @memberof ProfileExportSelectedRq
     */
    'fields'?: Array<CompanyQueryFields> | null;
    /**
     * 
     * @type {CompanyQuerySortingFields}
     * @memberof ProfileExportSelectedRq
     */
    'sortingField'?: CompanyQuerySortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ProfileExportSelectedRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * ProfileInfo Rs
 * @export
 * @interface ProfileInfoRs
 */
export interface ProfileInfoRs {
    /**
     * 公司 id
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'companyUuid'?: string | null;
    /**
     * 公司名稱
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'companyName'?: string | null;
    /**
     * 統一編號
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {CompanySubscriptionType}
     * @memberof ProfileInfoRs
     */
    'subscription'?: CompanySubscriptionType;
    /**
     * 訂閱啟用日
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'subscriptionActivationDate'?: string;
    /**
     * 訂閱到期日
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'subscriptionExpirationDate'?: string;
    /**
     * 
     * @type {CompanySubscriptionType}
     * @memberof ProfileInfoRs
     */
    'presetSubscription'?: CompanySubscriptionType;
    /**
     * 預設 - 訂閱啟用日
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'presetSubscriptionActivationDate'?: string | null;
    /**
     * 預設 - 訂閱到期日
     * @type {string}
     * @memberof ProfileInfoRs
     */
    'presetSubscriptionExpirationDate'?: string | null;
    /**
     * 公司擁有者 email
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileInfoRs
     */
    'ownerItems'?: Array<ProfileQueryAllUserRs> | null;
    /**
     * 負責業務
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileInfoRs
     */
    'contactItems'?: Array<ProfileQueryAllUserRs> | null;
    /**
     * 公司執行人員
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileInfoRs
     */
    'operatorItems'?: Array<ProfileQueryAllUserRs> | null;
}


/**
 * ProfileQueryAll Rq Model
 * @export
 * @interface ProfileQueryAllRq
 */
export interface ProfileQueryAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof ProfileQueryAllRq
     */
    'term'?: string | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof ProfileQueryAllRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof ProfileQueryAllRq
     */
    'pageSize'?: number;
    /**
     * 
     * @type {CompanyQueryType}
     * @memberof ProfileQueryAllRq
     */
    'queryType'?: CompanyQueryType | null;
    /**
     * 回傳欄位
     * @type {Array<CompanyQueryFields>}
     * @memberof ProfileQueryAllRq
     */
    'fields'?: Array<CompanyQueryFields> | null;
    /**
     * 
     * @type {CompanyQuerySortingFields}
     * @memberof ProfileQueryAllRq
     */
    'sortingField'?: CompanyQuerySortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ProfileQueryAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * rs model
 * @export
 * @interface ProfileQueryAllRs
 */
export interface ProfileQueryAllRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'companyUuid'?: string | null;
    /**
     * 公司名稱
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'companyName'?: string | null;
    /**
     * 訂閱方案
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'subscriptionDisplayName'?: string | null;
    /**
     * 公司狀態 (display name)
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'companyStatusDisplayName'?: string | null;
    /**
     * 
     * @type {CompanyStatus}
     * @memberof ProfileQueryAllRs
     */
    'companyStatusCode'?: CompanyStatus | null;
    /**
     * 資料輸入方式
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'dataInputType'?: string | null;
    /**
     * 統一編號
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'vatNumber'?: string | null;
    /**
     * 公司啟用
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'subscriptionActivationDate'?: string | null;
    /**
     * 到期日
     * @type {string}
     * @memberof ProfileQueryAllRs
     */
    'subscriptionExpirationDate'?: string | null;
    /**
     * 建立組織
     * @type {Array<string>}
     * @memberof ProfileQueryAllRs
     */
    'organizations'?: Array<string> | null;
    /**
     * 組織可建立上限
     * @type {number}
     * @memberof ProfileQueryAllRs
     */
    'organizationLimit'?: number;
    /**
     * 負責業務
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileQueryAllRs
     */
    'contactItems'?: Array<ProfileQueryAllUserRs> | null;
    /**
     * 公司擁有者
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileQueryAllRs
     */
    'ownerItems'?: Array<ProfileQueryAllUserRs> | null;
    /**
     * 公司執行人員
     * @type {Array<ProfileQueryAllUserRs>}
     * @memberof ProfileQueryAllRs
     */
    'operatorItems'?: Array<ProfileQueryAllUserRs> | null;
}


/**
 * ProfileQueryAllUser Rs model
 * @export
 * @interface ProfileQueryAllUserRs
 */
export interface ProfileQueryAllUserRs {
    /**
     * user 識別碼
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'userUuid'?: string;
    /**
     * 使用者名稱
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'userName'?: string | null;
    /**
     * Email
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'email'?: string | null;
    /**
     * 電話
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'phone'?: string | null;
    /**
     * 照片連結
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'photoUrl'?: string | null;
    /**
     * 使用者狀態
     * @type {string}
     * @memberof ProfileQueryAllUserRs
     */
    'userStatusDisplayName'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof ProfileQueryAllUserRs
     */
    'userStatusCode'?: UserStatus;
}


/**
 * ProfileQueryDomainDetailRq
 * @export
 * @interface ProfileQueryDomainDetailRq
 */
export interface ProfileQueryDomainDetailRq {
    /**
     * company uuid
     * @type {string}
     * @memberof ProfileQueryDomainDetailRq
     */
    'companyUuid'?: string;
    /**
     * domain id
     * @type {number}
     * @memberof ProfileQueryDomainDetailRq
     */
    'domainId'?: number;
}
/**
 * ProfileQueryDomainDetailRs
 * @export
 * @interface ProfileQueryDomainDetailRs
 */
export interface ProfileQueryDomainDetailRs {
    /**
     * company uuid
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'companyUuid'?: string;
    /**
     * domain id
     * @type {number}
     * @memberof ProfileQueryDomainDetailRs
     */
    'domainId'?: number;
    /**
     * domain name
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'customDomain'?: string | null;
    /**
     * domain 首頁
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'domainHomePage'?: string | null;
    /**
     * 到期日
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'expiryDate'?: string | null;
    /**
     * 購買時間
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'purchaseTime'?: string | null;
    /**
     * 購買金額
     * @type {number}
     * @memberof ProfileQueryDomainDetailRs
     */
    'purchaseAmount'?: number | null;
    /**
     * 備註
     * @type {string}
     * @memberof ProfileQueryDomainDetailRs
     */
    'notes'?: string | null;
}
/**
 * Profile Query Domain Rs Model
 * @export
 * @interface ProfileQueryDomainRs
 */
export interface ProfileQueryDomainRs {
    /**
     * domain id
     * @type {number}
     * @memberof ProfileQueryDomainRs
     */
    'domainId'?: number;
    /**
     * domain name
     * @type {string}
     * @memberof ProfileQueryDomainRs
     */
    'customDomain'?: string | null;
    /**
     * domain 首頁
     * @type {string}
     * @memberof ProfileQueryDomainRs
     */
    'domainHomePage'?: string | null;
    /**
     * 
     * @type {DomainStatus}
     * @memberof ProfileQueryDomainRs
     */
    'status'?: DomainStatus;
    /**
     * 到期日
     * @type {string}
     * @memberof ProfileQueryDomainRs
     */
    'expiryDate'?: string | null;
}


/**
 * 公司 - 小計 查詢
 * @export
 * @interface ProfileQuerySubtotalRq
 */
export interface ProfileQuerySubtotalRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof ProfileQuerySubtotalRq
     */
    'term'?: string | null;
}
/**
 * 公司列表查詢小計
 * @export
 * @interface ProfileQuerySubtotalRs
 */
export interface ProfileQuerySubtotalRs {
    /**
     * 公司總數量
     * @type {number}
     * @memberof ProfileQuerySubtotalRs
     */
    'totalCount'?: number;
    /**
     * 使用中數量
     * @type {number}
     * @memberof ProfileQuerySubtotalRs
     */
    'activeCount'?: number;
    /**
     * 將到期數量
     * @type {number}
     * @memberof ProfileQuerySubtotalRs
     */
    'expiringSoonCount'?: number;
    /**
     * 停用數量
     * @type {number}
     * @memberof ProfileQuerySubtotalRs
     */
    'disabledCount'?: number;
}
/**
 * Profile Remove Domain Rq Model
 * @export
 * @interface ProfileRemoveDomainRq
 */
export interface ProfileRemoveDomainRq {
    /**
     * company uuid
     * @type {string}
     * @memberof ProfileRemoveDomainRq
     */
    'companyUuid'?: string;
    /**
     * domain id
     * @type {number}
     * @memberof ProfileRemoveDomainRq
     */
    'domainId'?: number;
}
/**
 * Profile Update Domain Rq Model
 * @export
 * @interface ProfileUpdateDomainRq
 */
export interface ProfileUpdateDomainRq {
    /**
     * company uuid
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'companyUuid'?: string;
    /**
     * domain id
     * @type {number}
     * @memberof ProfileUpdateDomainRq
     */
    'domainId'?: number;
    /**
     * domain name
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'customDomain': string;
    /**
     * domain 首頁
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'domainHomePage': string;
    /**
     * 到期日
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'expiryDate'?: string | null;
    /**
     * 購買時間
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'purchaseTime'?: string | null;
    /**
     * 購買金額
     * @type {number}
     * @memberof ProfileUpdateDomainRq
     */
    'purchaseAmount'?: number | null;
    /**
     * 備註
     * @type {string}
     * @memberof ProfileUpdateDomainRq
     */
    'notes'?: string | null;
}
/**
 * 公司資料更新 model
 * @export
 * @interface ProfileUpdateRq
 */
export interface ProfileUpdateRq {
    /**
     * 公司 id
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'companyUuid'?: string | null;
    /**
     * 公司名稱
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'companyName': string;
    /**
     * 統一編號
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'vatNumber': string;
    /**
     * 
     * @type {CompanySubscriptionType}
     * @memberof ProfileUpdateRq
     */
    'subscription': CompanySubscriptionType;
    /**
     * 訂閱啟用日
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'subscriptionActivationDate': string;
    /**
     * 訂閱到期日
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'subscriptionExpirationDate': string;
    /**
     * 
     * @type {CompanySubscriptionType}
     * @memberof ProfileUpdateRq
     */
    'presetSubscription'?: CompanySubscriptionType;
    /**
     * 預設 - 訂閱啟用日
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'presetSubscriptionActivationDate'?: string | null;
    /**
     * 預設 - 訂閱到期日
     * @type {string}
     * @memberof ProfileUpdateRq
     */
    'presetSubscriptionExpirationDate'?: string | null;
    /**
     * 公司擁有者 email
     * @type {Array<ProfileUpdateUserRq>}
     * @memberof ProfileUpdateRq
     */
    'ownerList': Array<ProfileUpdateUserRq>;
    /**
     * 負責業務
     * @type {Array<ProfileUpdateUserRq>}
     * @memberof ProfileUpdateRq
     */
    'contactList': Array<ProfileUpdateUserRq>;
    /**
     * 公司執行人員
     * @type {Array<ProfileUpdateUserRq>}
     * @memberof ProfileUpdateRq
     */
    'operatorList': Array<ProfileUpdateUserRq>;
}


/**
 * Profile Update Rs Model
 * @export
 * @interface ProfileUpdateRs
 */
export interface ProfileUpdateRs {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ProfileUpdateRs
     */
    'companyUuid'?: string;
}
/**
 * ProfileUpdateUserRq
 * @export
 * @interface ProfileUpdateUserRq
 */
export interface ProfileUpdateUserRq {
    /**
     * user uuid
     * @type {string}
     * @memberof ProfileUpdateUserRq
     */
    'userUuid'?: string | null;
    /**
     * user email
     * @type {string}
     * @memberof ProfileUpdateUserRq
     */
    'email'?: string | null;
}
/**
 * QueryAllSubTagDailyClicksRs
 * @export
 * @interface QueryAllSubTagClicksByDateRs
 */
export interface QueryAllSubTagClicksByDateRs {
    /**
     * 日期
     * @type {string}
     * @memberof QueryAllSubTagClicksByDateRs
     */
    'date'?: string;
    /**
     * 平均點擊數
     * @type {number}
     * @memberof QueryAllSubTagClicksByDateRs
     */
    'clicks'?: number;
}
/**
 * FE Url Statistics Query Company Organization SubTags Clicks Rq Model
 * @export
 * @interface QueryAllSubTagClicksRq
 */
export interface QueryAllSubTagClicksRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof QueryAllSubTagClicksRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof QueryAllSubTagClicksRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof QueryAllSubTagClicksRq
     */
    'startDate'?: string | null;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof QueryAllSubTagClicksRq
     */
    'endDate'?: string | null;
}
/**
 * FE Url Statistics Query Company Organization SubTags Clicks Rs Model
 * @export
 * @interface QueryAllSubTagClicksRs
 */
export interface QueryAllSubTagClicksRs {
    /**
     * 子標籤 id
     * @type {number}
     * @memberof QueryAllSubTagClicksRs
     */
    'subTagId'?: number;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof QueryAllSubTagClicksRs
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof QueryAllSubTagClicksRs
     */
    'subTagNo'?: string | null;
    /**
     * 總點擊數
     * @type {number}
     * @memberof QueryAllSubTagClicksRs
     */
    'totalClicks'?: number;
    /**
     * 不重複點擊數
     * @type {number}
     * @memberof QueryAllSubTagClicksRs
     */
    'uniqueClicks'?: number;
    /**
     * 轉換數
     * @type {number}
     * @memberof QueryAllSubTagClicksRs
     */
    'conversions'?: number | null;
    /**
     * 點擊數區間資料
     * @type {Array<QueryAllSubTagClicksByDateRs>}
     * @memberof QueryAllSubTagClicksRs
     */
    'clickList'?: Array<QueryAllSubTagClicksByDateRs> | null;
}
/**
 * QuerySubtotalRq
 * @export
 * @interface QuerySubtotalRq
 */
export interface QuerySubtotalRq {
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof QuerySubtotalRq
     */
    'term'?: string | null;
}
/**
 * 資料列表 - 小計數據 resp. model
 * @export
 * @interface QuerySubtotalRs
 */
export interface QuerySubtotalRs {
    /**
     * 主標籤小計數量
     * @type {number}
     * @memberof QuerySubtotalRs
     */
    'mainTagSubtotalCount'?: number;
    /**
     * 自定義標籤數量小計
     * @type {number}
     * @memberof QuerySubtotalRs
     */
    'customTagSubtotalCount'?: number;
    /**
     * 非自定義標籤數量小計
     * @type {number}
     * @memberof QuerySubtotalRs
     */
    'nonCustomTagSubtotalCount'?: number;
    /**
     * 子標籤小計數量
     * @type {number}
     * @memberof QuerySubtotalRs
     */
    'subtagSubtotalCount'?: number;
    /**
     * 全組織數量
     * @type {number}
     * @memberof QuerySubtotalRs
     */
    'totalOrganizationalCount'?: number;
}
/**
 * 短網址處理狀態  0 = None (None)  1 = Pending (等待執行)  2 = Processing (執行中)  3 = Success (執行成功)  4 = Failed (執行失敗)
 * @export
 * @enum {string}
 */

export const ShortLinkProcessStatus = {
    /**
    * None
    */
    None: 0,
    /**
    * 等待執行
    */
    Pending: 1,
    /**
    * 執行中
    */
    Processing: 2,
    /**
    * 執行成功
    */
    Success: 3,
    /**
    * 執行失敗
    */
    Failed: 4
} as const;

export type ShortLinkProcessStatus = typeof ShortLinkProcessStatus[keyof typeof ShortLinkProcessStatus];


/**
 * Short Url Append Tag To Urls Rq Model
 * @export
 * @interface ShortUrlAppendTagToUrlsRq
 */
export interface ShortUrlAppendTagToUrlsRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlAppendTagToUrlsRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlAppendTagToUrlsRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlAppendTagToUrlsRq
     */
    'orgTagId'?: number;
    /**
     * url uid list
     * @type {Array<string>}
     * @memberof ShortUrlAppendTagToUrlsRq
     */
    'urlUidList'?: Array<string> | null;
}
/**
 * Short Url Create Rq Model
 * @export
 * @interface ShortUrlCreateRq
 */
export interface ShortUrlCreateRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'projectName'?: string | null;
    /**
     * 數據標籤
     * @type {number}
     * @memberof ShortUrlCreateRq
     */
    'subtagId'?: number;
    /**
     * 原始網址
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'originalUrl'?: string | null;
    /**
     * 跳轉網址 (處理 utm 後的網址)
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'directUrl'?: string | null;
    /**
     * 
     * @type {FEUrlGroupingSingleUrlCreateRqUtm}
     * @memberof ShortUrlCreateRq
     */
    'utm'?: FEUrlGroupingSingleUrlCreateRqUtm | null;
    /**
     * 中文標記
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'chineseTag'?: string | null;
    /**
     * 標題
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'description'?: string | null;
    /**
     * image url
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'imageUrl'?: string | null;
    /**
     * image base64
     * @type {string}
     * @memberof ShortUrlCreateRq
     */
    'uploadImageBase64'?: string | null;
    /**
     * 
     * @type {UrlType}
     * @memberof ShortUrlCreateRq
     */
    'urlType'?: UrlType;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof ShortUrlCreateRq
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlCreateRq
     */
    'orgTagId'?: number | null;
}


/**
 * Short Url Create Rs Model
 * @export
 * @interface ShortUrlCreateRs
 */
export interface ShortUrlCreateRs {
    /**
     * url uid
     * @type {string}
     * @memberof ShortUrlCreateRs
     */
    'urlUid'?: string;
    /**
     * MainCode
     * @type {string}
     * @memberof ShortUrlCreateRs
     */
    'mainCode'?: string | null;
}
/**
 * Short Url Delete Item Rq Model
 * @export
 * @interface ShortUrlDeleteItemRq
 */
export interface ShortUrlDeleteItemRq {
    /**
     * url uid
     * @type {string}
     * @memberof ShortUrlDeleteItemRq
     */
    'urlUid'?: string;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof ShortUrlDeleteItemRq
     */
    'mainCode'?: string | null;
}
/**
 * Short Url Delete Rq Model
 * @export
 * @interface ShortUrlDeleteRq
 */
export interface ShortUrlDeleteRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlDeleteRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlDeleteRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * Items
     * @type {Array<ShortUrlDeleteItemRq>}
     * @memberof ShortUrlDeleteRq
     */
    'items'?: Array<ShortUrlDeleteItemRq> | null;
}
/**
 * Short Url Export All Rq Model
 * @export
 * @interface ShortUrlExportAllRq
 */
export interface ShortUrlExportAllRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'term'?: string | null;
    /**
     * 建立者
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'creatorUserUuid'?: string | null;
    /**
     * 子標籤 id
     * @type {Array<number>}
     * @memberof ShortUrlExportAllRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 開始日期
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'startDate'?: string | null;
    /**
     * 結束日期
     * @type {string}
     * @memberof ShortUrlExportAllRq
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof ShortUrlExportAllRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ShortUrlExportAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlExportAllRq
     */
    'orgTagId'?: number | null;
}


/**
 * Short Url Export Selected Detail
 * @export
 * @interface ShortUrlExportSelectedDetail
 */
export interface ShortUrlExportSelectedDetail {
    /**
     * UrlUid
     * @type {string}
     * @memberof ShortUrlExportSelectedDetail
     */
    'urlUid'?: string;
    /**
     * Main Code
     * @type {string}
     * @memberof ShortUrlExportSelectedDetail
     */
    'mainCode'?: string | null;
}
/**
 * Short Url Export Selected Rq Model
 * @export
 * @interface ShortUrlExportSelectedRq
 */
export interface ShortUrlExportSelectedRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlExportSelectedRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlExportSelectedRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof ShortUrlExportSelectedRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ShortUrlExportSelectedRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * details
     * @type {Array<ShortUrlExportSelectedDetail>}
     * @memberof ShortUrlExportSelectedRq
     */
    'details'?: Array<ShortUrlExportSelectedDetail> | null;
}


/**
 * ShortUrlGroupQueryAllSortingFields  0 = None (None)  1 = CreateTime (建立日期)  2 = Creator (建立人)  3 = SubTagName (受眾標籤)  4 = ProjectName (專案名稱)  5 = OrgTagName (組織標籤名稱)
 * @export
 * @enum {string}
 */

export const ShortUrlGroupQueryAllSortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 建立日期
    */
    CreateTime: 1,
    /**
    * 建立人
    */
    Creator: 2,
    /**
    * 受眾標籤
    */
    SubTagName: 3,
    /**
    * 專案名稱
    */
    ProjectName: 4,
    /**
    * 組織標籤名稱
    */
    OrgTagName: 5
} as const;

export type ShortUrlGroupQueryAllSortingFields = typeof ShortUrlGroupQueryAllSortingFields[keyof typeof ShortUrlGroupQueryAllSortingFields];


/**
 * Short Url Og Meta Rq Model
 * @export
 * @interface ShortUrlOgMetaRq
 */
export interface ShortUrlOgMetaRq {
    /**
     * parse html url
     * @type {string}
     * @memberof ShortUrlOgMetaRq
     */
    'url'?: string | null;
}
/**
 * Short Url Og Meta Rs Model
 * @export
 * @interface ShortUrlOgMetaRs
 */
export interface ShortUrlOgMetaRs {
    /**
     * Title
     * @type {string}
     * @memberof ShortUrlOgMetaRs
     */
    'title'?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof ShortUrlOgMetaRs
     */
    'description'?: string | null;
    /**
     * Image
     * @type {string}
     * @memberof ShortUrlOgMetaRs
     */
    'image'?: string | null;
}
/**
 * Short Url Query All Rq Model
 * @export
 * @interface ShortUrlQueryAllRq
 */
export interface ShortUrlQueryAllRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'term'?: string | null;
    /**
     * 建立者
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'creatorUserUuid'?: string | null;
    /**
     * 子標籤 id
     * @type {Array<number>}
     * @memberof ShortUrlQueryAllRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 開始日期
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'startDate'?: string | null;
    /**
     * 結束日期
     * @type {string}
     * @memberof ShortUrlQueryAllRq
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof ShortUrlQueryAllRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ShortUrlQueryAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlQueryAllRq
     */
    'orgTagId'?: number | null;
    /**
     * 分頁碼
     * @type {number}
     * @memberof ShortUrlQueryAllRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof ShortUrlQueryAllRq
     */
    'pageSize'?: number;
}


/**
 * Short Url Query All Rs Model
 * @export
 * @interface ShortUrlQueryAllRs
 */
export interface ShortUrlQueryAllRs {
    /**
     * UrlUid
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'urlUid'?: string;
    /**
     * Main Code
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'mainCode'?: string | null;
    /**
     * url code
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'urlCode'?: string | null;
    /**
     * 數據標籤
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'subTagName'?: string | null;
    /**
     * 專案名稱
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'projectName'?: string | null;
    /**
     * 建立時間
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'createTime'?: string;
    /**
     * 建立人
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'creator'?: string | null;
    /**
     * photo url
     * @type {string}
     * @memberof ShortUrlQueryAllRs
     */
    'photoUrl'?: string | null;
    /**
     * 短網址 IP 點擊數
     * @type {number}
     * @memberof ShortUrlQueryAllRs
     */
    'shortURLIPClickCount'?: number;
    /**
     * 短網址總點擊次數
     * @type {number}
     * @memberof ShortUrlQueryAllRs
     */
    'shortURLTotalClicks'?: number;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlQueryAllRs
     */
    'orgTagId'?: number | null;
    /**
     * 轉換數
     * @type {number}
     * @memberof ShortUrlQueryAllRs
     */
    'conversions'?: number | null;
}
/**
 * ShortUrlQueryAllSortingFields  0 = None (None)  1 = CreateTime (建立日期)  2 = Creator (建立人)  3 = SubTagName (受眾標籤)  4 = ProjectName (專案名稱)  5 = ShorterUrl (短網址)  6 = ClickCount (點擊數)  7 = UniqueClickCount (不重複訪客)  8 = Conversion (轉換數)  9 = OrgTagName (組織標籤名稱)
 * @export
 * @enum {string}
 */

export const ShortUrlQueryAllSortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 建立日期
    */
    CreateTime: 1,
    /**
    * 建立人
    */
    Creator: 2,
    /**
    * 受眾標籤
    */
    SubTagName: 3,
    /**
    * 專案名稱
    */
    ProjectName: 4,
    /**
    * 短網址
    */
    ShorterUrl: 5,
    /**
    * 點擊數
    */
    ClickCount: 6,
    /**
    * 不重複訪客
    */
    UniqueClickCount: 7,
    /**
    * 轉換數
    */
    Conversion: 8,
    /**
    * 組織標籤名稱
    */
    OrgTagName: 9
} as const;

export type ShortUrlQueryAllSortingFields = typeof ShortUrlQueryAllSortingFields[keyof typeof ShortUrlQueryAllSortingFields];


/**
 * ShortUrlQueryAllSubtotalRq
 * @export
 * @interface ShortUrlQueryAllSubtotalRq
 */
export interface ShortUrlQueryAllSubtotalRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'term'?: string | null;
    /**
     * 建立者
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'creatorUserUuid'?: string | null;
    /**
     * 子標籤 id
     * @type {Array<number>}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'subTagIdList'?: Array<number> | null;
    /**
     * 開始日期
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'startDate'?: string | null;
    /**
     * 結束日期
     * @type {string}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {ShortUrlQueryAllSortingFields}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'sortingField'?: ShortUrlQueryAllSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'sortingFieldDirection'?: SortDirection | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlQueryAllSubtotalRq
     */
    'orgTagId'?: number | null;
}


/**
 * ShortUrlQueryAllSubtotalRs
 * @export
 * @interface ShortUrlQueryAllSubtotalRs
 */
export interface ShortUrlQueryAllSubtotalRs {
    /**
     * 總數量
     * @type {number}
     * @memberof ShortUrlQueryAllSubtotalRs
     */
    'totalCount'?: number;
}
/**
 * Short Url Query Rq Model
 * @export
 * @interface ShortUrlQueryRq
 */
export interface ShortUrlQueryRq {
    /**
     * url uid
     * @type {string}
     * @memberof ShortUrlQueryRq
     */
    'urlUid'?: string;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof ShortUrlQueryRq
     */
    'mainCode'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlQueryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlQueryRq
     */
    'companyOrganizationUuid'?: string;
}
/**
 * Short Url Query Rs Model
 * @export
 * @interface ShortUrlQueryRs
 */
export interface ShortUrlQueryRs {
    /**
     * url uid
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'urlUid'?: string;
    /**
     * url code
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'urlCode'?: string | null;
    /**
     * MainCode
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'mainCode'?: string | null;
    /**
     * 專案名稱
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'projectName'?: string | null;
    /**
     * 數據標籤
     * @type {number}
     * @memberof ShortUrlQueryRs
     */
    'subtagId'?: number;
    /**
     * 原始網址
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'originalUrl'?: string | null;
    /**
     * 
     * @type {FEUrlGroupingSingleUrlCreateRqUtm}
     * @memberof ShortUrlQueryRs
     */
    'utm'?: FEUrlGroupingSingleUrlCreateRqUtm | null;
    /**
     * 中文標記
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'chineseTag'?: string | null;
    /**
     * 標題
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'description'?: string | null;
    /**
     * Thumbnail image url
     * @type {string}
     * @memberof ShortUrlQueryRs
     */
    'thumbnailImageUrl'?: string | null;
    /**
     * 
     * @type {UrlType}
     * @memberof ShortUrlQueryRs
     */
    'urlType'?: UrlType;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof ShortUrlQueryRs
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlQueryRs
     */
    'orgTagId'?: number | null;
}


/**
 * Short Url Query Subtag Rs Model
 * @export
 * @interface ShortUrlQuerySubtagRs
 */
export interface ShortUrlQuerySubtagRs {
    /**
     * 數據標籤 Id
     * @type {number}
     * @memberof ShortUrlQuerySubtagRs
     */
    'subtagId'?: number;
    /**
     * 數據標籤名稱
     * @type {string}
     * @memberof ShortUrlQuerySubtagRs
     */
    'subtagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof ShortUrlQuerySubtagRs
     */
    'subTagNo'?: string | null;
}
/**
 * Short Url Remove Tag From Rq Model
 * @export
 * @interface ShortUrlRemoveTagFromRq
 */
export interface ShortUrlRemoveTagFromRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlRemoveTagFromRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlRemoveTagFromRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlRemoveTagFromRq
     */
    'orgTagId'?: number;
    /**
     * url uid list
     * @type {Array<string>}
     * @memberof ShortUrlRemoveTagFromRq
     */
    'urlUidList'?: Array<string> | null;
}
/**
 * utm 參數標記
 * @export
 * @interface ShortUrlUTM
 */
export interface ShortUrlUTM {
    /**
     * Campaign Source
     * @type {string}
     * @memberof ShortUrlUTM
     */
    'campaignSource'?: string | null;
    /**
     * Campaign Medium
     * @type {string}
     * @memberof ShortUrlUTM
     */
    'campaignMedium'?: string | null;
    /**
     * Campaign Name
     * @type {string}
     * @memberof ShortUrlUTM
     */
    'campaignName'?: string | null;
    /**
     * Campaign Term
     * @type {string}
     * @memberof ShortUrlUTM
     */
    'campaignTerm'?: string | null;
    /**
     * Campaign Content
     * @type {string}
     * @memberof ShortUrlUTM
     */
    'campaignContent'?: string | null;
}
/**
 * Short Url Update Rq Model
 * @export
 * @interface ShortUrlUpdateRq
 */
export interface ShortUrlUpdateRq {
    /**
     * url uid
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'urlUid'?: string;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'mainCode'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 專案名稱
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'projectName'?: string | null;
    /**
     * 原始網址
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'originalUrl'?: string | null;
    /**
     * 跳轉網址 (處理 utm 後的網址)
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'directUrl'?: string | null;
    /**
     * 
     * @type {FEUrlGroupingSingleUrlCreateRqUtm}
     * @memberof ShortUrlUpdateRq
     */
    'utm'?: FEUrlGroupingSingleUrlCreateRqUtm | null;
    /**
     * 中文標記
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'chineseTag'?: string | null;
    /**
     * 標題
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'title'?: string | null;
    /**
     * 描述
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'description'?: string | null;
    /**
     * 有變更 image 設置
     * @type {boolean}
     * @memberof ShortUrlUpdateRq
     */
    'hasUpdateImage'?: boolean;
    /**
     * image url
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'newImageUrl'?: string | null;
    /**
     * image base64
     * @type {string}
     * @memberof ShortUrlUpdateRq
     */
    'newUploadImageBase64'?: string | null;
    /**
     * 啟用追蹤 tape id
     * @type {boolean}
     * @memberof ShortUrlUpdateRq
     */
    'enableTraceTapeId'?: boolean;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof ShortUrlUpdateRq
     */
    'orgTagId'?: number | null;
}
/**
 * SortDirection  0 = None (None)  1 = Ascending (Ascending)  2 = Descending (Descending)
 * @export
 * @enum {string}
 */

export const SortDirection = {
    /**
    * None
    */
    None: 0,
    /**
    * Ascending
    */
    Ascending: 1,
    /**
    * Descending
    */
    Descending: 2
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * FE Company Org Stats SubTag Age Distribution Rs Model
 * @export
 * @interface StatisticsAgeDistRs
 */
export interface StatisticsAgeDistRs {
    /**
     * 項目名稱
     * @type {string}
     * @memberof StatisticsAgeDistRs
     */
    'itemName'?: string | null;
    /**
     * 組織數據標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsAgeDistRs
     */
    'stats'?: number;
    /**
     * 標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsAgeDistRs
     */
    'labelStats'?: number;
}
/**
 * FE Url Statistics Clicks Item Rs Model
 * @export
 * @interface StatisticsClickItemModel
 */
export interface StatisticsClickItemModel {
    /**
     * Date
     * @type {string}
     * @memberof StatisticsClickItemModel
     */
    'date'?: string;
    /**
     * Count
     * @type {number}
     * @memberof StatisticsClickItemModel
     */
    'count'?: number;
}
/**
 * StatisticsClickSummaryRs
 * @export
 * @interface StatisticsClickSummaryRs
 */
export interface StatisticsClickSummaryRs {
    /**
     * 短網址 IP 點擊數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'shortURLIPClickCount'?: number;
    /**
     * 短網址總點擊次數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'shortURLTotalClicks'?: number;
    /**
     * 產業 - 短網址 IP 點擊數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'labelIPClickCount'?: number;
    /**
     * 產業 - 短網址總點擊次數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'labelTotalClicks'?: number;
    /**
     * 轉換數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'conversions'?: number | null;
    /**
     * label - 轉換數
     * @type {number}
     * @memberof StatisticsClickSummaryRs
     */
    'labelConversions'?: number | null;
}
/**
 * FE Url Statistics Clicks Rs Model
 * @export
 * @interface StatisticsClicksRs
 */
export interface StatisticsClicksRs {
    /**
     * 組織 - 短網址統計
     * @type {Array<StatisticsClickItemModel>}
     * @memberof StatisticsClicksRs
     */
    'orgClicks'?: Array<StatisticsClickItemModel> | null;
    /**
     * 組織 - 短網址不重複統計
     * @type {Array<StatisticsClickItemModel>}
     * @memberof StatisticsClicksRs
     */
    'orgUniqueClicks'?: Array<StatisticsClickItemModel> | null;
    /**
     * 組織 - 短網址轉換數統計
     * @type {Array<StatisticsClickItemModel>}
     * @memberof StatisticsClicksRs
     */
    'orgConversions'?: Array<StatisticsClickItemModel> | null;
}
/**
 * FE Company Org Stats SubTag Device Distribution Rs Model
 * @export
 * @interface StatisticsDeviceDistRs
 */
export interface StatisticsDeviceDistRs {
    /**
     * 項目名稱
     * @type {string}
     * @memberof StatisticsDeviceDistRs
     */
    'itemName'?: string | null;
    /**
     * 組織數據標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsDeviceDistRs
     */
    'stats'?: number;
    /**
     * 標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsDeviceDistRs
     */
    'labelStats'?: number;
}
/**
 * FE Company Org Stats SubTag Gender Distribution Rs Model
 * @export
 * @interface StatisticsGenderDistRs
 */
export interface StatisticsGenderDistRs {
    /**
     * 項目名稱
     * @type {string}
     * @memberof StatisticsGenderDistRs
     */
    'itemName'?: string | null;
    /**
     * 組織數據標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsGenderDistRs
     */
    'stats'?: number;
    /**
     * 標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsGenderDistRs
     */
    'labelStats'?: number;
}
/**
 * FE Url Statistics Region Distribution Item Rs Model
 * @export
 * @interface StatisticsRegionDistItemModel
 */
export interface StatisticsRegionDistItemModel {
    /**
     * Region
     * @type {string}
     * @memberof StatisticsRegionDistItemModel
     */
    'region'?: string | null;
    /**
     * 統計數據
     * @type {number}
     * @memberof StatisticsRegionDistItemModel
     */
    'stats'?: number;
}
/**
 * FE Company Org Stats SubTag Region Distribution Rs Model
 * @export
 * @interface StatisticsRegionDistRs
 */
export interface StatisticsRegionDistRs {
    /**
     * 組織數據標籤 - 統計數據
     * @type {Array<StatisticsRegionDistItemModel>}
     * @memberof StatisticsRegionDistRs
     */
    'orgStats'?: Array<StatisticsRegionDistItemModel> | null;
    /**
     * 產業 - 統計數據
     * @type {Array<StatisticsRegionDistItemModel>}
     * @memberof StatisticsRegionDistRs
     */
    'labelStats'?: Array<StatisticsRegionDistItemModel> | null;
}
/**
 * FE Company Org Stats SubTag Source Distribution Rs Model
 * @export
 * @interface StatisticsSourceDistRs
 */
export interface StatisticsSourceDistRs {
    /**
     * 項目名稱
     * @type {string}
     * @memberof StatisticsSourceDistRs
     */
    'itemName'?: string | null;
    /**
     * 組織數據標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsSourceDistRs
     */
    'stats'?: number;
    /**
     * 標籤 - 統計數據
     * @type {number}
     * @memberof StatisticsSourceDistRs
     */
    'labelStats'?: number;
}
/**
 * 子標籤更新 model
 * @export
 * @interface SubTagUpdateRq
 */
export interface SubTagUpdateRq {
    /**
     * 子標籤 id
     * @type {number}
     * @memberof SubTagUpdateRq
     */
    'subTagId'?: number | null;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof SubTagUpdateRq
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof SubTagUpdateRq
     */
    'subTagNo'?: string | null;
    /**
     * 
     * @type {DataStatus}
     * @memberof SubTagUpdateRq
     */
    'subTagStatus'?: DataStatus;
}


/**
 * SystemCompanyDomainRelationshipRs
 * @export
 * @interface SystemCompanyDomainRelationshipRs
 */
export interface SystemCompanyDomainRelationshipRs {
    /**
     * domain id
     * @type {number}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'domainId'?: number;
    /**
     * 公司名稱
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'companyName'?: string | null;
    /**
     * domain name
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'customDomain'?: string | null;
    /**
     * company status display name
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'companyStatusDisplayName'?: string | null;
    /**
     * 
     * @type {CompanyStatus}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'companyStatusCode'?: CompanyStatus;
    /**
     * 
     * @type {DomainStatus}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'domainStatusCode'?: DomainStatus;
    /**
     * 到期日
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'expiryDate'?: string | null;
    /**
     * 購買時間
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'purchaseTime'?: string | null;
    /**
     * 購買金額
     * @type {number}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'purchaseAmount'?: number | null;
    /**
     * 備註
     * @type {string}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'notes'?: string | null;
    /**
     * 關聯組織清單
     * @type {Array<string>}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'relationshipOrganizationList'?: Array<string> | null;
    /**
     * domain warning
     * @type {boolean}
     * @memberof SystemCompanyDomainRelationshipRs
     */
    'isWarning'?: boolean;
}


/**
 * System Count Urls Grouped By Date Rs Model
 * @export
 * @interface SystemCountUrlsGroupedByDateRs
 */
export interface SystemCountUrlsGroupedByDateRs {
    /**
     * 建立日期
     * @type {string}
     * @memberof SystemCountUrlsGroupedByDateRs
     */
    'date'?: string;
    /**
     * 建立筆數
     * @type {number}
     * @memberof SystemCountUrlsGroupedByDateRs
     */
    'count'?: number;
}
/**
 * System Domain Health Check Rs Model
 * @export
 * @interface SystemDomainHealthCheckRs
 */
export interface SystemDomainHealthCheckRs {
    /**
     * domain name
     * @type {string}
     * @memberof SystemDomainHealthCheckRs
     */
    'customDomain'?: string | null;
    /**
     * organization name
     * @type {string}
     * @memberof SystemDomainHealthCheckRs
     */
    'organizationName'?: string | null;
    /**
     * company name
     * @type {string}
     * @memberof SystemDomainHealthCheckRs
     */
    'companyName'?: string | null;
    /**
     * 是否存活
     * @type {boolean}
     * @memberof SystemDomainHealthCheckRs
     */
    'isLive'?: boolean;
}
/**
 * System Job Rs Model
 * @export
 * @interface SystemJobRs
 */
export interface SystemJobRs {
    /**
     * job 代碼
     * @type {string}
     * @memberof SystemJobRs
     */
    'jobCode'?: string | null;
    /**
     * job 名稱
     * @type {string}
     * @memberof SystemJobRs
     */
    'jobName'?: string | null;
    /**
     * job 描述
     * @type {string}
     * @memberof SystemJobRs
     */
    'jobDesc'?: string | null;
    /**
     * 最新更新時間
     * @type {string}
     * @memberof SystemJobRs
     */
    'lastExecutionTime'?: string;
}
/**
 * system user role  0 = None (None)  1 = Admin (Admin (管理者))  2 = SuperUser (Super User (超級用戶))  3 = User (User (使用者))  4 = Guest (Guest (客戶))  5 = External (外部帳號)
 * @export
 * @enum {string}
 */

export const SystemUserRole = {
    /**
    * None
    */
    None: 0,
    /**
    * Admin (管理者)
    */
    Admin: 1,
    /**
    * Super User (超級用戶)
    */
    SuperUser: 2,
    /**
    * User (使用者)
    */
    User: 3,
    /**
    * Guest (客戶)
    */
    Guest: 4,
    /**
    * 外部帳號
    */
    External: 5
} as const;

export type SystemUserRole = typeof SystemUserRole[keyof typeof SystemUserRole];


/**
 * Tag Export All Rq Model
 * @export
 * @interface TagExportAllRq
 */
export interface TagExportAllRq {
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof TagExportAllRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {TagQueryType}
     * @memberof TagExportAllRq
     */
    'queryType'?: TagQueryType;
}


/**
 * Tag Export Selected Rq Model
 * @export
 * @interface TagExportSelectedRq
 */
export interface TagExportSelectedRq {
    /**
     * Main tag id list
     * @type {Array<number>}
     * @memberof TagExportSelectedRq
     */
    'mainTagIdList'?: Array<number> | null;
}
/**
 * 標籤清單 - 查詢參數
 * @export
 * @interface TagQueryAllRq
 */
export interface TagQueryAllRq {
    /**
     * 關鍵字查詢
     * @type {string}
     * @memberof TagQueryAllRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {TagQueryType}
     * @memberof TagQueryAllRq
     */
    'queryType'?: TagQueryType;
    /**
     * 分頁碼
     * @type {number}
     * @memberof TagQueryAllRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof TagQueryAllRq
     */
    'pageSize'?: number;
}


/**
 * TagQueryAllRs
 * @export
 * @interface TagQueryAllRs
 */
export interface TagQueryAllRs {
    /**
     * 主標籤 id
     * @type {number}
     * @memberof TagQueryAllRs
     */
    'mainTagId'?: number;
    /**
     * 主標籤名稱
     * @type {string}
     * @memberof TagQueryAllRs
     */
    'mainTagName'?: string | null;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof TagQueryAllRs
     */
    'mainTagCode'?: string | null;
    /**
     * 是否為客製標籤
     * @type {boolean}
     * @memberof TagQueryAllRs
     */
    'isCustom'?: boolean;
    /**
     * 有子標籤項目
     * @type {boolean}
     * @memberof TagQueryAllRs
     */
    'hasSubtags'?: boolean;
    /**
     * 短網址 IP 點擊數
     * @type {number}
     * @memberof TagQueryAllRs
     */
    'shortURLIPClickCount'?: number;
    /**
     * 短網址總點擊次數
     * @type {number}
     * @memberof TagQueryAllRs
     */
    'shortURLTotalClicks'?: number;
    /**
     * 短網址建立筆數
     * @type {number}
     * @memberof TagQueryAllRs
     */
    'shortURLsCreatedCount'?: number;
    /**
     * 組織連結數量
     * @type {number}
     * @memberof TagQueryAllRs
     */
    'organizationalLinkCount'?: number;
}
/**
 * 資料列表明細 - 查詢參數
 * @export
 * @interface TagQueryDetailRq
 */
export interface TagQueryDetailRq {
    /**
     * 主標籤 id
     * @type {number}
     * @memberof TagQueryDetailRq
     */
    'mainTagId'?: number;
}
/**
 * TagQueryTagDetailRs
 * @export
 * @interface TagQueryDetailRs
 */
export interface TagQueryDetailRs {
    /**
     * 子標籤 id
     * @type {number}
     * @memberof TagQueryDetailRs
     */
    'subTagId'?: number;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof TagQueryDetailRs
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof TagQueryDetailRs
     */
    'subTagNo'?: string | null;
    /**
     * 短網址 IP 點擊數
     * @type {number}
     * @memberof TagQueryDetailRs
     */
    'shortURLIPClickCount'?: number;
    /**
     * 短網址總點擊次數
     * @type {number}
     * @memberof TagQueryDetailRs
     */
    'shortURLTotalClicks'?: number;
    /**
     * 短網址建立筆數
     * @type {number}
     * @memberof TagQueryDetailRs
     */
    'shortURLsCreatedCount'?: number;
}
/**
 * TagQueryType  0 = None (None)  1 = All (總建立)  2 = NonCustomTagSubtotalCount (自定義標籤)  3 = CustomTagSubtotalCount (非自定義標籤)
 * @export
 * @enum {string}
 */

export const TagQueryType = {
    /**
    * None
    */
    None: 0,
    /**
    * 總建立
    */
    All: 1,
    /**
    * 自定義標籤
    */
    NonCustomTagSubtotalCount: 2,
    /**
    * 非自定義標籤
    */
    CustomTagSubtotalCount: 3
} as const;

export type TagQueryType = typeof TagQueryType[keyof typeof TagQueryType];


/**
 * Thumbnail Size  0 = None (None)  1 = Small (Small)  2 = Large (Large)
 * @export
 * @enum {string}
 */

export const ThumbnailSize = {
    /**
    * None
    */
    None: 0,
    /**
    * Small
    */
    Small: 1,
    /**
    * Large
    */
    Large: 2
} as const;

export type ThumbnailSize = typeof ThumbnailSize[keyof typeof ThumbnailSize];


/**
 * Url Click Summary Rq Model
 * @export
 * @interface UrlClickSummaryRq
 */
export interface UrlClickSummaryRq {
    /**
     * url uid
     * @type {string}
     * @memberof UrlClickSummaryRq
     */
    'urlUid'?: string;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlClickSummaryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlClickSummaryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * 開始日期
     * @type {string}
     * @memberof UrlClickSummaryRq
     */
    'startDate'?: string;
    /**
     * 結束日期
     * @type {string}
     * @memberof UrlClickSummaryRq
     */
    'endDate'?: string;
}
/**
 * Url Group Stats Click Summary Rq Model
 * @export
 * @interface UrlGroupStatsClickSummaryRq
 */
export interface UrlGroupStatsClickSummaryRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlGroupStatsClickSummaryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlGroupStatsClickSummaryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof UrlGroupStatsClickSummaryRq
     */
    'urlGroupId'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof UrlGroupStatsClickSummaryRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof UrlGroupStatsClickSummaryRq
     */
    'endDate'?: string;
}
/**
 * FE Url Group Stats Clicks Rq Model
 * @export
 * @interface UrlGroupStatsClicksRq
 */
export interface UrlGroupStatsClicksRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlGroupStatsClicksRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlGroupStatsClicksRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof UrlGroupStatsClicksRq
     */
    'urlGroupId'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof UrlGroupStatsClicksRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof UrlGroupStatsClicksRq
     */
    'endDate'?: string;
}
/**
 * Url Group Stats Info Rq
 * @export
 * @interface UrlGroupStatsInfoRq
 */
export interface UrlGroupStatsInfoRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlGroupStatsInfoRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlGroupStatsInfoRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof UrlGroupStatsInfoRq
     */
    'urlGroupId'?: string;
}
/**
 * FE Url Group Stats Info Rs Model
 * @export
 * @interface UrlGroupStatsInfoRs
 */
export interface UrlGroupStatsInfoRs {
    /**
     * Project Name
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'projectName'?: string | null;
    /**
     * 主標籤名稱
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'mainTagName'?: string | null;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'mainTagCode'?: string | null;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'subTagNo'?: string | null;
    /**
     * 建立人
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'creator'?: string | null;
    /**
     * 建立時間
     * @type {string}
     * @memberof UrlGroupStatsInfoRs
     */
    'createTime'?: string;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof UrlGroupStatsInfoRs
     */
    'orgTagId'?: number | null;
}
/**
 * FE Url Group Stats Age Distribution Rq Model
 * @export
 * @interface UrlGroupStatsQueryRq
 */
export interface UrlGroupStatsQueryRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlGroupStatsQueryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlGroupStatsQueryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url group id
     * @type {string}
     * @memberof UrlGroupStatsQueryRq
     */
    'urlGroupId'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof UrlGroupStatsQueryRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof UrlGroupStatsQueryRq
     */
    'endDate'?: string;
}
/**
 * FE Url Statistic Clicks Rq
 * @export
 * @interface UrlStatsClicksRq
 */
export interface UrlStatsClicksRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlStatsClicksRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlStatsClicksRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url uid
     * @type {string}
     * @memberof UrlStatsClicksRq
     */
    'urlUid'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof UrlStatsClicksRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof UrlStatsClicksRq
     */
    'endDate'?: string;
}
/**
 * FE Url Statistics Age Distribution Rq
 * @export
 * @interface UrlStatsQueryRq
 */
export interface UrlStatsQueryRq {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlStatsQueryRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlStatsQueryRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * url uid
     * @type {string}
     * @memberof UrlStatsQueryRq
     */
    'urlUid'?: string;
    /**
     * 搜尋開始時間
     * @type {string}
     * @memberof UrlStatsQueryRq
     */
    'startDate'?: string;
    /**
     * 搜尋結束時間
     * @type {string}
     * @memberof UrlStatsQueryRq
     */
    'endDate'?: string;
}
/**
 * FE Url Statistics Url Info Rq
 * @export
 * @interface UrlStatsUrlInfoRq
 */
export interface UrlStatsUrlInfoRq {
    /**
     * url uid
     * @type {string}
     * @memberof UrlStatsUrlInfoRq
     */
    'urlUid'?: string;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof UrlStatsUrlInfoRq
     */
    'mainCode'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UrlStatsUrlInfoRq
     */
    'companyUuId'?: string;
    /**
     * 公司組織 uuid
     * @type {string}
     * @memberof UrlStatsUrlInfoRq
     */
    'companyOrganizationUuid'?: string;
}
/**
 * FE Url Statistics Url Info Rs Model
 * @export
 * @interface UrlStatsUrlInfoRs
 */
export interface UrlStatsUrlInfoRs {
    /**
     * 專案名稱
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'projectName'?: string | null;
    /**
     * 主標籤名稱
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'mainTagName'?: string | null;
    /**
     * 主標籤代碼
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'mainTagCode'?: string | null;
    /**
     * 子標籤名稱
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'subTagName'?: string | null;
    /**
     * 子標籤編號
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'subTagNo'?: string | null;
    /**
     * 建立人
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'creator'?: string | null;
    /**
     * 建立時間
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'createTime'?: string;
    /**
     * 短網址
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'shortUrl'?: string | null;
    /**
     * 跳轉網址 (處理 utm 後的網址)
     * @type {string}
     * @memberof UrlStatsUrlInfoRs
     */
    'directUrl'?: string | null;
    /**
     * 組織標籤 id
     * @type {number}
     * @memberof UrlStatsUrlInfoRs
     */
    'orgTagId'?: number | null;
}
/**
 * 網址類別  0 = None (None)  1 = Url (網址)  2 = Tel (電話)
 * @export
 * @enum {string}
 */

export const UrlType = {
    /**
    * None
    */
    None: 0,
    /**
    * 網址
    */
    Url: 1,
    /**
    * 電話
    */
    Tel: 2
} as const;

export type UrlType = typeof UrlType[keyof typeof UrlType];


/**
 * User Cancel Invitation Rq Model
 * @export
 * @interface UserCancelInvitationRq
 */
export interface UserCancelInvitationRq {
    /**
     * user uuids
     * @type {Array<string>}
     * @memberof UserCancelInvitationRq
     */
    'userUuids'?: Array<string> | null;
}
/**
 * User Mgmt Assign Company Contact To Staff Rq Model
 * @export
 * @interface UserMgmtAssignCompanyContactToStaffRq
 */
export interface UserMgmtAssignCompanyContactToStaffRq {
    /**
     * user uuid
     * @type {string}
     * @memberof UserMgmtAssignCompanyContactToStaffRq
     */
    'userUuid'?: string;
    /**
     * company uuid
     * @type {string}
     * @memberof UserMgmtAssignCompanyContactToStaffRq
     */
    'companyUuid'?: string;
}
/**
 * User Mgmt Change Staff Role Rq Model
 * @export
 * @interface UserMgmtChangeStaffRoleRq
 */
export interface UserMgmtChangeStaffRoleRq {
    /**
     * 使用者 id
     * @type {string}
     * @memberof UserMgmtChangeStaffRoleRq
     */
    'userUuid'?: string;
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtChangeStaffRoleRq
     */
    'role'?: UserMgmtQueryStaffType;
}


/**
 * User Mgmt Customer Export All Rq Model
 * @export
 * @interface UserMgmtCustomerExportAllRq
 */
export interface UserMgmtCustomerExportAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtCustomerExportAllRq
     */
    'term'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UserMgmtCustomerExportAllRq
     */
    'companyUuid'?: string | null;
    /**
     * 
     * @type {UserQueryCustomerUserSortingFields}
     * @memberof UserMgmtCustomerExportAllRq
     */
    'sortingField'?: UserQueryCustomerUserSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtCustomerExportAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User Mgmt Customer Export Selected Rq Model
 * @export
 * @interface UserMgmtCustomerExportSelectedRq
 */
export interface UserMgmtCustomerExportSelectedRq {
    /**
     * User Uuid List
     * @type {Array<string>}
     * @memberof UserMgmtCustomerExportSelectedRq
     */
    'userUuidList'?: Array<string> | null;
    /**
     * 
     * @type {UserQueryCustomerUserSortingFields}
     * @memberof UserMgmtCustomerExportSelectedRq
     */
    'sortingField'?: UserQueryCustomerUserSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtCustomerExportSelectedRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User Mgmt Customer Remove All Permission Rq Model
 * @export
 * @interface UserMgmtCustomerRemoveAllPermissionRq
 */
export interface UserMgmtCustomerRemoveAllPermissionRq {
    /**
     * user uuid
     * @type {string}
     * @memberof UserMgmtCustomerRemoveAllPermissionRq
     */
    'userUuid'?: string;
    /**
     * company uuid
     * @type {string}
     * @memberof UserMgmtCustomerRemoveAllPermissionRq
     */
    'companyUuid'?: string;
}
/**
 * User Mgmt Delete Company Contact By Staff
 * @export
 * @interface UserMgmtDeleteCompanyContactByStaff
 */
export interface UserMgmtDeleteCompanyContactByStaff {
    /**
     * user uuid
     * @type {string}
     * @memberof UserMgmtDeleteCompanyContactByStaff
     */
    'userUuid'?: string;
    /**
     * company uuid
     * @type {string}
     * @memberof UserMgmtDeleteCompanyContactByStaff
     */
    'companyUuid'?: string;
}
/**
 * User Mgmt Delete Customer Account Model
 * @export
 * @interface UserMgmtDeleteCustomerAccount
 */
export interface UserMgmtDeleteCustomerAccount {
    /**
     * user uuids
     * @type {Array<string>}
     * @memberof UserMgmtDeleteCustomerAccount
     */
    'userUuids'?: Array<string> | null;
}
/**
 * User Mgmt Delete Staff Account Rq Model
 * @export
 * @interface UserMgmtDeleteStaffAccountRq
 */
export interface UserMgmtDeleteStaffAccountRq {
    /**
     * user uuids
     * @type {Array<string>}
     * @memberof UserMgmtDeleteStaffAccountRq
     */
    'userUuids'?: Array<string> | null;
}
/**
 * User Mgmt Generate Customer Registration Link Rq Model
 * @export
 * @interface UserMgmtGenerateCustomerRegistrationLinkRq
 */
export interface UserMgmtGenerateCustomerRegistrationLinkRq {
    /**
     * company uuid
     * @type {string}
     * @memberof UserMgmtGenerateCustomerRegistrationLinkRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof UserMgmtGenerateCustomerRegistrationLinkRq
     */
    'orgUuid'?: string;
}
/**
 * User Mgmt Generate Customer Registration Link Rs Model
 * @export
 * @interface UserMgmtGenerateCustomerRegistrationLinkRs
 */
export interface UserMgmtGenerateCustomerRegistrationLinkRs {
    /**
     * 邀請連結
     * @type {string}
     * @memberof UserMgmtGenerateCustomerRegistrationLinkRs
     */
    'invitationLink'?: string | null;
}
/**
 * User Mgmt Generate Staff Registration Link Rq Model
 * @export
 * @interface UserMgmtGenerateStaffRegistrationLinkRq
 */
export interface UserMgmtGenerateStaffRegistrationLinkRq {
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtGenerateStaffRegistrationLinkRq
     */
    'role'?: UserMgmtQueryStaffType | null;
}


/**
 * User Mgmt Generate Staff Registration Link Rs Model
 * @export
 * @interface UserMgmtGenerateStaffRegistrationLinkRs
 */
export interface UserMgmtGenerateStaffRegistrationLinkRs {
    /**
     * 邀請連結
     * @type {string}
     * @memberof UserMgmtGenerateStaffRegistrationLinkRs
     */
    'invitationLink'?: string | null;
}
/**
 * User Mgmt Get Current User Pending Customer Invitation Count Rs Model
 * @export
 * @interface UserMgmtGetCurrentUserPendingCustomerInvitationCountRs
 */
export interface UserMgmtGetCurrentUserPendingCustomerInvitationCountRs {
    /**
     * 待驗證狀態筆數
     * @type {number}
     * @memberof UserMgmtGetCurrentUserPendingCustomerInvitationCountRs
     */
    'pendingInvitationCount'?: number;
}
/**
 * User Mgmt Query Staff Pending Invitation Count Rs
 * @export
 * @interface UserMgmtGetCurrentUserPendingStaffInvitationCountRs
 */
export interface UserMgmtGetCurrentUserPendingStaffInvitationCountRs {
    /**
     * 待驗證狀態筆數
     * @type {number}
     * @memberof UserMgmtGetCurrentUserPendingStaffInvitationCountRs
     */
    'pendingInvitationCount'?: number;
}
/**
 * User Mgmt Query Current User Owned Company Rs Model
 * @export
 * @interface UserMgmtQueryCurrentUserOwnedCompanyRs
 */
export interface UserMgmtQueryCurrentUserOwnedCompanyRs {
    /**
     * 公司公開 id
     * @type {string}
     * @memberof UserMgmtQueryCurrentUserOwnedCompanyRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof UserMgmtQueryCurrentUserOwnedCompanyRs
     */
    'companyName'?: string | null;
}
/**
 * User Mgmt Query Customer User Company Rs Model
 * @export
 * @interface UserMgmtQueryCustomerUserCompanyRs
 */
export interface UserMgmtQueryCustomerUserCompanyRs {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserCompanyRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserCompanyRs
     */
    'companyName'?: string | null;
}
/**
 * User Mgmt Query Customer User Org Rs Model
 * @export
 * @interface UserMgmtQueryCustomerUserOrgRs
 */
export interface UserMgmtQueryCustomerUserOrgRs {
    /**
     * 公司組織公開 id
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserOrgRs
     */
    'organizationUuid'?: string;
    /**
     * 公司組織名稱
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserOrgRs
     */
    'organizationName'?: string | null;
}
/**
 * User Query General User Rq Model
 * @export
 * @interface UserMgmtQueryCustomerUserRq
 */
export interface UserMgmtQueryCustomerUserRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'term'?: string | null;
    /**
     * 頁面索引
     * @type {number}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'pageSize'?: number;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'companyUuid'?: string | null;
    /**
     * 
     * @type {UserQueryCustomerUserSortingFields}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'sortingField'?: UserQueryCustomerUserSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtQueryCustomerUserRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User Query General User Rs Model
 * @export
 * @interface UserMgmtQueryCustomerUserRs
 */
export interface UserMgmtQueryCustomerUserRs {
    /**
     * 使用者 uuid
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'userUuid'?: string;
    /**
     * 使用者名稱
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'userName'?: string | null;
    /**
     * 使用者 email
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'email'?: string | null;
    /**
     * 使用者電話
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'phone'?: string | null;
    /**
     * 照片連結
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'photoUrl'?: string | null;
    /**
     * 使用者狀態 (display name)
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'userStatusDisplayName'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'userStatusCode'?: UserStatus;
    /**
     * 是否為公司負責人
     * @type {boolean}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'isOwner'?: boolean;
    /**
     * 所屬公司
     * @type {Array<UserMgmtQueryCustomerUserCompanyRs>}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'companyItems'?: Array<UserMgmtQueryCustomerUserCompanyRs> | null;
    /**
     * 組長 - 組織列表
     * @type {Array<UserMgmtQueryCustomerUserOrgRs>}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'leaderOrgList'?: Array<UserMgmtQueryCustomerUserOrgRs> | null;
    /**
     * 組員 - 組織列表
     * @type {Array<UserMgmtQueryCustomerUserOrgRs>}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'memberOrgList'?: Array<UserMgmtQueryCustomerUserOrgRs> | null;
    /**
     * 建立者 uuid
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'creatorUuid'?: string | null;
    /**
     * 建立者姓名
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'creatorName'?: string | null;
    /**
     * 建立者 email
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserRs
     */
    'creatorEmail'?: string | null;
}


/**
 * User Query General User Subtotal Rq Model
 * @export
 * @interface UserMgmtQueryCustomerUserSubtotalRq
 */
export interface UserMgmtQueryCustomerUserSubtotalRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserSubtotalRq
     */
    'term'?: string | null;
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UserMgmtQueryCustomerUserSubtotalRq
     */
    'companyUuid'?: string | null;
}
/**
 * User Query General User Subtotal Rs Model
 * @export
 * @interface UserMgmtQueryCustomerUserSubtotalRs
 */
export interface UserMgmtQueryCustomerUserSubtotalRs {
    /**
     * 一般用戶總數
     * @type {number}
     * @memberof UserMgmtQueryCustomerUserSubtotalRs
     */
    'customerUserCount'?: number;
}
/**
 * User Query Staff Member Rq Model
 * @export
 * @interface UserMgmtQueryStaffMemberRq
 */
export interface UserMgmtQueryStaffMemberRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'term'?: string | null;
    /**
     * 頁面索引
     * @type {number}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'pageNumber'?: number;
    /**
     * 頁面大小
     * @type {number}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'pageSize'?: number;
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'role'?: UserMgmtQueryStaffType | null;
    /**
     * 業務分類
     * @type {Array<UserQueryStaffMemberBusinessCategory>}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'businessCategory'?: Array<UserQueryStaffMemberBusinessCategory> | null;
    /**
     * 
     * @type {UserQueryStaffMemberSortingFields}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'sortingField'?: UserQueryStaffMemberSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtQueryStaffMemberRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User QuerySubtotal Rq Model
 * @export
 * @interface UserMgmtQueryStaffMemberSubtotalRq
 */
export interface UserMgmtQueryStaffMemberSubtotalRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtQueryStaffMemberSubtotalRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtQueryStaffMemberSubtotalRq
     */
    'role'?: UserMgmtQueryStaffType | null;
    /**
     * 業務分類
     * @type {Array<UserQueryStaffMemberBusinessCategory>}
     * @memberof UserMgmtQueryStaffMemberSubtotalRq
     */
    'businessCategory'?: Array<UserQueryStaffMemberBusinessCategory> | null;
}


/**
 * Query Staff Type  0 = None (None)  1 = Admin (Admin (管理者))  2 = SuperUser (Super User (超級用戶))  3 = User (User (使用者))
 * @export
 * @enum {string}
 */

export const UserMgmtQueryStaffType = {
    /**
    * None
    */
    None: 0,
    /**
    * Admin (管理者)
    */
    Admin: 1,
    /**
    * Super User (超級用戶)
    */
    SuperUser: 2,
    /**
    * User (使用者)
    */
    User: 3
} as const;

export type UserMgmtQueryStaffType = typeof UserMgmtQueryStaffType[keyof typeof UserMgmtQueryStaffType];


/**
 * User Mgmt Send Customer Registration Invitation Rq Model
 * @export
 * @interface UserMgmtSendCustomerRegistrationInvitationRq
 */
export interface UserMgmtSendCustomerRegistrationInvitationRq {
    /**
     * company uuid
     * @type {string}
     * @memberof UserMgmtSendCustomerRegistrationInvitationRq
     */
    'companyUuid'?: string;
    /**
     * org uuid
     * @type {string}
     * @memberof UserMgmtSendCustomerRegistrationInvitationRq
     */
    'companyOrganizationUuid'?: string;
    /**
     * org members
     * @type {Array<UserMgmtSendCustomerRegistrationInvitationUserRq>}
     * @memberof UserMgmtSendCustomerRegistrationInvitationRq
     */
    'orgMembers'?: Array<UserMgmtSendCustomerRegistrationInvitationUserRq> | null;
}
/**
 * User Mgmt Send Customer Registration Invitation User Rq
 * @export
 * @interface UserMgmtSendCustomerRegistrationInvitationUserRq
 */
export interface UserMgmtSendCustomerRegistrationInvitationUserRq {
    /**
     * user uuid
     * @type {string}
     * @memberof UserMgmtSendCustomerRegistrationInvitationUserRq
     */
    'userUuid'?: string | null;
    /**
     * user email
     * @type {string}
     * @memberof UserMgmtSendCustomerRegistrationInvitationUserRq
     */
    'email'?: string | null;
}
/**
 * User Mgmt Send Staff Registration Invitation Rq Model
 * @export
 * @interface UserMgmtSendStaffRegistrationInvitationRq
 */
export interface UserMgmtSendStaffRegistrationInvitationRq {
    /**
     * 申請 email 清單
     * @type {Array<string>}
     * @memberof UserMgmtSendStaffRegistrationInvitationRq
     */
    'emailList'?: Array<string> | null;
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtSendStaffRegistrationInvitationRq
     */
    'role'?: UserMgmtQueryStaffType;
}


/**
 * User Mgmt Staff Export All Rq Model
 * @export
 * @interface UserMgmtStaffExportAllRq
 */
export interface UserMgmtStaffExportAllRq {
    /**
     * 關鍵字搜尋
     * @type {string}
     * @memberof UserMgmtStaffExportAllRq
     */
    'term'?: string | null;
    /**
     * 
     * @type {UserMgmtQueryStaffType}
     * @memberof UserMgmtStaffExportAllRq
     */
    'role'?: UserMgmtQueryStaffType | null;
    /**
     * 業務分類
     * @type {Array<UserQueryStaffMemberBusinessCategory>}
     * @memberof UserMgmtStaffExportAllRq
     */
    'businessCategory'?: Array<UserQueryStaffMemberBusinessCategory> | null;
    /**
     * 
     * @type {UserQueryStaffMemberSortingFields}
     * @memberof UserMgmtStaffExportAllRq
     */
    'sortingField'?: UserQueryStaffMemberSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtStaffExportAllRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User Mgmt Staff Export Selected Rq Model
 * @export
 * @interface UserMgmtStaffExportSelectedRq
 */
export interface UserMgmtStaffExportSelectedRq {
    /**
     * User Uuid List
     * @type {Array<string>}
     * @memberof UserMgmtStaffExportSelectedRq
     */
    'userUuidList'?: Array<string> | null;
    /**
     * 
     * @type {UserQueryStaffMemberSortingFields}
     * @memberof UserMgmtStaffExportSelectedRq
     */
    'sortingField'?: UserQueryStaffMemberSortingFields | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof UserMgmtStaffExportSelectedRq
     */
    'sortingFieldDirection'?: SortDirection | null;
}


/**
 * User Mgmt Staff Membe Companyr Rs Model
 * @export
 * @interface UserMgmtStaffMembeCompanyrRs
 */
export interface UserMgmtStaffMembeCompanyrRs {
    /**
     * 公司 uuid
     * @type {string}
     * @memberof UserMgmtStaffMembeCompanyrRs
     */
    'companyUuid'?: string;
    /**
     * 公司名稱
     * @type {string}
     * @memberof UserMgmtStaffMembeCompanyrRs
     */
    'companyName'?: string | null;
}
/**
 * User Query Staff Member Rs Model
 * @export
 * @interface UserMgmtStaffMemberRs
 */
export interface UserMgmtStaffMemberRs {
    /**
     * 使用者 uuid
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'userUuid'?: string;
    /**
     * 使用者名稱
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'userName'?: string | null;
    /**
     * 使用者 email
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'email'?: string | null;
    /**
     * 使用者電話
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'phone'?: string | null;
    /**
     * 照片連結
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'photoUrl'?: string | null;
    /**
     * 使用者狀態 (display name)
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'userStatusDisplayName'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserMgmtStaffMemberRs
     */
    'userStatusCode'?: UserStatus;
    /**
     * 使用者 role name
     * @type {string}
     * @memberof UserMgmtStaffMemberRs
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {SystemUserRole}
     * @memberof UserMgmtStaffMemberRs
     */
    'roleId'?: SystemUserRole;
    /**
     * 業務-公司列表
     * @type {Array<UserMgmtStaffMembeCompanyrRs>}
     * @memberof UserMgmtStaffMemberRs
     */
    'contractCompanyList'?: Array<UserMgmtStaffMembeCompanyrRs> | null;
    /**
     * 編輯-公司列表
     * @type {Array<UserMgmtStaffMembeCompanyrRs>}
     * @memberof UserMgmtStaffMemberRs
     */
    'operatorCompanyList'?: Array<UserMgmtStaffMembeCompanyrRs> | null;
}


/**
 * User Query Subtotal Rs Model
 * @export
 * @interface UserMgmtStaffMemberSubtotalRs
 */
export interface UserMgmtStaffMemberSubtotalRs {
    /**
     * 管理人員總數
     * @type {number}
     * @memberof UserMgmtStaffMemberSubtotalRs
     */
    'staffMemberCount'?: number;
}
/**
 * User Mgmt Transfer Staff Permission Rq Model
 * @export
 * @interface UserMgmtTransferStaffPermissionRq
 */
export interface UserMgmtTransferStaffPermissionRq {
    /**
     * 來源用戶
     * @type {string}
     * @memberof UserMgmtTransferStaffPermissionRq
     */
    'sourceUserUuid'?: string;
    /**
     * 目標用戶
     * @type {string}
     * @memberof UserMgmtTransferStaffPermissionRq
     */
    'targetUserUuid'?: string;
    /**
     * 刪除來源用戶
     * @type {boolean}
     * @memberof UserMgmtTransferStaffPermissionRq
     */
    'deleteSourceUserAccount'?: boolean;
}
/**
 * UserMgmt Verify Current User As Company Contact Rs Model
 * @export
 * @interface UserMgmtVerifyCurrentUserAsCompanyContactRs
 */
export interface UserMgmtVerifyCurrentUserAsCompanyContactRs {
    /**
     * 登入者是否為公司業務
     * @type {boolean}
     * @memberof UserMgmtVerifyCurrentUserAsCompanyContactRs
     */
    'isCurrentUserCompanyContact'?: boolean;
}
/**
 * User Profile BindSso Token Rq Model
 * @export
 * @interface UserProfileBindSsoTokenRq
 */
export interface UserProfileBindSsoTokenRq {
    /**
     * 綁定目標的 accesss token
     * @type {string}
     * @memberof UserProfileBindSsoTokenRq
     */
    'bindAccessToken'?: string | null;
}
/**
 * User Profile Delete Current User Bind Sso Account Rq Model
 * @export
 * @interface UserProfileDeleteCurrentUserBindSsoAccountRq
 */
export interface UserProfileDeleteCurrentUserBindSsoAccountRq {
    /**
     * Provider Id
     * @type {string}
     * @memberof UserProfileDeleteCurrentUserBindSsoAccountRq
     */
    'providerId'?: string;
    /**
     * 
     * @type {AuthProvider}
     * @memberof UserProfileDeleteCurrentUserBindSsoAccountRq
     */
    'provider'?: AuthProvider;
}


/**
 * User Profile Get Current User Bind Sso Accounts Rs Model
 * @export
 * @interface UserProfileGetCurrentUserBindSsoAccountsRs
 */
export interface UserProfileGetCurrentUserBindSsoAccountsRs {
    /**
     * Provider Id
     * @type {string}
     * @memberof UserProfileGetCurrentUserBindSsoAccountsRs
     */
    'providerId'?: string;
    /**
     * 
     * @type {AuthProvider}
     * @memberof UserProfileGetCurrentUserBindSsoAccountsRs
     */
    'provider'?: AuthProvider;
}


/**
 * User Profile Query Summary Rs Model
 * @export
 * @interface UserProfileQuerySummaryRs
 */
export interface UserProfileQuerySummaryRs {
    /**
     * 所有帳號數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'accountTotalCount'?: number;
    /**
     * 管理人員 數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'staffMemberCount'?: number;
    /**
     * 管理者數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'adminCount'?: number;
    /**
     * super user 數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'superUserCount'?: number;
    /**
     * user 數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'userCount'?: number;
    /**
     * 客戶 數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'customerCount'?: number;
    /**
     * 公司總數量
     * @type {number}
     * @memberof UserProfileQuerySummaryRs
     */
    'companyTotalCount'?: number;
}
/**
 * UserQueryCustomerUserSortingFields  0 = None (None)  1 = UserName (使用者姓名)  2 = UserStatus (帳號狀態)  3 = Creator (邀請人)
 * @export
 * @enum {string}
 */

export const UserQueryCustomerUserSortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 使用者姓名
    */
    UserName: 1,
    /**
    * 帳號狀態
    */
    UserStatus: 2,
    /**
    * 邀請人
    */
    Creator: 3
} as const;

export type UserQueryCustomerUserSortingFields = typeof UserQueryCustomerUserSortingFields[keyof typeof UserQueryCustomerUserSortingFields];


/**
 * 人員業務分類  0 = None (None)  1 = Contract (公司業務)  2 = Operator (操作者(編輯))
 * @export
 * @enum {string}
 */

export const UserQueryStaffMemberBusinessCategory = {
    /**
    * None
    */
    None: 0,
    /**
    * 公司業務
    */
    Contract: 1,
    /**
    * 操作者(編輯)
    */
    Operator: 2
} as const;

export type UserQueryStaffMemberBusinessCategory = typeof UserQueryStaffMemberBusinessCategory[keyof typeof UserQueryStaffMemberBusinessCategory];


/**
 * UserQueryStaffMemberSortingFields  0 = None (None)  1 = UserName (使用者姓名)  2 = UserRole (使用者角色)  3 = UserStatus (帳號狀態)
 * @export
 * @enum {string}
 */

export const UserQueryStaffMemberSortingFields = {
    /**
    * None
    */
    None: 0,
    /**
    * 使用者姓名
    */
    UserName: 1,
    /**
    * 使用者角色
    */
    UserRole: 2,
    /**
    * 帳號狀態
    */
    UserStatus: 3
} as const;

export type UserQueryStaffMemberSortingFields = typeof UserQueryStaffMemberSortingFields[keyof typeof UserQueryStaffMemberSortingFields];


/**
 * UserResendConfirmEmail Rq Model
 * @export
 * @interface UserResendConfirmEmailRq
 */
export interface UserResendConfirmEmailRq {
    /**
     * user uuids
     * @type {Array<string>}
     * @memberof UserResendConfirmEmailRq
     */
    'userUuids'?: Array<string> | null;
}
/**
 * 使用者狀態  0 = None (None)  1 = Inactive (未啟用)  2 = Active (啟用)
 * @export
 * @enum {string}
 */

export const UserStatus = {
    /**
    * None
    */
    None: 0,
    /**
    * 未啟用
    */
    Inactive: 1,
    /**
    * 啟用
    */
    Active: 2
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];



/**
 * BatchesBigQueryApi - axios parameter creator
 * @export
 */
export const BatchesBigQueryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryRefreshbigqueryprojectschedules: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/BigQuery/RefreshBigQueryProjectSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryRefreshshorturlconversions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/BigQuery/RefreshShortUrlConversions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 測試刷新短網址轉換數 (DEV專用)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryTestrefreshshorturlconversions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/BigQuery/TestRefreshShortUrlConversions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchesBigQueryApi - functional programming interface
 * @export
 */
export const BatchesBigQueryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchesBigQueryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bigqueryRefreshbigqueryprojectschedules(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bigqueryRefreshbigqueryprojectschedules(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesBigQueryApi.bigqueryRefreshbigqueryprojectschedules']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bigqueryRefreshshorturlconversions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bigqueryRefreshshorturlconversions(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesBigQueryApi.bigqueryRefreshshorturlconversions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 測試刷新短網址轉換數 (DEV專用)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bigqueryTestrefreshshorturlconversions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bigqueryTestrefreshshorturlconversions(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesBigQueryApi.bigqueryTestrefreshshorturlconversions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BatchesBigQueryApi - factory interface
 * @export
 */
export const BatchesBigQueryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchesBigQueryApiFp(configuration)
    return {
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryRefreshbigqueryprojectschedules(options?: any): AxiosPromise<void> {
            return localVarFp.bigqueryRefreshbigqueryprojectschedules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryRefreshshorturlconversions(options?: any): AxiosPromise<void> {
            return localVarFp.bigqueryRefreshshorturlconversions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 測試刷新短網址轉換數 (DEV專用)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryTestrefreshshorturlconversions(options?: any): AxiosPromise<void> {
            return localVarFp.bigqueryTestrefreshshorturlconversions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchesBigQueryApi - object-oriented interface
 * @export
 * @class BatchesBigQueryApi
 * @extends {BaseAPI}
 */
export class BatchesBigQueryApi extends BaseAPI {
    /**
     * 
     * @summary 刷新BigQuery專案排程
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesBigQueryApi
     */
    public bigqueryRefreshbigqueryprojectschedules(options?: AxiosRequestConfig) {
        return BatchesBigQueryApiFp(this.configuration).bigqueryRefreshbigqueryprojectschedules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新短網址轉換數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesBigQueryApi
     */
    public bigqueryRefreshshorturlconversions(options?: AxiosRequestConfig) {
        return BatchesBigQueryApiFp(this.configuration).bigqueryRefreshshorturlconversions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 測試刷新短網址轉換數 (DEV專用)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesBigQueryApi
     */
    public bigqueryTestrefreshshorturlconversions(options?: AxiosRequestConfig) {
        return BatchesBigQueryApiFp(this.configuration).bigqueryTestrefreshshorturlconversions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BatchesCommonApi - axios parameter creator
 * @export
 */
export const BatchesCommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshallprestatsclicks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/RefreshAllPreStatsClicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshorgsubtagconversion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/RefreshOrgSubtagConversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 訂閱狀態刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshsubscriptionandstatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/RefreshSubscriptionAndStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshsubtagma14stats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/RefreshSubtagMa14Stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移除逾期 (default create time 30 days) 短網址檢視 IP 清單, 此清單跟不重複檢視有關
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRemoveexpiredshorturlvisitorips: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/RemoveExpiredShortUrlVisitorIps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 目的: 當不重複點擊數據 > 重複點擊數據，需要把兩邊數字拉齊
         * @summary 同步短網址點擊數跟不重複點擊數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonSyncshorturlclickcount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Common/SyncShortUrlClickCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchesCommonApi - functional programming interface
 * @export
 */
export const BatchesCommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchesCommonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonRefreshallprestatsclicks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonRefreshallprestatsclicks(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonRefreshallprestatsclicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonRefreshorgsubtagconversion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonRefreshorgsubtagconversion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonRefreshorgsubtagconversion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 訂閱狀態刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonRefreshsubscriptionandstatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonRefreshsubscriptionandstatus(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonRefreshsubscriptionandstatus']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonRefreshsubtagma14stats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonRefreshsubtagma14stats(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonRefreshsubtagma14stats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 移除逾期 (default create time 30 days) 短網址檢視 IP 清單, 此清單跟不重複檢視有關
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonRemoveexpiredshorturlvisitorips(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonRemoveexpiredshorturlvisitorips(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonRemoveexpiredshorturlvisitorips']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 目的: 當不重複點擊數據 > 重複點擊數據，需要把兩邊數字拉齊
         * @summary 同步短網址點擊數跟不重複點擊數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonSyncshorturlclickcount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonSyncshorturlclickcount(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesCommonApi.commonSyncshorturlclickcount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BatchesCommonApi - factory interface
 * @export
 */
export const BatchesCommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchesCommonApiFp(configuration)
    return {
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshallprestatsclicks(options?: any): AxiosPromise<void> {
            return localVarFp.commonRefreshallprestatsclicks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshorgsubtagconversion(options?: any): AxiosPromise<void> {
            return localVarFp.commonRefreshorgsubtagconversion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 訂閱狀態刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshsubscriptionandstatus(options?: any): AxiosPromise<void> {
            return localVarFp.commonRefreshsubscriptionandstatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRefreshsubtagma14stats(options?: any): AxiosPromise<void> {
            return localVarFp.commonRefreshsubtagma14stats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移除逾期 (default create time 30 days) 短網址檢視 IP 清單, 此清單跟不重複檢視有關
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonRemoveexpiredshorturlvisitorips(options?: any): AxiosPromise<void> {
            return localVarFp.commonRemoveexpiredshorturlvisitorips(options).then((request) => request(axios, basePath));
        },
        /**
         * 目的: 當不重複點擊數據 > 重複點擊數據，需要把兩邊數字拉齊
         * @summary 同步短網址點擊數跟不重複點擊數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonSyncshorturlclickcount(options?: any): AxiosPromise<void> {
            return localVarFp.commonSyncshorturlclickcount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchesCommonApi - object-oriented interface
 * @export
 * @class BatchesCommonApi
 * @extends {BaseAPI}
 */
export class BatchesCommonApi extends BaseAPI {
    /**
     * 
     * @summary 刷新全部預先統計資料表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonRefreshallprestatsclicks(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonRefreshallprestatsclicks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新預先統計組織受眾標籤轉換數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonRefreshorgsubtagconversion(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonRefreshorgsubtagconversion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 訂閱狀態刷新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonRefreshsubscriptionandstatus(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonRefreshsubscriptionandstatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonRefreshsubtagma14stats(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonRefreshsubtagma14stats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移除逾期 (default create time 30 days) 短網址檢視 IP 清單, 此清單跟不重複檢視有關
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonRemoveexpiredshorturlvisitorips(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonRemoveexpiredshorturlvisitorips(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 目的: 當不重複點擊數據 > 重複點擊數據，需要把兩邊數字拉齊
     * @summary 同步短網址點擊數跟不重複點擊數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesCommonApi
     */
    public commonSyncshorturlclickcount(options?: AxiosRequestConfig) {
        return BatchesCommonApiFp(this.configuration).commonSyncshorturlclickcount(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BatchesGaApi - axios parameter creator
 * @export
 */
export const BatchesGaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ga 資料刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gaGadatatest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Ga/GaDataTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ga 資料刷新
         * @param {GaDataUpdateRq} [gaDataUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gaGadataupdate: async (gaDataUpdateRq?: GaDataUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Batches/Ga/GaDataUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gaDataUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchesGaApi - functional programming interface
 * @export
 */
export const BatchesGaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchesGaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ga 資料刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gaGadatatest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gaGadatatest(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesGaApi.gaGadatatest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary ga 資料刷新
         * @param {GaDataUpdateRq} [gaDataUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gaGadataupdate(gaDataUpdateRq?: GaDataUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gaGadataupdate(gaDataUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BatchesGaApi.gaGadataupdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BatchesGaApi - factory interface
 * @export
 */
export const BatchesGaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchesGaApiFp(configuration)
    return {
        /**
         * 
         * @summary ga 資料刷新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gaGadatatest(options?: any): AxiosPromise<void> {
            return localVarFp.gaGadatatest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ga 資料刷新
         * @param {GaDataUpdateRq} [gaDataUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gaGadataupdate(gaDataUpdateRq?: GaDataUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.gaGadataupdate(gaDataUpdateRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchesGaApi - object-oriented interface
 * @export
 * @class BatchesGaApi
 * @extends {BaseAPI}
 */
export class BatchesGaApi extends BaseAPI {
    /**
     * 
     * @summary ga 資料刷新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesGaApi
     */
    public gaGadatatest(options?: AxiosRequestConfig) {
        return BatchesGaApiFp(this.configuration).gaGadatatest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ga 資料刷新
     * @param {GaDataUpdateRq} [gaDataUpdateRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesGaApi
     */
    public gaGadataupdate(gaDataUpdateRq?: GaDataUpdateRq, options?: AxiosRequestConfig) {
        return BatchesGaApiFp(this.configuration).gaGadataupdate(gaDataUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommonIdentityPickerApi - axios parameter creator
 * @export
 */
export const CommonIdentityPickerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Identities
         * @param {string} [term] 關鍵字查詢
         * @param {IdentityPickerType} [type] 查詢類型  0 &#x3D; None (None)  1 &#x3D; CompanyContact (公司業務)  2 &#x3D; CompanyOwner (公司負責人)  3 &#x3D; CompanyOperator (公司操作者)  4 &#x3D; Guest (一般用戶)
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identitypickerIdentities: async (term?: string, type?: IdentityPickerType, companyUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/IdentityPicker/Identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 會員頭像 (cache 30 days)
         * @param {string} userUuid uuid
         * @param {string} photoCode photoCode
         * @param {ThumbnailSize} [size] size  0 &#x3D; None (None)  1 &#x3D; Small (Small)  2 &#x3D; Large (Large)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identitypickerMemberavatars: async (userUuid: string, photoCode: string, size?: ThumbnailSize, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('identitypickerMemberavatars', 'userUuid', userUuid)
            // verify required parameter 'photoCode' is not null or undefined
            assertParamExists('identitypickerMemberavatars', 'photoCode', photoCode)
            const localVarPath = `/Common/IdentityPicker/MemberAvatars/{userUuid}/{photoCode}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)))
                .replace(`{${"photoCode"}}`, encodeURIComponent(String(photoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonIdentityPickerApi - functional programming interface
 * @export
 */
export const CommonIdentityPickerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonIdentityPickerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Identities
         * @param {string} [term] 關鍵字查詢
         * @param {IdentityPickerType} [type] 查詢類型  0 &#x3D; None (None)  1 &#x3D; CompanyContact (公司業務)  2 &#x3D; CompanyOwner (公司負責人)  3 &#x3D; CompanyOperator (公司操作者)  4 &#x3D; Guest (一般用戶)
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identitypickerIdentities(term?: string, type?: IdentityPickerType, companyUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdentityInfoModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identitypickerIdentities(term, type, companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonIdentityPickerApi.identitypickerIdentities']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 會員頭像 (cache 30 days)
         * @param {string} userUuid uuid
         * @param {string} photoCode photoCode
         * @param {ThumbnailSize} [size] size  0 &#x3D; None (None)  1 &#x3D; Small (Small)  2 &#x3D; Large (Large)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identitypickerMemberavatars(userUuid: string, photoCode: string, size?: ThumbnailSize, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identitypickerMemberavatars(userUuid, photoCode, size, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonIdentityPickerApi.identitypickerMemberavatars']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommonIdentityPickerApi - factory interface
 * @export
 */
export const CommonIdentityPickerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonIdentityPickerApiFp(configuration)
    return {
        /**
         * 
         * @summary Identities
         * @param {string} [term] 關鍵字查詢
         * @param {IdentityPickerType} [type] 查詢類型  0 &#x3D; None (None)  1 &#x3D; CompanyContact (公司業務)  2 &#x3D; CompanyOwner (公司負責人)  3 &#x3D; CompanyOperator (公司操作者)  4 &#x3D; Guest (一般用戶)
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identitypickerIdentities(term?: string, type?: IdentityPickerType, companyUuid?: string, options?: any): AxiosPromise<Array<IdentityInfoModel>> {
            return localVarFp.identitypickerIdentities(term, type, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 會員頭像 (cache 30 days)
         * @param {string} userUuid uuid
         * @param {string} photoCode photoCode
         * @param {ThumbnailSize} [size] size  0 &#x3D; None (None)  1 &#x3D; Small (Small)  2 &#x3D; Large (Large)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identitypickerMemberavatars(userUuid: string, photoCode: string, size?: ThumbnailSize, options?: any): AxiosPromise<void> {
            return localVarFp.identitypickerMemberavatars(userUuid, photoCode, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonIdentityPickerApi - object-oriented interface
 * @export
 * @class CommonIdentityPickerApi
 * @extends {BaseAPI}
 */
export class CommonIdentityPickerApi extends BaseAPI {
    /**
     * 
     * @summary Identities
     * @param {string} [term] 關鍵字查詢
     * @param {IdentityPickerType} [type] 查詢類型  0 &#x3D; None (None)  1 &#x3D; CompanyContact (公司業務)  2 &#x3D; CompanyOwner (公司負責人)  3 &#x3D; CompanyOperator (公司操作者)  4 &#x3D; Guest (一般用戶)
     * @param {string} [companyUuid] 公司 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonIdentityPickerApi
     */
    public identitypickerIdentities(term?: string, type?: IdentityPickerType, companyUuid?: string, options?: AxiosRequestConfig) {
        return CommonIdentityPickerApiFp(this.configuration).identitypickerIdentities(term, type, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 會員頭像 (cache 30 days)
     * @param {string} userUuid uuid
     * @param {string} photoCode photoCode
     * @param {ThumbnailSize} [size] size  0 &#x3D; None (None)  1 &#x3D; Small (Small)  2 &#x3D; Large (Large)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonIdentityPickerApi
     */
    public identitypickerMemberavatars(userUuid: string, photoCode: string, size?: ThumbnailSize, options?: AxiosRequestConfig) {
        return CommonIdentityPickerApiFp(this.configuration).identitypickerMemberavatars(userUuid, photoCode, size, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommonOptionsApi - axios parameter creator
 * @export
 */
export const CommonOptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 基本檔代碼
         * @param {PROMCodeTypes} [type] 代碼類別  0 &#x3D; None (None)  1 &#x3D; CompanySubscriptionType (公司訂閱類型)  2 &#x3D; CompanyStatus (公司狀態)  3 &#x3D; CompanyDataInputType (公司資料輸入類別)  4 &#x3D; UserStatus (使用者狀態)  5 &#x3D; DataStatus (資料狀態)  6 &#x3D; OrganizationMemberRole (組織成員角色)  7 &#x3D; ShortLinkProcessStatus (短網址處理狀態)  8 &#x3D; UserChangePasswordProcess (使用者密碼變更進程)  9 &#x3D; AuthProvider (單一登入類型)  11 &#x3D; PaymentCycles (計價區間)  12 &#x3D; DomainStatus (Domain 狀態)  13 &#x3D; UrlType (網址類別)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycodes: async (type?: PROMCodeTypes, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/Options/QueryCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司清單 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycompanies: async (term?: string, companyUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/Options/QueryCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司組織清單 (top 20)
         * @param {string} companyUuid 公司 uuid
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycompanyorganizations: async (companyUuid: string, term?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('optionsQuerycompanyorganizations', 'companyUuid', companyUuid)
            const localVarPath = `/Common/Options/QueryCompanyOrganizations/{companyUuid}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢主標籤 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerymaintag: async (term?: string, mainTagId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/Options/QueryMainTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (mainTagId !== undefined) {
                localVarQueryParameter['mainTagId'] = mainTagId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢人員選項
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerystaffoptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/Options/QueryStaffOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢子標籤 (完整列表)
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerysubtag: async (mainTagId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/Options/QuerySubTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mainTagId !== undefined) {
                localVarQueryParameter['mainTagId'] = mainTagId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonOptionsApi - functional programming interface
 * @export
 */
export const CommonOptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonOptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 基本檔代碼
         * @param {PROMCodeTypes} [type] 代碼類別  0 &#x3D; None (None)  1 &#x3D; CompanySubscriptionType (公司訂閱類型)  2 &#x3D; CompanyStatus (公司狀態)  3 &#x3D; CompanyDataInputType (公司資料輸入類別)  4 &#x3D; UserStatus (使用者狀態)  5 &#x3D; DataStatus (資料狀態)  6 &#x3D; OrganizationMemberRole (組織成員角色)  7 &#x3D; ShortLinkProcessStatus (短網址處理狀態)  8 &#x3D; UserChangePasswordProcess (使用者密碼變更進程)  9 &#x3D; AuthProvider (單一登入類型)  11 &#x3D; PaymentCycles (計價區間)  12 &#x3D; DomainStatus (Domain 狀態)  13 &#x3D; UrlType (網址類別)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerycodes(type?: PROMCodeTypes, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerycodes(type, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerycodes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司清單 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerycompanies(term?: string, companyUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionCompanyRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerycompanies(term, companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerycompanies']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司組織清單 (top 20)
         * @param {string} companyUuid 公司 uuid
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerycompanyorganizations(companyUuid: string, term?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionCompanyOrgRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerycompanyorganizations(companyUuid, term, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerycompanyorganizations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢主標籤 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerymaintag(term?: string, mainTagId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerymaintag(term, mainTagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerymaintag']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢人員選項
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerystaffoptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerystaffoptions(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerystaffoptions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢子標籤 (完整列表)
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optionsQuerysubtag(mainTagId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionSubTagRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optionsQuerysubtag(mainTagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonOptionsApi.optionsQuerysubtag']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommonOptionsApi - factory interface
 * @export
 */
export const CommonOptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonOptionsApiFp(configuration)
    return {
        /**
         * 
         * @summary 基本檔代碼
         * @param {PROMCodeTypes} [type] 代碼類別  0 &#x3D; None (None)  1 &#x3D; CompanySubscriptionType (公司訂閱類型)  2 &#x3D; CompanyStatus (公司狀態)  3 &#x3D; CompanyDataInputType (公司資料輸入類別)  4 &#x3D; UserStatus (使用者狀態)  5 &#x3D; DataStatus (資料狀態)  6 &#x3D; OrganizationMemberRole (組織成員角色)  7 &#x3D; ShortLinkProcessStatus (短網址處理狀態)  8 &#x3D; UserChangePasswordProcess (使用者密碼變更進程)  9 &#x3D; AuthProvider (單一登入類型)  11 &#x3D; PaymentCycles (計價區間)  12 &#x3D; DomainStatus (Domain 狀態)  13 &#x3D; UrlType (網址類別)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycodes(type?: PROMCodeTypes, options?: any): AxiosPromise<Array<OptionModel>> {
            return localVarFp.optionsQuerycodes(type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司清單 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {string} [companyUuid] 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycompanies(term?: string, companyUuid?: string, options?: any): AxiosPromise<Array<OptionCompanyRs>> {
            return localVarFp.optionsQuerycompanies(term, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司組織清單 (top 20)
         * @param {string} companyUuid 公司 uuid
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerycompanyorganizations(companyUuid: string, term?: string, options?: any): AxiosPromise<Array<OptionCompanyOrgRs>> {
            return localVarFp.optionsQuerycompanyorganizations(companyUuid, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢主標籤 (top 20)
         * @param {string} [term] 關鍵字查詢
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerymaintag(term?: string, mainTagId?: number, options?: any): AxiosPromise<Array<OptionModel>> {
            return localVarFp.optionsQuerymaintag(term, mainTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢人員選項
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerystaffoptions(options?: any): AxiosPromise<Array<OptionModel>> {
            return localVarFp.optionsQuerystaffoptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢子標籤 (完整列表)
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optionsQuerysubtag(mainTagId?: number, options?: any): AxiosPromise<Array<OptionSubTagRs>> {
            return localVarFp.optionsQuerysubtag(mainTagId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonOptionsApi - object-oriented interface
 * @export
 * @class CommonOptionsApi
 * @extends {BaseAPI}
 */
export class CommonOptionsApi extends BaseAPI {
    /**
     * 
     * @summary 基本檔代碼
     * @param {PROMCodeTypes} [type] 代碼類別  0 &#x3D; None (None)  1 &#x3D; CompanySubscriptionType (公司訂閱類型)  2 &#x3D; CompanyStatus (公司狀態)  3 &#x3D; CompanyDataInputType (公司資料輸入類別)  4 &#x3D; UserStatus (使用者狀態)  5 &#x3D; DataStatus (資料狀態)  6 &#x3D; OrganizationMemberRole (組織成員角色)  7 &#x3D; ShortLinkProcessStatus (短網址處理狀態)  8 &#x3D; UserChangePasswordProcess (使用者密碼變更進程)  9 &#x3D; AuthProvider (單一登入類型)  11 &#x3D; PaymentCycles (計價區間)  12 &#x3D; DomainStatus (Domain 狀態)  13 &#x3D; UrlType (網址類別)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerycodes(type?: PROMCodeTypes, options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerycodes(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司清單 (top 20)
     * @param {string} [term] 關鍵字查詢
     * @param {string} [companyUuid] 公司 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerycompanies(term?: string, companyUuid?: string, options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerycompanies(term, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司組織清單 (top 20)
     * @param {string} companyUuid 公司 uuid
     * @param {string} [term] 關鍵字查詢
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerycompanyorganizations(companyUuid: string, term?: string, options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerycompanyorganizations(companyUuid, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢主標籤 (top 20)
     * @param {string} [term] 關鍵字查詢
     * @param {number} [mainTagId] 主標籤 id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerymaintag(term?: string, mainTagId?: number, options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerymaintag(term, mainTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢人員選項
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerystaffoptions(options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerystaffoptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢子標籤 (完整列表)
     * @param {number} [mainTagId] 主標籤 id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonOptionsApi
     */
    public optionsQuerysubtag(mainTagId?: number, options?: AxiosRequestConfig) {
        return CommonOptionsApiFp(this.configuration).optionsQuerysubtag(mainTagId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommonSystemApi - axios parameter creator
 * @export
 */
export const CommonSystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 清除 portal 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemClearportalallcache: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/ClearPortalAllCache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 清除 wenk index 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemClearwenkindexallcache: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/ClearWenkIndexAllCache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 按日期計算短網址建立數量
         * @param {string} [startDate] 開始日期
         * @param {string} [endDate] 結束日期
         * @param {boolean} [includeDeleted] 包含已刪除紀錄
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemCounturlsgroupedbydate: async (startDate?: string, endDate?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/CountUrlsGroupedByDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary domain health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemDomainlivehealthcheck: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/DomainLiveHealthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 抓取系統版本資訊
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetapplicationversion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/GetApplicationVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取得系統資料更新時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetsystemdataupdatetime: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/GetSystemDataUpdateTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 預計算資料時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemPrecomputeddatatimestamp: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/PrecomputedDataTimestamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢網域關聯表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemQuerycompanydomainrelationships: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/QueryCompanyDomainRelationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshallprestatsclicks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/RefreshAllPreStatsClicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshbigqueryprojectschedules: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/RefreshBigQueryProjectSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshorgsubtagconversion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/RefreshOrgSubtagConversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshshorturlconversions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/RefreshShortUrlConversions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshsubtagma14stats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/RefreshSubtagMa14Stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刷新 今日 ga 資料
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemUpdategatodaydata: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Common/System/UpdateGaTodayData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonSystemApi - functional programming interface
 * @export
 */
export const CommonSystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonSystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 清除 portal 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemClearportalallcache(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemClearportalallcache(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemClearportalallcache']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 清除 wenk index 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemClearwenkindexallcache(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemClearwenkindexallcache(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemClearwenkindexallcache']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 按日期計算短網址建立數量
         * @param {string} [startDate] 開始日期
         * @param {string} [endDate] 結束日期
         * @param {boolean} [includeDeleted] 包含已刪除紀錄
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemCounturlsgroupedbydate(startDate?: string, endDate?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemCountUrlsGroupedByDateRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemCounturlsgroupedbydate(startDate, endDate, includeDeleted, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemCounturlsgroupedbydate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary domain health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemDomainlivehealthcheck(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemDomainHealthCheckRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemDomainlivehealthcheck(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemDomainlivehealthcheck']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 抓取系統版本資訊
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemGetapplicationversion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppInfoApiRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemGetapplicationversion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemGetapplicationversion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 取得系統資料更新時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemGetsystemdataupdatetime(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemJobRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemGetsystemdataupdatetime(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemGetsystemdataupdatetime']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 預計算資料時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemPrecomputeddatatimestamp(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrecomputedDataTimestampRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemPrecomputeddatatimestamp(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemPrecomputeddatatimestamp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢網域關聯表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemQuerycompanydomainrelationships(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemCompanyDomainRelationshipRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemQuerycompanydomainrelationships(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemQuerycompanydomainrelationships']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemRefreshallprestatsclicks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemRefreshallprestatsclicks(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemRefreshallprestatsclicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemRefreshbigqueryprojectschedules(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemRefreshbigqueryprojectschedules(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemRefreshbigqueryprojectschedules']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemRefreshorgsubtagconversion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemRefreshorgsubtagconversion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemRefreshorgsubtagconversion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemRefreshshorturlconversions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemRefreshshorturlconversions(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemRefreshshorturlconversions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemRefreshsubtagma14stats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemRefreshsubtagma14stats(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemRefreshsubtagma14stats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刷新 今日 ga 資料
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemUpdategatodaydata(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemUpdategatodaydata(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommonSystemApi.systemUpdategatodaydata']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommonSystemApi - factory interface
 * @export
 */
export const CommonSystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonSystemApiFp(configuration)
    return {
        /**
         * 
         * @summary 清除 portal 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemClearportalallcache(options?: any): AxiosPromise<void> {
            return localVarFp.systemClearportalallcache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 清除 wenk index 所有快取
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemClearwenkindexallcache(options?: any): AxiosPromise<void> {
            return localVarFp.systemClearwenkindexallcache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 按日期計算短網址建立數量
         * @param {string} [startDate] 開始日期
         * @param {string} [endDate] 結束日期
         * @param {boolean} [includeDeleted] 包含已刪除紀錄
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemCounturlsgroupedbydate(startDate?: string, endDate?: string, includeDeleted?: boolean, options?: any): AxiosPromise<Array<SystemCountUrlsGroupedByDateRs>> {
            return localVarFp.systemCounturlsgroupedbydate(startDate, endDate, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary domain health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemDomainlivehealthcheck(options?: any): AxiosPromise<Array<SystemDomainHealthCheckRs>> {
            return localVarFp.systemDomainlivehealthcheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 抓取系統版本資訊
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetapplicationversion(options?: any): AxiosPromise<Array<AppInfoApiRs>> {
            return localVarFp.systemGetapplicationversion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取得系統資料更新時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetsystemdataupdatetime(options?: any): AxiosPromise<Array<SystemJobRs>> {
            return localVarFp.systemGetsystemdataupdatetime(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 預計算資料時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemPrecomputeddatatimestamp(options?: any): AxiosPromise<PrecomputedDataTimestampRs> {
            return localVarFp.systemPrecomputeddatatimestamp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢網域關聯表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemQuerycompanydomainrelationships(options?: any): AxiosPromise<Array<SystemCompanyDomainRelationshipRs>> {
            return localVarFp.systemQuerycompanydomainrelationships(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新全部預先統計資料表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshallprestatsclicks(options?: any): AxiosPromise<void> {
            return localVarFp.systemRefreshallprestatsclicks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新BigQuery專案排程
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshbigqueryprojectschedules(options?: any): AxiosPromise<void> {
            return localVarFp.systemRefreshbigqueryprojectschedules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新預先統計組織受眾標籤轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshorgsubtagconversion(options?: any): AxiosPromise<void> {
            return localVarFp.systemRefreshorgsubtagconversion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新短網址轉換數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshshorturlconversions(options?: any): AxiosPromise<void> {
            return localVarFp.systemRefreshshorturlconversions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemRefreshsubtagma14stats(options?: any): AxiosPromise<void> {
            return localVarFp.systemRefreshsubtagma14stats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刷新 今日 ga 資料
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemUpdategatodaydata(options?: any): AxiosPromise<void> {
            return localVarFp.systemUpdategatodaydata(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonSystemApi - object-oriented interface
 * @export
 * @class CommonSystemApi
 * @extends {BaseAPI}
 */
export class CommonSystemApi extends BaseAPI {
    /**
     * 
     * @summary 清除 portal 所有快取
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemClearportalallcache(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemClearportalallcache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 清除 wenk index 所有快取
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemClearwenkindexallcache(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemClearwenkindexallcache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 按日期計算短網址建立數量
     * @param {string} [startDate] 開始日期
     * @param {string} [endDate] 結束日期
     * @param {boolean} [includeDeleted] 包含已刪除紀錄
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemCounturlsgroupedbydate(startDate?: string, endDate?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemCounturlsgroupedbydate(startDate, endDate, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary domain health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemDomainlivehealthcheck(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemDomainlivehealthcheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 抓取系統版本資訊
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemGetapplicationversion(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemGetapplicationversion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取得系統資料更新時間
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemGetsystemdataupdatetime(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemGetsystemdataupdatetime(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 預計算資料時間
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemPrecomputeddatatimestamp(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemPrecomputeddatatimestamp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢網域關聯表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemQuerycompanydomainrelationships(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemQuerycompanydomainrelationships(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新全部預先統計資料表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemRefreshallprestatsclicks(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemRefreshallprestatsclicks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新BigQuery專案排程
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemRefreshbigqueryprojectschedules(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemRefreshbigqueryprojectschedules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新預先統計組織受眾標籤轉換數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemRefreshorgsubtagconversion(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemRefreshorgsubtagconversion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新短網址轉換數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemRefreshshorturlconversions(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemRefreshshorturlconversions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新預先統計受眾標籤平均點擊數 (MA14 - 移動平均14日)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemRefreshsubtagma14stats(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemRefreshsubtagma14stats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刷新 今日 ga 資料
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonSystemApi
     */
    public systemUpdategatodaydata(options?: AxiosRequestConfig) {
        return CommonSystemApiFp(this.configuration).systemUpdategatodaydata(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyBillingApi - axios parameter creator
 * @export
 */
export const CompanyBillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取得帳單資訊
         * @param {BillInfoRq} [billInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetbillinfo: async (billInfoRq?: BillInfoRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Billing/GetBillInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billInfoRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司清單
         * @param {BillingCompanyInfoRq} [billingCompanyInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcompanies: async (billingCompanyInfoRq?: BillingCompanyInfoRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Billing/GetCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingCompanyInfoRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司小計
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcompanysubtotal: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Billing/GetCompanySubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取得帳單聯絡資訊
         * @param {BillingGetContactRq} [billingGetContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcontact: async (billingGetContactRq?: BillingGetContactRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Billing/GetContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingGetContactRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新帳單聯絡資訊
         * @param {BillingUpdateContactRq} [billingUpdateContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUpdatecontact: async (billingUpdateContactRq?: BillingUpdateContactRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Billing/UpdateContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingUpdateContactRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyBillingApi - functional programming interface
 * @export
 */
export const CompanyBillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyBillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取得帳單資訊
         * @param {BillInfoRq} [billInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetbillinfo(billInfoRq?: BillInfoRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetbillinfo(billInfoRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyBillingApi.billingGetbillinfo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司清單
         * @param {BillingCompanyInfoRq} [billingCompanyInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetcompanies(billingCompanyInfoRq?: BillingCompanyInfoRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillingCompanyInfoRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetcompanies(billingCompanyInfoRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyBillingApi.billingGetcompanies']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司小計
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetcompanysubtotal(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingCompanySubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetcompanysubtotal(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyBillingApi.billingGetcompanysubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 取得帳單聯絡資訊
         * @param {BillingGetContactRq} [billingGetContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingGetcontact(billingGetContactRq?: BillingGetContactRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingGetContactRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingGetcontact(billingGetContactRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyBillingApi.billingGetcontact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新帳單聯絡資訊
         * @param {BillingUpdateContactRq} [billingUpdateContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingUpdatecontact(billingUpdateContactRq?: BillingUpdateContactRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingUpdatecontact(billingUpdateContactRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyBillingApi.billingUpdatecontact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CompanyBillingApi - factory interface
 * @export
 */
export const CompanyBillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyBillingApiFp(configuration)
    return {
        /**
         * 
         * @summary 取得帳單資訊
         * @param {BillInfoRq} [billInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetbillinfo(billInfoRq?: BillInfoRq, options?: any): AxiosPromise<BillInfoRs> {
            return localVarFp.billingGetbillinfo(billInfoRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司清單
         * @param {BillingCompanyInfoRq} [billingCompanyInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcompanies(billingCompanyInfoRq?: BillingCompanyInfoRq, options?: any): AxiosPromise<Array<BillingCompanyInfoRs>> {
            return localVarFp.billingGetcompanies(billingCompanyInfoRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取得 登入使用者 負責公司小計
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcompanysubtotal(options?: any): AxiosPromise<BillingCompanySubtotalRs> {
            return localVarFp.billingGetcompanysubtotal(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取得帳單聯絡資訊
         * @param {BillingGetContactRq} [billingGetContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGetcontact(billingGetContactRq?: BillingGetContactRq, options?: any): AxiosPromise<BillingGetContactRs> {
            return localVarFp.billingGetcontact(billingGetContactRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新帳單聯絡資訊
         * @param {BillingUpdateContactRq} [billingUpdateContactRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUpdatecontact(billingUpdateContactRq?: BillingUpdateContactRq, options?: any): AxiosPromise<void> {
            return localVarFp.billingUpdatecontact(billingUpdateContactRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyBillingApi - object-oriented interface
 * @export
 * @class CompanyBillingApi
 * @extends {BaseAPI}
 */
export class CompanyBillingApi extends BaseAPI {
    /**
     * 
     * @summary 取得帳單資訊
     * @param {BillInfoRq} [billInfoRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBillingApi
     */
    public billingGetbillinfo(billInfoRq?: BillInfoRq, options?: AxiosRequestConfig) {
        return CompanyBillingApiFp(this.configuration).billingGetbillinfo(billInfoRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取得 登入使用者 負責公司清單
     * @param {BillingCompanyInfoRq} [billingCompanyInfoRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBillingApi
     */
    public billingGetcompanies(billingCompanyInfoRq?: BillingCompanyInfoRq, options?: AxiosRequestConfig) {
        return CompanyBillingApiFp(this.configuration).billingGetcompanies(billingCompanyInfoRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取得 登入使用者 負責公司小計
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBillingApi
     */
    public billingGetcompanysubtotal(options?: AxiosRequestConfig) {
        return CompanyBillingApiFp(this.configuration).billingGetcompanysubtotal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取得帳單聯絡資訊
     * @param {BillingGetContactRq} [billingGetContactRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBillingApi
     */
    public billingGetcontact(billingGetContactRq?: BillingGetContactRq, options?: AxiosRequestConfig) {
        return CompanyBillingApiFp(this.configuration).billingGetcontact(billingGetContactRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新帳單聯絡資訊
     * @param {BillingUpdateContactRq} [billingUpdateContactRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBillingApi
     */
    public billingUpdatecontact(billingUpdateContactRq?: BillingUpdateContactRq, options?: AxiosRequestConfig) {
        return CompanyBillingApiFp(this.configuration).billingUpdatecontact(billingUpdateContactRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyOrganizationsApi - axios parameter creator
 * @export
 */
export const CompanyOrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新增 - 公司 組織資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCreate: async (organizationUpdateRq?: OrganizationUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除 - 公司組織
         * @param {OrganizationDeleteRq} [organizationDeleteRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete: async (organizationDeleteRq?: OrganizationDeleteRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationDeleteRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除成員
         * @param {OrganizationDeleteMemberRq} [organizationDeleteMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDeletemember: async (organizationDeleteMemberRq?: OrganizationDeleteMemberRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/DeleteMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationDeleteMemberRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {OrganizationExportAllRq} [organizationExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsExportall: async (organizationExportAllRq?: OrganizationExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {OrganizationExportSelectedRq} [organizationExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsExportselected: async (organizationExportSelectedRq?: OrganizationExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公司 domain 選單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGetcompanydomainoption: async (companyUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/GetCompanyDomainOption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 組織資料
         * @param {string} companyOrgUuid companyOrgUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuery: async (companyOrgUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyOrgUuid' is not null or undefined
            assertParamExists('organizationsQuery', 'companyOrgUuid', companyOrgUuid)
            const localVarPath = `/Company/Organizations/Query/{companyOrgUuid}`
                .replace(`{${"companyOrgUuid"}}`, encodeURIComponent(String(companyOrgUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {OrganizationQueryAllRq} [organizationQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQueryall: async (organizationQueryAllRq?: OrganizationQueryAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/QueryAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationQueryAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerydetail: async (companyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('organizationsQuerydetail', 'companyUuid', companyUuid)
            const localVarPath = `/Company/Organizations/QueryDetail/{companyUuid}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 GA 專案清單
         * @param {string} [projectName] 專案名稱
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerygaprojects: async (projectName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/QueryGAProjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectName !== undefined) {
                localVarQueryParameter['projectName'] = projectName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {OrganizationQueryMembersRq} [organizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerymembers: async (organizationQueryMembersRq?: OrganizationQueryMembersRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/QueryMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationQueryMembersRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {OrganizationQuerySubtotalRq} [organizationQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerysubtotal: async (organizationQuerySubtotalRq?: OrganizationQuerySubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/QuerySubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationQuerySubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {OrganizationSendRegistrationInvitationRq} [organizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsSendregistrationinvitation: async (organizationSendRegistrationInvitationRq?: OrganizationSendRegistrationInvitationRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/SendRegistrationInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationSendRegistrationInvitationRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdate: async (organizationUpdateRq?: OrganizationUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新成員權限
         * @param {OrganizationUpdateMemberPermissionRq} [organizationUpdateMemberPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdatememberpermission: async (organizationUpdateMemberPermissionRq?: OrganizationUpdateMemberPermissionRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Organizations/UpdateMemberPermission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdateMemberPermissionRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyOrganizationsApi - functional programming interface
 * @export
 */
export const CompanyOrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyOrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新增 - 公司 組織資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsCreate(organizationUpdateRq?: OrganizationUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUpdateRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsCreate(organizationUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除 - 公司組織
         * @param {OrganizationDeleteRq} [organizationDeleteRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsDelete(organizationDeleteRq?: OrganizationDeleteRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsDelete(organizationDeleteRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除成員
         * @param {OrganizationDeleteMemberRq} [organizationDeleteMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsDeletemember(organizationDeleteMemberRq?: OrganizationDeleteMemberRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsDeletemember(organizationDeleteMemberRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsDeletemember']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {OrganizationExportAllRq} [organizationExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsExportall(organizationExportAllRq?: OrganizationExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsExportall(organizationExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {OrganizationExportSelectedRq} [organizationExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsExportselected(organizationExportSelectedRq?: OrganizationExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsExportselected(organizationExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 公司 domain 選單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsGetcompanydomainoption(companyUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationGetCompanyDomainOptionRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsGetcompanydomainoption(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsGetcompanydomainoption']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 組織資料
         * @param {string} companyOrgUuid companyOrgUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQuery(companyOrgUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OraanizationInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQuery(companyOrgUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {OrganizationQueryAllRq} [organizationQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQueryall(organizationQueryAllRq?: OrganizationQueryAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationQueryAllRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQueryall(organizationQueryAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQueryall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQuerydetail(companyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationQueryDetailRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQuerydetail(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQuerydetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 GA 專案清單
         * @param {string} [projectName] 專案名稱
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQuerygaprojects(projectName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationQueryGAProjectsRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQuerygaprojects(projectName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQuerygaprojects']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {OrganizationQueryMembersRq} [organizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQuerymembers(organizationQueryMembersRq?: OrganizationQueryMembersRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationQueryMembersRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQuerymembers(organizationQueryMembersRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQuerymembers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {OrganizationQuerySubtotalRq} [organizationQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsQuerysubtotal(organizationQuerySubtotalRq?: OrganizationQuerySubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationQuerySubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsQuerysubtotal(organizationQuerySubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsQuerysubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {OrganizationSendRegistrationInvitationRq} [organizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq?: OrganizationSendRegistrationInvitationRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsSendregistrationinvitation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsUpdate(organizationUpdateRq?: OrganizationUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsUpdate(organizationUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsUpdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新成員權限
         * @param {OrganizationUpdateMemberPermissionRq} [organizationUpdateMemberPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq?: OrganizationUpdateMemberPermissionRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyOrganizationsApi.organizationsUpdatememberpermission']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CompanyOrganizationsApi - factory interface
 * @export
 */
export const CompanyOrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyOrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary 新增 - 公司 組織資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCreate(organizationUpdateRq?: OrganizationUpdateRq, options?: any): AxiosPromise<OrganizationUpdateRs> {
            return localVarFp.organizationsCreate(organizationUpdateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除 - 公司組織
         * @param {OrganizationDeleteRq} [organizationDeleteRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete(organizationDeleteRq?: OrganizationDeleteRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsDelete(organizationDeleteRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除成員
         * @param {OrganizationDeleteMemberRq} [organizationDeleteMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDeletemember(organizationDeleteMemberRq?: OrganizationDeleteMemberRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsDeletemember(organizationDeleteMemberRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {OrganizationExportAllRq} [organizationExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsExportall(organizationExportAllRq?: OrganizationExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsExportall(organizationExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {OrganizationExportSelectedRq} [organizationExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsExportselected(organizationExportSelectedRq?: OrganizationExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsExportselected(organizationExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公司 domain 選單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGetcompanydomainoption(companyUuid?: string, options?: any): AxiosPromise<Array<OrganizationGetCompanyDomainOptionRs>> {
            return localVarFp.organizationsGetcompanydomainoption(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 組織資料
         * @param {string} companyOrgUuid companyOrgUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuery(companyOrgUuid: string, options?: any): AxiosPromise<OraanizationInfoRs> {
            return localVarFp.organizationsQuery(companyOrgUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {OrganizationQueryAllRq} [organizationQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQueryall(organizationQueryAllRq?: OrganizationQueryAllRq, options?: any): AxiosPromise<Array<OrganizationQueryAllRs>> {
            return localVarFp.organizationsQueryall(organizationQueryAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織查詢列表
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerydetail(companyUuid: string, options?: any): AxiosPromise<Array<OrganizationQueryDetailRs>> {
            return localVarFp.organizationsQuerydetail(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 GA 專案清單
         * @param {string} [projectName] 專案名稱
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerygaprojects(projectName?: string, options?: any): AxiosPromise<Array<OrganizationQueryGAProjectsRs>> {
            return localVarFp.organizationsQuerygaprojects(projectName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {OrganizationQueryMembersRq} [organizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerymembers(organizationQueryMembersRq?: OrganizationQueryMembersRq, options?: any): AxiosPromise<Array<OrganizationQueryMembersRs>> {
            return localVarFp.organizationsQuerymembers(organizationQueryMembersRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {OrganizationQuerySubtotalRq} [organizationQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsQuerysubtotal(organizationQuerySubtotalRq?: OrganizationQuerySubtotalRq, options?: any): AxiosPromise<OrganizationQuerySubtotalRs> {
            return localVarFp.organizationsQuerysubtotal(organizationQuerySubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {OrganizationSendRegistrationInvitationRq} [organizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq?: OrganizationSendRegistrationInvitationRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdate(organizationUpdateRq?: OrganizationUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsUpdate(organizationUpdateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新成員權限
         * @param {OrganizationUpdateMemberPermissionRq} [organizationUpdateMemberPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq?: OrganizationUpdateMemberPermissionRq, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyOrganizationsApi - object-oriented interface
 * @export
 * @class CompanyOrganizationsApi
 * @extends {BaseAPI}
 */
export class CompanyOrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary 新增 - 公司 組織資料
     * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsCreate(organizationUpdateRq?: OrganizationUpdateRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsCreate(organizationUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除 - 公司組織
     * @param {OrganizationDeleteRq} [organizationDeleteRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsDelete(organizationDeleteRq?: OrganizationDeleteRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsDelete(organizationDeleteRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除成員
     * @param {OrganizationDeleteMemberRq} [organizationDeleteMemberRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsDeletemember(organizationDeleteMemberRq?: OrganizationDeleteMemberRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsDeletemember(organizationDeleteMemberRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案 (csv)
     * @param {OrganizationExportAllRq} [organizationExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsExportall(organizationExportAllRq?: OrganizationExportAllRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsExportall(organizationExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案 (csv)
     * @param {OrganizationExportSelectedRq} [organizationExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsExportselected(organizationExportSelectedRq?: OrganizationExportSelectedRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsExportselected(organizationExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公司 domain 選單
     * @param {string} [companyUuid] companyUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsGetcompanydomainoption(companyUuid?: string, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsGetcompanydomainoption(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 組織資料
     * @param {string} companyOrgUuid companyOrgUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQuery(companyOrgUuid: string, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQuery(companyOrgUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織查詢列表
     * @param {OrganizationQueryAllRq} [organizationQueryAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQueryall(organizationQueryAllRq?: OrganizationQueryAllRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQueryall(organizationQueryAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織查詢列表
     * @param {string} companyUuid 公司 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQuerydetail(companyUuid: string, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQuerydetail(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 GA 專案清單
     * @param {string} [projectName] 專案名稱
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQuerygaprojects(projectName?: string, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQuerygaprojects(projectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 公司組織成員
     * @param {OrganizationQueryMembersRq} [organizationQueryMembersRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQuerymembers(organizationQueryMembersRq?: OrganizationQueryMembersRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQuerymembers(organizationQueryMembersRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 資料列表 - 小計數據
     * @param {OrganizationQuerySubtotalRq} [organizationQuerySubtotalRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsQuerysubtotal(organizationQuerySubtotalRq?: OrganizationQuerySubtotalRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsQuerysubtotal(organizationQuerySubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 寄送 公司組織註冊邀請
     * @param {OrganizationSendRegistrationInvitationRq} [organizationSendRegistrationInvitationRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq?: OrganizationSendRegistrationInvitationRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsSendregistrationinvitation(organizationSendRegistrationInvitationRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新 - 公司基本資料
     * @param {OrganizationUpdateRq} [organizationUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsUpdate(organizationUpdateRq?: OrganizationUpdateRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsUpdate(organizationUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新成員權限
     * @param {OrganizationUpdateMemberPermissionRq} [organizationUpdateMemberPermissionRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyOrganizationsApi
     */
    public organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq?: OrganizationUpdateMemberPermissionRq, options?: AxiosRequestConfig) {
        return CompanyOrganizationsApiFp(this.configuration).organizationsUpdatememberpermission(organizationUpdateMemberPermissionRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyProfilesApi - axios parameter creator
 * @export
 */
export const CompanyProfilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新增公司 domain 清單
         * @param {ProfileAddDomainRq} [profileAddDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesAddcompanydomain: async (profileAddDomainRq?: ProfileAddDomainRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/AddCompanyDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileAddDomainRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 新增 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesCreate: async (profileUpdateRq?: ProfileUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 停用 - 公司
         * @param {ProfileDisableRq} [profileDisableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesDisable: async (profileDisableRq?: ProfileDisableRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/Disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileDisableRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 啟用 - 公司
         * @param {ProfileEnableRq} [profileEnableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesEnable: async (profileEnableRq?: ProfileEnableRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/Enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileEnableRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {ProfileExportAllRq} [profileExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesExportall: async (profileExportAllRq?: ProfileExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取公司檔案 (csv)
         * @param {ProfileExportSelectedRq} [profileExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesExportselected: async (profileExportSelectedRq?: ProfileExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 公司基本資料
         * @param {string} companyUuid company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuery: async (companyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('profilesQuery', 'companyUuid', companyUuid)
            const localVarPath = `/Company/Profiles/Query/{companyUuid}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公司查詢列表
         * @param {ProfileQueryAllRq} [profileQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQueryall: async (profileQueryAllRq?: ProfileQueryAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/QueryAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileQueryAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 domain detail
         * @param {ProfileQueryDomainDetailRq} [profileQueryDomainDetailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerydomaindetail: async (profileQueryDomainDetailRq?: ProfileQueryDomainDetailRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/QueryDomainDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileQueryDomainDetailRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司 domain 清單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerydomains: async (companyUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/QueryDomains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {ProfileQuerySubtotalRq} [profileQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerysubtotal: async (profileQuerySubtotalRq?: ProfileQuerySubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/QuerySubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileQuerySubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移除公司 domain
         * @param {ProfileRemoveDomainRq} [profileRemoveDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesRemovedomain: async (profileRemoveDomainRq?: ProfileRemoveDomainRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/RemoveDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileRemoveDomainRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdate: async (profileUpdateRq?: ProfileUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新公司 domain 內容
         * @param {ProfileUpdateDomainRq} [profileUpdateDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdatecompanydomain: async (profileUpdateDomainRq?: ProfileUpdateDomainRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Company/Profiles/UpdateCompanyDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateDomainRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyProfilesApi - functional programming interface
 * @export
 */
export const CompanyProfilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyProfilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新增公司 domain 清單
         * @param {ProfileAddDomainRq} [profileAddDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesAddcompanydomain(profileAddDomainRq?: ProfileAddDomainRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesAddcompanydomain(profileAddDomainRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesAddcompanydomain']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 新增 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesCreate(profileUpdateRq?: ProfileUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileUpdateRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesCreate(profileUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 停用 - 公司
         * @param {ProfileDisableRq} [profileDisableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesDisable(profileDisableRq?: ProfileDisableRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesDisable(profileDisableRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesDisable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 啟用 - 公司
         * @param {ProfileEnableRq} [profileEnableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesEnable(profileEnableRq?: ProfileEnableRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesEnable(profileEnableRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesEnable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {ProfileExportAllRq} [profileExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesExportall(profileExportAllRq?: ProfileExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesExportall(profileExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取公司檔案 (csv)
         * @param {ProfileExportSelectedRq} [profileExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesExportselected(profileExportSelectedRq?: ProfileExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesExportselected(profileExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 公司基本資料
         * @param {string} companyUuid company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesQuery(companyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesQuery(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 公司查詢列表
         * @param {ProfileQueryAllRq} [profileQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesQueryall(profileQueryAllRq?: ProfileQueryAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileQueryAllRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesQueryall(profileQueryAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesQueryall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 domain detail
         * @param {ProfileQueryDomainDetailRq} [profileQueryDomainDetailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesQuerydomaindetail(profileQueryDomainDetailRq?: ProfileQueryDomainDetailRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileQueryDomainDetailRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesQuerydomaindetail(profileQueryDomainDetailRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesQuerydomaindetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司 domain 清單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesQuerydomains(companyUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileQueryDomainRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesQuerydomains(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesQuerydomains']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {ProfileQuerySubtotalRq} [profileQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesQuerysubtotal(profileQuerySubtotalRq?: ProfileQuerySubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileQuerySubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesQuerysubtotal(profileQuerySubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesQuerysubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 移除公司 domain
         * @param {ProfileRemoveDomainRq} [profileRemoveDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesRemovedomain(profileRemoveDomainRq?: ProfileRemoveDomainRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesRemovedomain(profileRemoveDomainRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesRemovedomain']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesUpdate(profileUpdateRq?: ProfileUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesUpdate(profileUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesUpdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新公司 domain 內容
         * @param {ProfileUpdateDomainRq} [profileUpdateDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilesUpdatecompanydomain(profileUpdateDomainRq?: ProfileUpdateDomainRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesUpdatecompanydomain(profileUpdateDomainRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyProfilesApi.profilesUpdatecompanydomain']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CompanyProfilesApi - factory interface
 * @export
 */
export const CompanyProfilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyProfilesApiFp(configuration)
    return {
        /**
         * 
         * @summary 新增公司 domain 清單
         * @param {ProfileAddDomainRq} [profileAddDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesAddcompanydomain(profileAddDomainRq?: ProfileAddDomainRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesAddcompanydomain(profileAddDomainRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 新增 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesCreate(profileUpdateRq?: ProfileUpdateRq, options?: any): AxiosPromise<ProfileUpdateRs> {
            return localVarFp.profilesCreate(profileUpdateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 停用 - 公司
         * @param {ProfileDisableRq} [profileDisableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesDisable(profileDisableRq?: ProfileDisableRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesDisable(profileDisableRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 啟用 - 公司
         * @param {ProfileEnableRq} [profileEnableRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesEnable(profileEnableRq?: ProfileEnableRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesEnable(profileEnableRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {ProfileExportAllRq} [profileExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesExportall(profileExportAllRq?: ProfileExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesExportall(profileExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取公司檔案 (csv)
         * @param {ProfileExportSelectedRq} [profileExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesExportselected(profileExportSelectedRq?: ProfileExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesExportselected(profileExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 公司基本資料
         * @param {string} companyUuid company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuery(companyUuid: string, options?: any): AxiosPromise<ProfileInfoRs> {
            return localVarFp.profilesQuery(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公司查詢列表
         * @param {ProfileQueryAllRq} [profileQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQueryall(profileQueryAllRq?: ProfileQueryAllRq, options?: any): AxiosPromise<Array<ProfileQueryAllRs>> {
            return localVarFp.profilesQueryall(profileQueryAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 domain detail
         * @param {ProfileQueryDomainDetailRq} [profileQueryDomainDetailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerydomaindetail(profileQueryDomainDetailRq?: ProfileQueryDomainDetailRq, options?: any): AxiosPromise<ProfileQueryDomainDetailRs> {
            return localVarFp.profilesQuerydomaindetail(profileQueryDomainDetailRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司 domain 清單
         * @param {string} [companyUuid] companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerydomains(companyUuid?: string, options?: any): AxiosPromise<Array<ProfileQueryDomainRs>> {
            return localVarFp.profilesQuerydomains(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {ProfileQuerySubtotalRq} [profileQuerySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesQuerysubtotal(profileQuerySubtotalRq?: ProfileQuerySubtotalRq, options?: any): AxiosPromise<ProfileQuerySubtotalRs> {
            return localVarFp.profilesQuerysubtotal(profileQuerySubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移除公司 domain
         * @param {ProfileRemoveDomainRq} [profileRemoveDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesRemovedomain(profileRemoveDomainRq?: ProfileRemoveDomainRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesRemovedomain(profileRemoveDomainRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新 - 公司基本資料
         * @param {ProfileUpdateRq} [profileUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdate(profileUpdateRq?: ProfileUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesUpdate(profileUpdateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新公司 domain 內容
         * @param {ProfileUpdateDomainRq} [profileUpdateDomainRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdatecompanydomain(profileUpdateDomainRq?: ProfileUpdateDomainRq, options?: any): AxiosPromise<void> {
            return localVarFp.profilesUpdatecompanydomain(profileUpdateDomainRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyProfilesApi - object-oriented interface
 * @export
 * @class CompanyProfilesApi
 * @extends {BaseAPI}
 */
export class CompanyProfilesApi extends BaseAPI {
    /**
     * 
     * @summary 新增公司 domain 清單
     * @param {ProfileAddDomainRq} [profileAddDomainRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesAddcompanydomain(profileAddDomainRq?: ProfileAddDomainRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesAddcompanydomain(profileAddDomainRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 新增 - 公司基本資料
     * @param {ProfileUpdateRq} [profileUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesCreate(profileUpdateRq?: ProfileUpdateRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesCreate(profileUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 停用 - 公司
     * @param {ProfileDisableRq} [profileDisableRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesDisable(profileDisableRq?: ProfileDisableRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesDisable(profileDisableRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 啟用 - 公司
     * @param {ProfileEnableRq} [profileEnableRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesEnable(profileEnableRq?: ProfileEnableRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesEnable(profileEnableRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案 (csv)
     * @param {ProfileExportAllRq} [profileExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesExportall(profileExportAllRq?: ProfileExportAllRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesExportall(profileExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取公司檔案 (csv)
     * @param {ProfileExportSelectedRq} [profileExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesExportselected(profileExportSelectedRq?: ProfileExportSelectedRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesExportselected(profileExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 公司基本資料
     * @param {string} companyUuid company uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesQuery(companyUuid: string, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesQuery(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公司查詢列表
     * @param {ProfileQueryAllRq} [profileQueryAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesQueryall(profileQueryAllRq?: ProfileQueryAllRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesQueryall(profileQueryAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 domain detail
     * @param {ProfileQueryDomainDetailRq} [profileQueryDomainDetailRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesQuerydomaindetail(profileQueryDomainDetailRq?: ProfileQueryDomainDetailRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesQuerydomaindetail(profileQueryDomainDetailRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司 domain 清單
     * @param {string} [companyUuid] companyUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesQuerydomains(companyUuid?: string, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesQuerydomains(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 資料列表 - 小計數據
     * @param {ProfileQuerySubtotalRq} [profileQuerySubtotalRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesQuerysubtotal(profileQuerySubtotalRq?: ProfileQuerySubtotalRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesQuerysubtotal(profileQuerySubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移除公司 domain
     * @param {ProfileRemoveDomainRq} [profileRemoveDomainRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesRemovedomain(profileRemoveDomainRq?: ProfileRemoveDomainRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesRemovedomain(profileRemoveDomainRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新 - 公司基本資料
     * @param {ProfileUpdateRq} [profileUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesUpdate(profileUpdateRq?: ProfileUpdateRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesUpdate(profileUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新公司 domain 內容
     * @param {ProfileUpdateDomainRq} [profileUpdateDomainRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyProfilesApi
     */
    public profilesUpdatecompanydomain(profileUpdateDomainRq?: ProfileUpdateDomainRq, options?: AxiosRequestConfig) {
        return CompanyProfilesApiFp(this.configuration).profilesUpdatecompanydomain(profileUpdateDomainRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendCompaniesApi - axios parameter creator
 * @export
 */
export const FrontendCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新增或更新組織標籤 (多筆)
         * @param {FECompanyCreateOrUpdateOrganizationTagsRq} [fECompanyCreateOrUpdateOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCreateorupdateorganizationtags: async (fECompanyCreateOrUpdateOrganizationTagsRq?: FECompanyCreateOrUpdateOrganizationTagsRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/CreateOrUpdateOrganizationTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fECompanyCreateOrUpdateOrganizationTagsRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除公司縮圖
         * @param {string} [companyUuid] company uuid
         * @param {string} [photoCode] photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesDeletethumbnail: async (companyUuid?: string, photoCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/DeleteThumbnail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }

            if (photoCode !== undefined) {
                localVarQueryParameter['photoCode'] = photoCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢可訪問公司清單
         * @param {string} [term] 關鍵字搜尋
         * @param {number} [pageNumber] 分頁
         * @param {number} [pageSize] 分頁大小
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetcompanies: async (term?: string, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/GetCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢可訪問公司和組織清單
         * @param {string} [term] 關鍵字
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGetcompaniesandorganizations: async (term?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/GetCompaniesAndOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢可訪問公司清單 - 總數
         * @param {string} [term] 關鍵字搜尋
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetcompanycount: async (term?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/GetCompanyCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢可使用功能
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGetfeatures: async (companyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('companiesGetfeatures', 'companyUuid', companyUuid)
            const localVarPath = `/Frontend/Companies/GetFeatures/{companyUuid}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司組織
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetorganizations: async (companyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('companiesGetorganizations', 'companyUuid', companyUuid)
            const localVarPath = `/Frontend/Companies/GetOrganizations/{companyUuid}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司相關人員
         * @param {FECompanyQueryCompanyPersonnelListRq} [fECompanyQueryCompanyPersonnelListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQuerycompanypersonnellist: async (fECompanyQueryCompanyPersonnelListRq?: FECompanyQueryCompanyPersonnelListRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/QueryCompanyPersonnelList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fECompanyQueryCompanyPersonnelListRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {FECompanyOrganizationQueryMembersRq} [fECompanyOrganizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQueryorganizationmembers: async (fECompanyOrganizationQueryMembersRq?: FECompanyOrganizationQueryMembersRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/QueryOrganizationMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fECompanyOrganizationQueryMembersRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢組織標籤
         * @param {FECompanyQueryOrganizationTagsRq} [fECompanyQueryOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQueryorganizationtags: async (fECompanyQueryOrganizationTagsRq?: FECompanyQueryOrganizationTagsRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/QueryOrganizationTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fECompanyQueryOrganizationTagsRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {FECompanyOrganizationSendRegistrationInvitationRq} [fECompanyOrganizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesSendorganizationregistrationinvitation: async (fECompanyOrganizationSendRegistrationInvitationRq?: FECompanyOrganizationSendRegistrationInvitationRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/SendOrganizationRegistrationInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fECompanyOrganizationSendRegistrationInvitationRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司縮圖
         * @param {string} companyUuid compnay uuid
         * @param {string} photoCode photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesThumbnail: async (companyUuid: string, photoCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUuid' is not null or undefined
            assertParamExists('companiesThumbnail', 'companyUuid', companyUuid)
            // verify required parameter 'photoCode' is not null or undefined
            assertParamExists('companiesThumbnail', 'photoCode', photoCode)
            const localVarPath = `/Frontend/Companies/Thumbnail/{companyUuid}/{photoCode}`
                .replace(`{${"companyUuid"}}`, encodeURIComponent(String(companyUuid)))
                .replace(`{${"photoCode"}}`, encodeURIComponent(String(photoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 上傳公司圖像
         * @param {string} [companyUuid] company uuid
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesUploadimage: async (companyUuid?: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/Companies/UploadImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendCompaniesApi - functional programming interface
 * @export
 */
export const FrontendCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新增或更新組織標籤 (多筆)
         * @param {FECompanyCreateOrUpdateOrganizationTagsRq} [fECompanyCreateOrUpdateOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq?: FECompanyCreateOrUpdateOrganizationTagsRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesCreateorupdateorganizationtags']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除公司縮圖
         * @param {string} [companyUuid] company uuid
         * @param {string} [photoCode] photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesDeletethumbnail(companyUuid?: string, photoCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesDeletethumbnail(companyUuid, photoCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesDeletethumbnail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢可訪問公司清單
         * @param {string} [term] 關鍵字搜尋
         * @param {number} [pageNumber] 分頁
         * @param {number} [pageSize] 分頁大小
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async companiesGetcompanies(term?: string, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FECompanyRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGetcompanies(term, pageNumber, pageSize, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesGetcompanies']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢可訪問公司和組織清單
         * @param {string} [term] 關鍵字
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesGetcompaniesandorganizations(term?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FECompanyGetCompaniesAndOrganizationsRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGetcompaniesandorganizations(term, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesGetcompaniesandorganizations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢可訪問公司清單 - 總數
         * @param {string} [term] 關鍵字搜尋
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async companiesGetcompanycount(term?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FECompanyCountRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGetcompanycount(term, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesGetcompanycount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢可使用功能
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesGetfeatures(companyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EFCompanyFeatureRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGetfeatures(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesGetfeatures']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司組織
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async companiesGetorganizations(companyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EFCompanyOrganizationRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGetorganizations(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesGetorganizations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司相關人員
         * @param {FECompanyQueryCompanyPersonnelListRq} [fECompanyQueryCompanyPersonnelListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq?: FECompanyQueryCompanyPersonnelListRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FECompanyQueryCompanyPersonnelListRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesQuerycompanypersonnellist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {FECompanyOrganizationQueryMembersRq} [fECompanyOrganizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq?: FECompanyOrganizationQueryMembersRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FECompanyOrganizationQueryMembersRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesQueryorganizationmembers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢組織標籤
         * @param {FECompanyQueryOrganizationTagsRq} [fECompanyQueryOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq?: FECompanyQueryOrganizationTagsRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FECompanyQueryOrganizationTagsRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesQueryorganizationtags']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {FECompanyOrganizationSendRegistrationInvitationRq} [fECompanyOrganizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq?: FECompanyOrganizationSendRegistrationInvitationRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesSendorganizationregistrationinvitation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司縮圖
         * @param {string} companyUuid compnay uuid
         * @param {string} photoCode photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesThumbnail(companyUuid: string, photoCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesThumbnail(companyUuid, photoCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesThumbnail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 上傳公司圖像
         * @param {string} [companyUuid] company uuid
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesUploadimage(companyUuid?: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesUploadimage(companyUuid, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompaniesApi.companiesUploadimage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendCompaniesApi - factory interface
 * @export
 */
export const FrontendCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendCompaniesApiFp(configuration)
    return {
        /**
         * 
         * @summary 新增或更新組織標籤 (多筆)
         * @param {FECompanyCreateOrUpdateOrganizationTagsRq} [fECompanyCreateOrUpdateOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq?: FECompanyCreateOrUpdateOrganizationTagsRq, options?: any): AxiosPromise<void> {
            return localVarFp.companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除公司縮圖
         * @param {string} [companyUuid] company uuid
         * @param {string} [photoCode] photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesDeletethumbnail(companyUuid?: string, photoCode?: string, options?: any): AxiosPromise<void> {
            return localVarFp.companiesDeletethumbnail(companyUuid, photoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢可訪問公司清單
         * @param {string} [term] 關鍵字搜尋
         * @param {number} [pageNumber] 分頁
         * @param {number} [pageSize] 分頁大小
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetcompanies(term?: string, pageNumber?: number, pageSize?: number, options?: any): AxiosPromise<Array<FECompanyRs>> {
            return localVarFp.companiesGetcompanies(term, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢可訪問公司和組織清單
         * @param {string} [term] 關鍵字
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGetcompaniesandorganizations(term?: string, options?: any): AxiosPromise<FECompanyGetCompaniesAndOrganizationsRs> {
            return localVarFp.companiesGetcompaniesandorganizations(term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢可訪問公司清單 - 總數
         * @param {string} [term] 關鍵字搜尋
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetcompanycount(term?: string, options?: any): AxiosPromise<FECompanyCountRs> {
            return localVarFp.companiesGetcompanycount(term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢可使用功能
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGetfeatures(companyUuid: string, options?: any): AxiosPromise<Array<EFCompanyFeatureRs>> {
            return localVarFp.companiesGetfeatures(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司組織
         * @param {string} companyUuid 公司 uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        companiesGetorganizations(companyUuid: string, options?: any): AxiosPromise<EFCompanyOrganizationRs> {
            return localVarFp.companiesGetorganizations(companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司相關人員
         * @param {FECompanyQueryCompanyPersonnelListRq} [fECompanyQueryCompanyPersonnelListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq?: FECompanyQueryCompanyPersonnelListRq, options?: any): AxiosPromise<Array<FECompanyQueryCompanyPersonnelListRs>> {
            return localVarFp.companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 公司組織成員
         * @param {FECompanyOrganizationQueryMembersRq} [fECompanyOrganizationQueryMembersRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq?: FECompanyOrganizationQueryMembersRq, options?: any): AxiosPromise<Array<FECompanyOrganizationQueryMembersRs>> {
            return localVarFp.companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢組織標籤
         * @param {FECompanyQueryOrganizationTagsRq} [fECompanyQueryOrganizationTagsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq?: FECompanyQueryOrganizationTagsRq, options?: any): AxiosPromise<Array<FECompanyQueryOrganizationTagsRs>> {
            return localVarFp.companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 寄送 公司組織註冊邀請
         * @param {FECompanyOrganizationSendRegistrationInvitationRq} [fECompanyOrganizationSendRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq?: FECompanyOrganizationSendRegistrationInvitationRq, options?: any): AxiosPromise<void> {
            return localVarFp.companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司縮圖
         * @param {string} companyUuid compnay uuid
         * @param {string} photoCode photo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesThumbnail(companyUuid: string, photoCode: string, options?: any): AxiosPromise<void> {
            return localVarFp.companiesThumbnail(companyUuid, photoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 上傳公司圖像
         * @param {string} [companyUuid] company uuid
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesUploadimage(companyUuid?: string, file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.companiesUploadimage(companyUuid, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendCompaniesApi - object-oriented interface
 * @export
 * @class FrontendCompaniesApi
 * @extends {BaseAPI}
 */
export class FrontendCompaniesApi extends BaseAPI {
    /**
     * 
     * @summary 新增或更新組織標籤 (多筆)
     * @param {FECompanyCreateOrUpdateOrganizationTagsRq} [fECompanyCreateOrUpdateOrganizationTagsRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq?: FECompanyCreateOrUpdateOrganizationTagsRq, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesCreateorupdateorganizationtags(fECompanyCreateOrUpdateOrganizationTagsRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除公司縮圖
     * @param {string} [companyUuid] company uuid
     * @param {string} [photoCode] photo code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesDeletethumbnail(companyUuid?: string, photoCode?: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesDeletethumbnail(companyUuid, photoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢可訪問公司清單
     * @param {string} [term] 關鍵字搜尋
     * @param {number} [pageNumber] 分頁
     * @param {number} [pageSize] 分頁大小
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesGetcompanies(term?: string, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesGetcompanies(term, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢可訪問公司和組織清單
     * @param {string} [term] 關鍵字
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesGetcompaniesandorganizations(term?: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesGetcompaniesandorganizations(term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢可訪問公司清單 - 總數
     * @param {string} [term] 關鍵字搜尋
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesGetcompanycount(term?: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesGetcompanycount(term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢可使用功能
     * @param {string} companyUuid 公司 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesGetfeatures(companyUuid: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesGetfeatures(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司組織
     * @param {string} companyUuid 公司 uuid
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesGetorganizations(companyUuid: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesGetorganizations(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司相關人員
     * @param {FECompanyQueryCompanyPersonnelListRq} [fECompanyQueryCompanyPersonnelListRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq?: FECompanyQueryCompanyPersonnelListRq, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesQuerycompanypersonnellist(fECompanyQueryCompanyPersonnelListRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 公司組織成員
     * @param {FECompanyOrganizationQueryMembersRq} [fECompanyOrganizationQueryMembersRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq?: FECompanyOrganizationQueryMembersRq, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesQueryorganizationmembers(fECompanyOrganizationQueryMembersRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢組織標籤
     * @param {FECompanyQueryOrganizationTagsRq} [fECompanyQueryOrganizationTagsRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq?: FECompanyQueryOrganizationTagsRq, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesQueryorganizationtags(fECompanyQueryOrganizationTagsRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 寄送 公司組織註冊邀請
     * @param {FECompanyOrganizationSendRegistrationInvitationRq} [fECompanyOrganizationSendRegistrationInvitationRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq?: FECompanyOrganizationSendRegistrationInvitationRq, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesSendorganizationregistrationinvitation(fECompanyOrganizationSendRegistrationInvitationRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司縮圖
     * @param {string} companyUuid compnay uuid
     * @param {string} photoCode photo code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesThumbnail(companyUuid: string, photoCode: string, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesThumbnail(companyUuid, photoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 上傳公司圖像
     * @param {string} [companyUuid] company uuid
     * @param {File} [file] file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompaniesApi
     */
    public companiesUploadimage(companyUuid?: string, file?: File, options?: AxiosRequestConfig) {
        return FrontendCompaniesApiFp(this.configuration).companiesUploadimage(companyUuid, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendCompanyOrgStatsApi - axios parameter creator
 * @export
 */
export const FrontendCompanyOrgStatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAgedist: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/AgeDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 數據標籤重疊 user(session) 檢視 url code top 清單
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop: async (analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/AnalyzeCompareOverlapSessionViewUrlCodeTop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyzeTagOverlapRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 數據標籤重疊度分析
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAnalyzetagoverlap: async (analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/AnalyzeTagOverlap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyzeTagOverlapRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {CompanyOrgStatsClicksRq} [companyOrgStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsClicks: async (companyOrgStatsClicksRq?: CompanyOrgStatsClicksRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/Clicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsClicksRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsDevicedist: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/DeviceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsGenderdist: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/GenderDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢公司組織, 所有子標籤 點擊數 (數據標籤列表)
         * @param {QueryAllSubTagClicksRq} [queryAllSubTagClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsQueryallsubtagclicks: async (queryAllSubTagClicksRq?: QueryAllSubTagClicksRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/QueryAllSubTagClicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAllSubTagClicksRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢數據標籤資訊
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsQuerysubtaginfo: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/QuerySubTagInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsRegiondist: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/RegionDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsSourcedist: async (companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/CompanyOrgStats/SourceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyOrgStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendCompanyOrgStatsApi - functional programming interface
 * @export
 */
export const FrontendCompanyOrgStatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendCompanyOrgStatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsAgedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsAgeDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsAgedist(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsAgedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 數據標籤重疊 user(session) 檢視 url code top 清單
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyzeCompareOverlapSessionViewUrlCodeTopRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 數據標籤重疊度分析
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeTagOverlapRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsAnalyzetagoverlap']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {CompanyOrgStatsClicksRq} [companyOrgStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsClicks(companyOrgStatsClicksRq?: CompanyOrgStatsClicksRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsClicksRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsClicks(companyOrgStatsClicksRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsClicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsDevicedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsDeviceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsDevicedist(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsDevicedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsGenderdist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsGenderDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsGenderdist(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsGenderdist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢公司組織, 所有子標籤 點擊數 (數據標籤列表)
         * @param {QueryAllSubTagClicksRq} [queryAllSubTagClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq?: QueryAllSubTagClicksRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueryAllSubTagClicksRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsQueryallsubtagclicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢數據標籤資訊
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyOrgStatsQuerySubTagInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsQuerysubtaginfo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsRegiondist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsRegionDistRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsRegiondist(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsRegiondist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyorgstatsSourcedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsSourceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyorgstatsSourcedist(companyOrgStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendCompanyOrgStatsApi.companyorgstatsSourcedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendCompanyOrgStatsApi - factory interface
 * @export
 */
export const FrontendCompanyOrgStatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendCompanyOrgStatsApiFp(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAgedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsAgeDistRs>> {
            return localVarFp.companyorgstatsAgedist(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 數據標籤重疊 user(session) 檢視 url code top 清單
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: any): AxiosPromise<Array<AnalyzeCompareOverlapSessionViewUrlCodeTopRs>> {
            return localVarFp.companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 數據標籤重疊度分析
         * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: any): AxiosPromise<AnalyzeTagOverlapRs> {
            return localVarFp.companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {CompanyOrgStatsClicksRq} [companyOrgStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsClicks(companyOrgStatsClicksRq?: CompanyOrgStatsClicksRq, options?: any): AxiosPromise<StatisticsClicksRs> {
            return localVarFp.companyorgstatsClicks(companyOrgStatsClicksRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsDevicedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsDeviceDistRs>> {
            return localVarFp.companyorgstatsDevicedist(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsGenderdist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsGenderDistRs>> {
            return localVarFp.companyorgstatsGenderdist(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢公司組織, 所有子標籤 點擊數 (數據標籤列表)
         * @param {QueryAllSubTagClicksRq} [queryAllSubTagClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq?: QueryAllSubTagClicksRq, options?: any): AxiosPromise<Array<QueryAllSubTagClicksRs>> {
            return localVarFp.companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢數據標籤資訊
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<CompanyOrgStatsQuerySubTagInfoRs> {
            return localVarFp.companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsRegiondist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<StatisticsRegionDistRs> {
            return localVarFp.companyorgstatsRegiondist(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyorgstatsSourcedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsSourceDistRs>> {
            return localVarFp.companyorgstatsSourcedist(companyOrgStatsQueryRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendCompanyOrgStatsApi - object-oriented interface
 * @export
 * @class FrontendCompanyOrgStatsApi
 * @extends {BaseAPI}
 */
export class FrontendCompanyOrgStatsApi extends BaseAPI {
    /**
     * 
     * @summary 短網址 年齡分布
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsAgedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsAgedist(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 數據標籤重疊 user(session) 檢視 url code top 清單
     * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(analyzeTagOverlapRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 數據標籤重疊度分析
     * @param {AnalyzeTagOverlapRq} [analyzeTagOverlapRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq?: AnalyzeTagOverlapRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsAnalyzetagoverlap(analyzeTagOverlapRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址點擊統計
     * @param {CompanyOrgStatsClicksRq} [companyOrgStatsClicksRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsClicks(companyOrgStatsClicksRq?: CompanyOrgStatsClicksRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsClicks(companyOrgStatsClicksRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 裝置分布
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsDevicedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsDevicedist(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 性別分布
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsGenderdist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsGenderdist(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢公司組織, 所有子標籤 點擊數 (數據標籤列表)
     * @param {QueryAllSubTagClicksRq} [queryAllSubTagClicksRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq?: QueryAllSubTagClicksRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsQueryallsubtagclicks(queryAllSubTagClicksRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢數據標籤資訊
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsQuerysubtaginfo(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 地區分布
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsRegiondist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsRegiondist(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 來源分布
     * @param {CompanyOrgStatsQueryRq} [companyOrgStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendCompanyOrgStatsApi
     */
    public companyorgstatsSourcedist(companyOrgStatsQueryRq?: CompanyOrgStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendCompanyOrgStatsApiFp(this.configuration).companyorgstatsSourcedist(companyOrgStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendShortUrlsApi - axios parameter creator
 * @export
 */
export const FrontendShortUrlsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址
         * @param {ShortUrlAppendTagToUrlsRq} [shortUrlAppendTagToUrlsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsAppendtagtourls: async (shortUrlAppendTagToUrlsRq?: ShortUrlAppendTagToUrlsRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/AppendTagToUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlAppendTagToUrlsRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 建立短網址
         * @param {ShortUrlCreateRq} [shortUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsCreate: async (shortUrlCreateRq?: ShortUrlCreateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlCreateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除短網址 (多筆)
         * @param {ShortUrlDeleteRq} [shortUrlDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsDelete: async (shortUrlDeleteRq?: ShortUrlDeleteRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlDeleteRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案
         * @param {ShortUrlExportAllRq} [shortUrlExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsExportall: async (shortUrlExportAllRq?: ShortUrlExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {ShortUrlExportSelectedRq} [shortUrlExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsExportselected: async (shortUrlExportSelectedRq?: ShortUrlExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取得 html meta info
         * @param {ShortUrlOgMetaRq} [shortUrlOgMetaRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsGetogmeta: async (shortUrlOgMetaRq?: ShortUrlOgMetaRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/GetOgMeta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlOgMetaRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址明細
         * @param {ShortUrlQueryRq} [shortUrlQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQuery: async (shortUrlQueryRq?: ShortUrlQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/Query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址列表
         * @param {ShortUrlQueryAllRq} [shortUrlQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQueryall: async (shortUrlQueryAllRq?: ShortUrlQueryAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/QueryAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlQueryAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址列表 (總比數)
         * @param {ShortUrlQueryAllSubtotalRq} [shortUrlQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQueryallsubtotal: async (shortUrlQueryAllSubtotalRq?: ShortUrlQueryAllSubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/QueryAllSubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlQueryAllSubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 數據標籤
         * @param {string} [companyUuId] 公司 uuid
         * @param {string} [companyOrganizationUuid] 公司組織 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQuerysubtags: async (companyUuId?: string, companyOrganizationUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/QuerySubtags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuId !== undefined) {
                localVarQueryParameter['companyUuId'] = companyUuId;
            }

            if (companyOrganizationUuid !== undefined) {
                localVarQueryParameter['companyOrganizationUuid'] = companyOrganizationUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移除標籤 從 短網址
         * @param {ShortUrlRemoveTagFromRq} [shortUrlRemoveTagFromRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsRemovetagfromurls: async (shortUrlRemoveTagFromRq?: ShortUrlRemoveTagFromRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/RemoveTagFromUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlRemoveTagFromRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新短網址
         * @param {ShortUrlUpdateRq} [shortUrlUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsUpdate: async (shortUrlUpdateRq?: ShortUrlUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/ShortUrls/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shortUrlUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendShortUrlsApi - functional programming interface
 * @export
 */
export const FrontendShortUrlsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendShortUrlsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址
         * @param {ShortUrlAppendTagToUrlsRq} [shortUrlAppendTagToUrlsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq?: ShortUrlAppendTagToUrlsRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsAppendtagtourls']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 建立短網址
         * @param {ShortUrlCreateRq} [shortUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsCreate(shortUrlCreateRq?: ShortUrlCreateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortUrlCreateRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsCreate(shortUrlCreateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除短網址 (多筆)
         * @param {ShortUrlDeleteRq} [shortUrlDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsDelete(shortUrlDeleteRq?: ShortUrlDeleteRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsDelete(shortUrlDeleteRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案
         * @param {ShortUrlExportAllRq} [shortUrlExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsExportall(shortUrlExportAllRq?: ShortUrlExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsExportall(shortUrlExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {ShortUrlExportSelectedRq} [shortUrlExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsExportselected(shortUrlExportSelectedRq?: ShortUrlExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsExportselected(shortUrlExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 取得 html meta info
         * @param {ShortUrlOgMetaRq} [shortUrlOgMetaRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsGetogmeta(shortUrlOgMetaRq?: ShortUrlOgMetaRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortUrlOgMetaRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsGetogmeta(shortUrlOgMetaRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsGetogmeta']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址明細
         * @param {ShortUrlQueryRq} [shortUrlQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsQuery(shortUrlQueryRq?: ShortUrlQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortUrlQueryRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsQuery(shortUrlQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址列表
         * @param {ShortUrlQueryAllRq} [shortUrlQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsQueryall(shortUrlQueryAllRq?: ShortUrlQueryAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShortUrlQueryAllRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsQueryall(shortUrlQueryAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsQueryall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址列表 (總比數)
         * @param {ShortUrlQueryAllSubtotalRq} [shortUrlQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq?: ShortUrlQueryAllSubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortUrlQueryAllSubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsQueryallsubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 數據標籤
         * @param {string} [companyUuId] 公司 uuid
         * @param {string} [companyOrganizationUuid] 公司組織 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsQuerysubtags(companyUuId?: string, companyOrganizationUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShortUrlQuerySubtagRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsQuerysubtags(companyUuId, companyOrganizationUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsQuerysubtags']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 移除標籤 從 短網址
         * @param {ShortUrlRemoveTagFromRq} [shortUrlRemoveTagFromRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq?: ShortUrlRemoveTagFromRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsRemovetagfromurls']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新短網址
         * @param {ShortUrlUpdateRq} [shortUrlUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shorturlsUpdate(shortUrlUpdateRq?: ShortUrlUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shorturlsUpdate(shortUrlUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendShortUrlsApi.shorturlsUpdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendShortUrlsApi - factory interface
 * @export
 */
export const FrontendShortUrlsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendShortUrlsApiFp(configuration)
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址
         * @param {ShortUrlAppendTagToUrlsRq} [shortUrlAppendTagToUrlsRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq?: ShortUrlAppendTagToUrlsRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 建立短網址
         * @param {ShortUrlCreateRq} [shortUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsCreate(shortUrlCreateRq?: ShortUrlCreateRq, options?: any): AxiosPromise<ShortUrlCreateRs> {
            return localVarFp.shorturlsCreate(shortUrlCreateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除短網址 (多筆)
         * @param {ShortUrlDeleteRq} [shortUrlDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsDelete(shortUrlDeleteRq?: ShortUrlDeleteRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsDelete(shortUrlDeleteRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案
         * @param {ShortUrlExportAllRq} [shortUrlExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsExportall(shortUrlExportAllRq?: ShortUrlExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsExportall(shortUrlExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {ShortUrlExportSelectedRq} [shortUrlExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsExportselected(shortUrlExportSelectedRq?: ShortUrlExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsExportselected(shortUrlExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取得 html meta info
         * @param {ShortUrlOgMetaRq} [shortUrlOgMetaRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsGetogmeta(shortUrlOgMetaRq?: ShortUrlOgMetaRq, options?: any): AxiosPromise<ShortUrlOgMetaRs> {
            return localVarFp.shorturlsGetogmeta(shortUrlOgMetaRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址明細
         * @param {ShortUrlQueryRq} [shortUrlQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQuery(shortUrlQueryRq?: ShortUrlQueryRq, options?: any): AxiosPromise<ShortUrlQueryRs> {
            return localVarFp.shorturlsQuery(shortUrlQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址列表
         * @param {ShortUrlQueryAllRq} [shortUrlQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQueryall(shortUrlQueryAllRq?: ShortUrlQueryAllRq, options?: any): AxiosPromise<Array<ShortUrlQueryAllRs>> {
            return localVarFp.shorturlsQueryall(shortUrlQueryAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址列表 (總比數)
         * @param {ShortUrlQueryAllSubtotalRq} [shortUrlQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq?: ShortUrlQueryAllSubtotalRq, options?: any): AxiosPromise<ShortUrlQueryAllSubtotalRs> {
            return localVarFp.shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 數據標籤
         * @param {string} [companyUuId] 公司 uuid
         * @param {string} [companyOrganizationUuid] 公司組織 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsQuerysubtags(companyUuId?: string, companyOrganizationUuid?: string, options?: any): AxiosPromise<Array<ShortUrlQuerySubtagRs>> {
            return localVarFp.shorturlsQuerysubtags(companyUuId, companyOrganizationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移除標籤 從 短網址
         * @param {ShortUrlRemoveTagFromRq} [shortUrlRemoveTagFromRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq?: ShortUrlRemoveTagFromRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新短網址
         * @param {ShortUrlUpdateRq} [shortUrlUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shorturlsUpdate(shortUrlUpdateRq?: ShortUrlUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.shorturlsUpdate(shortUrlUpdateRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendShortUrlsApi - object-oriented interface
 * @export
 * @class FrontendShortUrlsApi
 * @extends {BaseAPI}
 */
export class FrontendShortUrlsApi extends BaseAPI {
    /**
     * 
     * @summary 新增標籤 至 短網址
     * @param {ShortUrlAppendTagToUrlsRq} [shortUrlAppendTagToUrlsRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq?: ShortUrlAppendTagToUrlsRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsAppendtagtourls(shortUrlAppendTagToUrlsRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 建立短網址
     * @param {ShortUrlCreateRq} [shortUrlCreateRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsCreate(shortUrlCreateRq?: ShortUrlCreateRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsCreate(shortUrlCreateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除短網址 (多筆)
     * @param {ShortUrlDeleteRq} [shortUrlDeleteRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsDelete(shortUrlDeleteRq?: ShortUrlDeleteRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsDelete(shortUrlDeleteRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案
     * @param {ShortUrlExportAllRq} [shortUrlExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsExportall(shortUrlExportAllRq?: ShortUrlExportAllRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsExportall(shortUrlExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案
     * @param {ShortUrlExportSelectedRq} [shortUrlExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsExportselected(shortUrlExportSelectedRq?: ShortUrlExportSelectedRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsExportselected(shortUrlExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取得 html meta info
     * @param {ShortUrlOgMetaRq} [shortUrlOgMetaRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsGetogmeta(shortUrlOgMetaRq?: ShortUrlOgMetaRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsGetogmeta(shortUrlOgMetaRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址明細
     * @param {ShortUrlQueryRq} [shortUrlQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsQuery(shortUrlQueryRq?: ShortUrlQueryRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsQuery(shortUrlQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址列表
     * @param {ShortUrlQueryAllRq} [shortUrlQueryAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsQueryall(shortUrlQueryAllRq?: ShortUrlQueryAllRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsQueryall(shortUrlQueryAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址列表 (總比數)
     * @param {ShortUrlQueryAllSubtotalRq} [shortUrlQueryAllSubtotalRq] rq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq?: ShortUrlQueryAllSubtotalRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsQueryallsubtotal(shortUrlQueryAllSubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 數據標籤
     * @param {string} [companyUuId] 公司 uuid
     * @param {string} [companyOrganizationUuid] 公司組織 uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsQuerysubtags(companyUuId?: string, companyOrganizationUuid?: string, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsQuerysubtags(companyUuId, companyOrganizationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移除標籤 從 短網址
     * @param {ShortUrlRemoveTagFromRq} [shortUrlRemoveTagFromRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq?: ShortUrlRemoveTagFromRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsRemovetagfromurls(shortUrlRemoveTagFromRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新短網址
     * @param {ShortUrlUpdateRq} [shortUrlUpdateRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendShortUrlsApi
     */
    public shorturlsUpdate(shortUrlUpdateRq?: ShortUrlUpdateRq, options?: AxiosRequestConfig) {
        return FrontendShortUrlsApiFp(this.configuration).shorturlsUpdate(shortUrlUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendUrlGroupStatsApi - axios parameter creator
 * @export
 */
export const FrontendUrlGroupStatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsAgedist: async (urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/AgeDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlGroupStatsClicksRq} [urlGroupStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsClicks: async (urlGroupStatsClicksRq?: UrlGroupStatsClicksRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/Clicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsClicksRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlGroupStatsClickSummaryRq} [urlGroupStatsClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsClicksummary: async (urlGroupStatsClickSummaryRq?: UrlGroupStatsClickSummaryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/ClickSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsClickSummaryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsDevicedist: async (urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/DeviceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsGenderdist: async (urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/GenderDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlGroupStatsInfoRq} [urlGroupStatsInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsGroupinfo: async (urlGroupStatsInfoRq?: UrlGroupStatsInfoRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/GroupInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsInfoRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsRegiondist: async (urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/RegionDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsSourcedist: async (urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGroupStats/SourceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlGroupStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendUrlGroupStatsApi - functional programming interface
 * @export
 */
export const FrontendUrlGroupStatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendUrlGroupStatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsAgedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsAgeDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsAgedist(urlGroupStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsAgedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlGroupStatsClicksRq} [urlGroupStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsClicks(urlGroupStatsClicksRq?: UrlGroupStatsClicksRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsClicksRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsClicks(urlGroupStatsClicksRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsClicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlGroupStatsClickSummaryRq} [urlGroupStatsClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq?: UrlGroupStatsClickSummaryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsClickSummaryRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsClicksummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsDevicedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsDeviceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsDevicedist(urlGroupStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsDevicedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsGenderdist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsGenderDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsGenderdist(urlGroupStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsGenderdist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlGroupStatsInfoRq} [urlGroupStatsInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsGroupinfo(urlGroupStatsInfoRq?: UrlGroupStatsInfoRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlGroupStatsInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsGroupinfo(urlGroupStatsInfoRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsGroupinfo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsRegiondist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsRegionDistRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsRegiondist(urlGroupStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsRegiondist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupstatsSourcedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsSourceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupstatsSourcedist(urlGroupStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupStatsApi.urlgroupstatsSourcedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendUrlGroupStatsApi - factory interface
 * @export
 */
export const FrontendUrlGroupStatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendUrlGroupStatsApiFp(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsAgedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsAgeDistRs>> {
            return localVarFp.urlgroupstatsAgedist(urlGroupStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlGroupStatsClicksRq} [urlGroupStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsClicks(urlGroupStatsClicksRq?: UrlGroupStatsClicksRq, options?: any): AxiosPromise<StatisticsClicksRs> {
            return localVarFp.urlgroupstatsClicks(urlGroupStatsClicksRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlGroupStatsClickSummaryRq} [urlGroupStatsClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq?: UrlGroupStatsClickSummaryRq, options?: any): AxiosPromise<StatisticsClickSummaryRs> {
            return localVarFp.urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsDevicedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsDeviceDistRs>> {
            return localVarFp.urlgroupstatsDevicedist(urlGroupStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsGenderdist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsGenderDistRs>> {
            return localVarFp.urlgroupstatsGenderdist(urlGroupStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlGroupStatsInfoRq} [urlGroupStatsInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsGroupinfo(urlGroupStatsInfoRq?: UrlGroupStatsInfoRq, options?: any): AxiosPromise<UrlGroupStatsInfoRs> {
            return localVarFp.urlgroupstatsGroupinfo(urlGroupStatsInfoRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsRegiondist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: any): AxiosPromise<StatisticsRegionDistRs> {
            return localVarFp.urlgroupstatsRegiondist(urlGroupStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupstatsSourcedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsSourceDistRs>> {
            return localVarFp.urlgroupstatsSourcedist(urlGroupStatsQueryRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendUrlGroupStatsApi - object-oriented interface
 * @export
 * @class FrontendUrlGroupStatsApi
 * @extends {BaseAPI}
 */
export class FrontendUrlGroupStatsApi extends BaseAPI {
    /**
     * 
     * @summary 短網址 年齡分布
     * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsAgedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsAgedist(urlGroupStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址點擊數據
     * @param {UrlGroupStatsClicksRq} [urlGroupStatsClicksRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsClicks(urlGroupStatsClicksRq?: UrlGroupStatsClicksRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsClicks(urlGroupStatsClicksRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址點擊統計
     * @param {UrlGroupStatsClickSummaryRq} [urlGroupStatsClickSummaryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq?: UrlGroupStatsClickSummaryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsClicksummary(urlGroupStatsClickSummaryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 裝置分布
     * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsDevicedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsDevicedist(urlGroupStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 性別分布
     * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsGenderdist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsGenderdist(urlGroupStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址資訊
     * @param {UrlGroupStatsInfoRq} [urlGroupStatsInfoRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsGroupinfo(urlGroupStatsInfoRq?: UrlGroupStatsInfoRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsGroupinfo(urlGroupStatsInfoRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 地區分布
     * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsRegiondist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsRegiondist(urlGroupStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 來源分布
     * @param {UrlGroupStatsQueryRq} [urlGroupStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupStatsApi
     */
    public urlgroupstatsSourcedist(urlGroupStatsQueryRq?: UrlGroupStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupStatsApiFp(this.configuration).urlgroupstatsSourcedist(urlGroupStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendUrlGroupingApi - axios parameter creator
 * @export
 */
export const FrontendUrlGroupingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址群組
         * @param {FEUrlGroupingAppendTagToUrlGroupRq} [fEUrlGroupingAppendTagToUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingAppendtagtourls: async (fEUrlGroupingAppendTagToUrlGroupRq?: FEUrlGroupingAppendTagToUrlGroupRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/AppendTagToUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingAppendTagToUrlGroupRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {FEUrlGroupingCreateRq} [fEUrlGroupingCreateRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingCreate: async (fEUrlGroupingCreateRq?: FEUrlGroupingCreateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingCreateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 群組資料 - 刪除
         * @param {FEUrlGroupingDeleteRq} [fEUrlGroupingDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingDelete: async (fEUrlGroupingDeleteRq?: FEUrlGroupingDeleteRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingDeleteRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {FEUrlGroupingExportSelectedRq} [fEUrlGroupingExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingExportselected: async (fEUrlGroupingExportSelectedRq?: FEUrlGroupingExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query
         * @param {FEUrlGroupingQueryRq} [fEUrlGroupingQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQuery: async (fEUrlGroupingQueryRq?: FEUrlGroupingQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/Query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址群組列表
         * @param {FEUrlGroupingQueryAllRq} [fEUrlGroupingQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryall: async (fEUrlGroupingQueryAllRq?: FEUrlGroupingQueryAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/QueryAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingQueryAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址群組列表 (總筆數)
         * @param {FEUrlGroupingQueryAllSubtotalRq} [fEUrlGroupingQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryallsubtotal: async (fEUrlGroupingQueryAllSubtotalRq?: FEUrlGroupingQueryAllSubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/QueryAllSubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingQueryAllSubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單
         * @param {FEUrlGroupingQueryUrlListRq} [fEUrlGroupingQueryUrlListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryurllist: async (fEUrlGroupingQueryUrlListRq?: FEUrlGroupingQueryUrlListRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/QueryUrlList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingQueryUrlListRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單 (總筆數)
         * @param {FEUrlGroupingQueryUrlListSubtotalRq} [fEUrlGroupingQueryUrlListSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryurllistsubtotal: async (fEUrlGroupingQueryUrlListSubtotalRq?: FEUrlGroupingQueryUrlListSubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/QueryUrlListSubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingQueryUrlListSubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移除標籤 從 短網址群組
         * @param {FEUrlGroupingRemoveTagFromUrlGroupRq} [fEUrlGroupingRemoveTagFromUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingRemovetagfromurls: async (fEUrlGroupingRemoveTagFromUrlGroupRq?: FEUrlGroupingRemoveTagFromUrlGroupRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/RemoveTagFromUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingRemoveTagFromUrlGroupRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址群組 - 個別新增短網址
         * @param {FEUrlGroupingSingleUrlCreateRq} [fEUrlGroupingSingleUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingSingleurlcreate: async (fEUrlGroupingSingleUrlCreateRq?: FEUrlGroupingSingleUrlCreateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/SingleUrlCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingSingleUrlCreateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update
         * @param {FEUrlGroupingUpdateRq} [fEUrlGroupingUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingUpdate: async (fEUrlGroupingUpdateRq?: FEUrlGroupingUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlGrouping/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUrlGroupingUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendUrlGroupingApi - functional programming interface
 * @export
 */
export const FrontendUrlGroupingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendUrlGroupingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址群組
         * @param {FEUrlGroupingAppendTagToUrlGroupRq} [fEUrlGroupingAppendTagToUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq?: FEUrlGroupingAppendTagToUrlGroupRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingAppendtagtourls']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create
         * @param {FEUrlGroupingCreateRq} [fEUrlGroupingCreateRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingCreate(fEUrlGroupingCreateRq?: FEUrlGroupingCreateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingCreate(fEUrlGroupingCreateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 群組資料 - 刪除
         * @param {FEUrlGroupingDeleteRq} [fEUrlGroupingDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingDelete(fEUrlGroupingDeleteRq?: FEUrlGroupingDeleteRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingDelete(fEUrlGroupingDeleteRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {FEUrlGroupingExportSelectedRq} [fEUrlGroupingExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingExportselected(fEUrlGroupingExportSelectedRq?: FEUrlGroupingExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingExportselected(fEUrlGroupingExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Query
         * @param {FEUrlGroupingQueryRq} [fEUrlGroupingQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingQuery(fEUrlGroupingQueryRq?: FEUrlGroupingQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUrlGroupingQueryRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingQuery(fEUrlGroupingQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址群組列表
         * @param {FEUrlGroupingQueryAllRq} [fEUrlGroupingQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingQueryall(fEUrlGroupingQueryAllRq?: FEUrlGroupingQueryAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FEUrlGroupingQueryAllRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingQueryall(fEUrlGroupingQueryAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingQueryall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址群組列表 (總筆數)
         * @param {FEUrlGroupingQueryAllSubtotalRq} [fEUrlGroupingQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq?: FEUrlGroupingQueryAllSubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUrlGroupingQueryAllSubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingQueryallsubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單
         * @param {FEUrlGroupingQueryUrlListRq} [fEUrlGroupingQueryUrlListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq?: FEUrlGroupingQueryUrlListRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FEUrlGroupingQueryUrlListRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingQueryurllist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單 (總筆數)
         * @param {FEUrlGroupingQueryUrlListSubtotalRq} [fEUrlGroupingQueryUrlListSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq?: FEUrlGroupingQueryUrlListSubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUrlGroupingQueryUrlListSubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingQueryurllistsubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 移除標籤 從 短網址群組
         * @param {FEUrlGroupingRemoveTagFromUrlGroupRq} [fEUrlGroupingRemoveTagFromUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq?: FEUrlGroupingRemoveTagFromUrlGroupRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingRemovetagfromurls']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址群組 - 個別新增短網址
         * @param {FEUrlGroupingSingleUrlCreateRq} [fEUrlGroupingSingleUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq?: FEUrlGroupingSingleUrlCreateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingSingleurlcreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update
         * @param {FEUrlGroupingUpdateRq} [fEUrlGroupingUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlgroupingUpdate(fEUrlGroupingUpdateRq?: FEUrlGroupingUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlgroupingUpdate(fEUrlGroupingUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlGroupingApi.urlgroupingUpdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendUrlGroupingApi - factory interface
 * @export
 */
export const FrontendUrlGroupingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendUrlGroupingApiFp(configuration)
    return {
        /**
         * 
         * @summary 新增標籤 至 短網址群組
         * @param {FEUrlGroupingAppendTagToUrlGroupRq} [fEUrlGroupingAppendTagToUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq?: FEUrlGroupingAppendTagToUrlGroupRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {FEUrlGroupingCreateRq} [fEUrlGroupingCreateRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingCreate(fEUrlGroupingCreateRq?: FEUrlGroupingCreateRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingCreate(fEUrlGroupingCreateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 群組資料 - 刪除
         * @param {FEUrlGroupingDeleteRq} [fEUrlGroupingDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingDelete(fEUrlGroupingDeleteRq?: FEUrlGroupingDeleteRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingDelete(fEUrlGroupingDeleteRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案
         * @param {FEUrlGroupingExportSelectedRq} [fEUrlGroupingExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingExportselected(fEUrlGroupingExportSelectedRq?: FEUrlGroupingExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingExportselected(fEUrlGroupingExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query
         * @param {FEUrlGroupingQueryRq} [fEUrlGroupingQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQuery(fEUrlGroupingQueryRq?: FEUrlGroupingQueryRq, options?: any): AxiosPromise<FEUrlGroupingQueryRs> {
            return localVarFp.urlgroupingQuery(fEUrlGroupingQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址群組列表
         * @param {FEUrlGroupingQueryAllRq} [fEUrlGroupingQueryAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryall(fEUrlGroupingQueryAllRq?: FEUrlGroupingQueryAllRq, options?: any): AxiosPromise<Array<FEUrlGroupingQueryAllRs>> {
            return localVarFp.urlgroupingQueryall(fEUrlGroupingQueryAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址群組列表 (總筆數)
         * @param {FEUrlGroupingQueryAllSubtotalRq} [fEUrlGroupingQueryAllSubtotalRq] rq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq?: FEUrlGroupingQueryAllSubtotalRq, options?: any): AxiosPromise<FEUrlGroupingQueryAllSubtotalRs> {
            return localVarFp.urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單
         * @param {FEUrlGroupingQueryUrlListRq} [fEUrlGroupingQueryUrlListRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq?: FEUrlGroupingQueryUrlListRq, options?: any): AxiosPromise<Array<FEUrlGroupingQueryUrlListRs>> {
            return localVarFp.urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址群組 - 網址清單 (總筆數)
         * @param {FEUrlGroupingQueryUrlListSubtotalRq} [fEUrlGroupingQueryUrlListSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq?: FEUrlGroupingQueryUrlListSubtotalRq, options?: any): AxiosPromise<FEUrlGroupingQueryUrlListSubtotalRs> {
            return localVarFp.urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移除標籤 從 短網址群組
         * @param {FEUrlGroupingRemoveTagFromUrlGroupRq} [fEUrlGroupingRemoveTagFromUrlGroupRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq?: FEUrlGroupingRemoveTagFromUrlGroupRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址群組 - 個別新增短網址
         * @param {FEUrlGroupingSingleUrlCreateRq} [fEUrlGroupingSingleUrlCreateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq?: FEUrlGroupingSingleUrlCreateRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update
         * @param {FEUrlGroupingUpdateRq} [fEUrlGroupingUpdateRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlgroupingUpdate(fEUrlGroupingUpdateRq?: FEUrlGroupingUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.urlgroupingUpdate(fEUrlGroupingUpdateRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendUrlGroupingApi - object-oriented interface
 * @export
 * @class FrontendUrlGroupingApi
 * @extends {BaseAPI}
 */
export class FrontendUrlGroupingApi extends BaseAPI {
    /**
     * 
     * @summary 新增標籤 至 短網址群組
     * @param {FEUrlGroupingAppendTagToUrlGroupRq} [fEUrlGroupingAppendTagToUrlGroupRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq?: FEUrlGroupingAppendTagToUrlGroupRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingAppendtagtourls(fEUrlGroupingAppendTagToUrlGroupRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {FEUrlGroupingCreateRq} [fEUrlGroupingCreateRq] rq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingCreate(fEUrlGroupingCreateRq?: FEUrlGroupingCreateRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingCreate(fEUrlGroupingCreateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 群組資料 - 刪除
     * @param {FEUrlGroupingDeleteRq} [fEUrlGroupingDeleteRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingDelete(fEUrlGroupingDeleteRq?: FEUrlGroupingDeleteRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingDelete(fEUrlGroupingDeleteRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案
     * @param {FEUrlGroupingExportSelectedRq} [fEUrlGroupingExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingExportselected(fEUrlGroupingExportSelectedRq?: FEUrlGroupingExportSelectedRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingExportselected(fEUrlGroupingExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query
     * @param {FEUrlGroupingQueryRq} [fEUrlGroupingQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingQuery(fEUrlGroupingQueryRq?: FEUrlGroupingQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingQuery(fEUrlGroupingQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址群組列表
     * @param {FEUrlGroupingQueryAllRq} [fEUrlGroupingQueryAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingQueryall(fEUrlGroupingQueryAllRq?: FEUrlGroupingQueryAllRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingQueryall(fEUrlGroupingQueryAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址群組列表 (總筆數)
     * @param {FEUrlGroupingQueryAllSubtotalRq} [fEUrlGroupingQueryAllSubtotalRq] rq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq?: FEUrlGroupingQueryAllSubtotalRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingQueryallsubtotal(fEUrlGroupingQueryAllSubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址群組 - 網址清單
     * @param {FEUrlGroupingQueryUrlListRq} [fEUrlGroupingQueryUrlListRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq?: FEUrlGroupingQueryUrlListRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingQueryurllist(fEUrlGroupingQueryUrlListRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址群組 - 網址清單 (總筆數)
     * @param {FEUrlGroupingQueryUrlListSubtotalRq} [fEUrlGroupingQueryUrlListSubtotalRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq?: FEUrlGroupingQueryUrlListSubtotalRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingQueryurllistsubtotal(fEUrlGroupingQueryUrlListSubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移除標籤 從 短網址群組
     * @param {FEUrlGroupingRemoveTagFromUrlGroupRq} [fEUrlGroupingRemoveTagFromUrlGroupRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq?: FEUrlGroupingRemoveTagFromUrlGroupRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingRemovetagfromurls(fEUrlGroupingRemoveTagFromUrlGroupRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址群組 - 個別新增短網址
     * @param {FEUrlGroupingSingleUrlCreateRq} [fEUrlGroupingSingleUrlCreateRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq?: FEUrlGroupingSingleUrlCreateRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingSingleurlcreate(fEUrlGroupingSingleUrlCreateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update
     * @param {FEUrlGroupingUpdateRq} [fEUrlGroupingUpdateRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlGroupingApi
     */
    public urlgroupingUpdate(fEUrlGroupingUpdateRq?: FEUrlGroupingUpdateRq, options?: AxiosRequestConfig) {
        return FrontendUrlGroupingApiFp(this.configuration).urlgroupingUpdate(fEUrlGroupingUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendUrlStatisticsApi - axios parameter creator
 * @export
 */
export const FrontendUrlStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsAgedist: async (urlStatsQueryRq?: UrlStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/AgeDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlStatsClicksRq} [urlStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsClicks: async (urlStatsClicksRq?: UrlStatsClicksRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/Clicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsClicksRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlClickSummaryRq} [urlClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsClicksummary: async (urlClickSummaryRq?: UrlClickSummaryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/ClickSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlClickSummaryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsDevicedist: async (urlStatsQueryRq?: UrlStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/DeviceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsGenderdist: async (urlStatsQueryRq?: UrlStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/GenderDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsRegiondist: async (urlStatsQueryRq?: UrlStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/RegionDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsSourcedist: async (urlStatsQueryRq?: UrlStatsQueryRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/SourceDist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsQueryRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlStatsUrlInfoRq} [urlStatsUrlInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsUrlinfo: async (urlStatsUrlInfoRq?: UrlStatsUrlInfoRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UrlStatistics/UrlInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urlStatsUrlInfoRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendUrlStatisticsApi - functional programming interface
 * @export
 */
export const FrontendUrlStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendUrlStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsAgedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsAgeDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsAgedist(urlStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsAgedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlStatsClicksRq} [urlStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsClicks(urlStatsClicksRq?: UrlStatsClicksRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsClicksRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsClicks(urlStatsClicksRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsClicks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlClickSummaryRq} [urlClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsClicksummary(urlClickSummaryRq?: UrlClickSummaryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsClickSummaryRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsClicksummary(urlClickSummaryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsClicksummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsDevicedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsDeviceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsDevicedist(urlStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsDevicedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsGenderdist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsGenderDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsGenderdist(urlStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsGenderdist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsRegiondist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsRegionDistRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsRegiondist(urlStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsRegiondist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsSourcedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatisticsSourceDistRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsSourcedist(urlStatsQueryRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsSourcedist']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlStatsUrlInfoRq} [urlStatsUrlInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlstatisticsUrlinfo(urlStatsUrlInfoRq?: UrlStatsUrlInfoRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlStatsUrlInfoRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.urlstatisticsUrlinfo(urlStatsUrlInfoRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUrlStatisticsApi.urlstatisticsUrlinfo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendUrlStatisticsApi - factory interface
 * @export
 */
export const FrontendUrlStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendUrlStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary 短網址 年齡分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsAgedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsAgeDistRs>> {
            return localVarFp.urlstatisticsAgedist(urlStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址點擊數據
         * @param {UrlStatsClicksRq} [urlStatsClicksRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsClicks(urlStatsClicksRq?: UrlStatsClicksRq, options?: any): AxiosPromise<StatisticsClicksRs> {
            return localVarFp.urlstatisticsClicks(urlStatsClicksRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址點擊統計
         * @param {UrlClickSummaryRq} [urlClickSummaryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsClicksummary(urlClickSummaryRq?: UrlClickSummaryRq, options?: any): AxiosPromise<StatisticsClickSummaryRs> {
            return localVarFp.urlstatisticsClicksummary(urlClickSummaryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 裝置分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsDevicedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsDeviceDistRs>> {
            return localVarFp.urlstatisticsDevicedist(urlStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 性別分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsGenderdist(urlStatsQueryRq?: UrlStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsGenderDistRs>> {
            return localVarFp.urlstatisticsGenderdist(urlStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 地區分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsRegiondist(urlStatsQueryRq?: UrlStatsQueryRq, options?: any): AxiosPromise<StatisticsRegionDistRs> {
            return localVarFp.urlstatisticsRegiondist(urlStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 短網址 來源分布
         * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsSourcedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: any): AxiosPromise<Array<StatisticsSourceDistRs>> {
            return localVarFp.urlstatisticsSourcedist(urlStatsQueryRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢短網址資訊
         * @param {UrlStatsUrlInfoRq} [urlStatsUrlInfoRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlstatisticsUrlinfo(urlStatsUrlInfoRq?: UrlStatsUrlInfoRq, options?: any): AxiosPromise<UrlStatsUrlInfoRs> {
            return localVarFp.urlstatisticsUrlinfo(urlStatsUrlInfoRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendUrlStatisticsApi - object-oriented interface
 * @export
 * @class FrontendUrlStatisticsApi
 * @extends {BaseAPI}
 */
export class FrontendUrlStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary 短網址 年齡分布
     * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsAgedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsAgedist(urlStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址點擊數據
     * @param {UrlStatsClicksRq} [urlStatsClicksRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsClicks(urlStatsClicksRq?: UrlStatsClicksRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsClicks(urlStatsClicksRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址點擊統計
     * @param {UrlClickSummaryRq} [urlClickSummaryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsClicksummary(urlClickSummaryRq?: UrlClickSummaryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsClicksummary(urlClickSummaryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 裝置分布
     * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsDevicedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsDevicedist(urlStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 性別分布
     * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsGenderdist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsGenderdist(urlStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 地區分布
     * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsRegiondist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsRegiondist(urlStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 短網址 來源分布
     * @param {UrlStatsQueryRq} [urlStatsQueryRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsSourcedist(urlStatsQueryRq?: UrlStatsQueryRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsSourcedist(urlStatsQueryRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢短網址資訊
     * @param {UrlStatsUrlInfoRq} [urlStatsUrlInfoRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUrlStatisticsApi
     */
    public urlstatisticsUrlinfo(urlStatsUrlInfoRq?: UrlStatsUrlInfoRq, options?: AxiosRequestConfig) {
        return FrontendUrlStatisticsApiFp(this.configuration).urlstatisticsUrlinfo(urlStatsUrlInfoRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontendUserProfileApi - axios parameter creator
 * @export
 */
export const FrontendUserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 綁定 sso token
         * @param {UserProfileBindSsoTokenRq} [userProfileBindSsoTokenRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileBindssotoken: async (userProfileBindSsoTokenRq?: UserProfileBindSsoTokenRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/BindSsoToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userProfileBindSsoTokenRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除 當前 user 綁定 sso 帳號
         * @param {UserProfileDeleteCurrentUserBindSsoAccountRq} [userProfileDeleteCurrentUserBindSsoAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileDeletecurrentuserbindssoaccount: async (userProfileDeleteCurrentUserBindSsoAccountRq?: UserProfileDeleteCurrentUserBindSsoAccountRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/DeleteCurrentUserBindSsoAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userProfileDeleteCurrentUserBindSsoAccountRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢當前使用者綁定 sso 帳號清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileGetcurrentuserbindssoaccounts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/GetCurrentUserBindSsoAccounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 current user phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileGetphonenumber: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/GetPhoneNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除當前用戶圖像
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileRemoveuseravatar: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/RemoveUserAvatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 請求 email 變更
         * @param {FEUserProfileRequestEmailChangeRq} [fEUserProfileRequestEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileRequestemailchange: async (fEUserProfileRequestEmailChangeRq?: FEUserProfileRequestEmailChangeRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/RequestEmailChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileRequestEmailChangeRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 重新寄送驗證碼
         * @param {FEUserProfileResendVerificationCodeRq} [fEUserProfileResendVerificationCodeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileResendverificationcode: async (fEUserProfileResendVerificationCodeRq?: FEUserProfileResendVerificationCodeRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/ResendVerificationCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileResendVerificationCodeRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 名稱變更
         * @param {FEUserProfileUpdateNameRq} [fEUserProfileUpdateNameRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatename: async (fEUserProfileUpdateNameRq?: FEUserProfileUpdateNameRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/UpdateName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileUpdateNameRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 密碼變更
         * @param {FEUserProfileUpdatePasswordRq} [fEUserProfileUpdatePasswordRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatepassword: async (fEUserProfileUpdatePasswordRq?: FEUserProfileUpdatePasswordRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/UpdatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileUpdatePasswordRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 手機號碼變更
         * @param {FEUserProfileUpdatePhoneNumberRq} [fEUserProfileUpdatePhoneNumberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatephonenumber: async (fEUserProfileUpdatePhoneNumberRq?: FEUserProfileUpdatePhoneNumberRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/UpdatePhoneNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileUpdatePhoneNumberRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 上傳用戶圖像
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUploadimage: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/UploadImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 驗證 email 變更
         * @param {FEUserProfileVerifyEmailChangeRq} [fEUserProfileVerifyEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileVerifyemailchange: async (fEUserProfileVerifyEmailChangeRq?: FEUserProfileVerifyEmailChangeRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Frontend/UserProfile/VerifyEmailChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fEUserProfileVerifyEmailChangeRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendUserProfileApi - functional programming interface
 * @export
 */
export const FrontendUserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendUserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 綁定 sso token
         * @param {UserProfileBindSsoTokenRq} [userProfileBindSsoTokenRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileBindssotoken(userProfileBindSsoTokenRq?: UserProfileBindSsoTokenRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileBindssotoken(userProfileBindSsoTokenRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileBindssotoken']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除 當前 user 綁定 sso 帳號
         * @param {UserProfileDeleteCurrentUserBindSsoAccountRq} [userProfileDeleteCurrentUserBindSsoAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq?: UserProfileDeleteCurrentUserBindSsoAccountRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileDeletecurrentuserbindssoaccount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢當前使用者綁定 sso 帳號清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileGetcurrentuserbindssoaccounts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserProfileGetCurrentUserBindSsoAccountsRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileGetcurrentuserbindssoaccounts(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileGetcurrentuserbindssoaccounts']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 current user phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileGetphonenumber(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUserProfileGetPhoneNumberRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileGetphonenumber(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileGetphonenumber']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除當前用戶圖像
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileRemoveuseravatar(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileRemoveuseravatar(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileRemoveuseravatar']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 請求 email 變更
         * @param {FEUserProfileRequestEmailChangeRq} [fEUserProfileRequestEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq?: FEUserProfileRequestEmailChangeRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUserProfileRequestEmailChangeRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileRequestemailchange']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 重新寄送驗證碼
         * @param {FEUserProfileResendVerificationCodeRq} [fEUserProfileResendVerificationCodeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq?: FEUserProfileResendVerificationCodeRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUserProfileResendVerificationCodeRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileResendverificationcode']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 名稱變更
         * @param {FEUserProfileUpdateNameRq} [fEUserProfileUpdateNameRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileUpdatename(fEUserProfileUpdateNameRq?: FEUserProfileUpdateNameRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileUpdatename(fEUserProfileUpdateNameRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileUpdatename']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 密碼變更
         * @param {FEUserProfileUpdatePasswordRq} [fEUserProfileUpdatePasswordRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileUpdatepassword(fEUserProfileUpdatePasswordRq?: FEUserProfileUpdatePasswordRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUserProfileUpdatePasswordRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileUpdatepassword(fEUserProfileUpdatePasswordRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileUpdatepassword']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 手機號碼變更
         * @param {FEUserProfileUpdatePhoneNumberRq} [fEUserProfileUpdatePhoneNumberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq?: FEUserProfileUpdatePhoneNumberRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileUpdatephonenumber']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 上傳用戶圖像
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileUploadimage(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileUploadimage(file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileUploadimage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 驗證 email 變更
         * @param {FEUserProfileVerifyEmailChangeRq} [fEUserProfileVerifyEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq?: FEUserProfileVerifyEmailChangeRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FEUserProfileVerifyEmailChangeRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FrontendUserProfileApi.userprofileVerifyemailchange']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FrontendUserProfileApi - factory interface
 * @export
 */
export const FrontendUserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendUserProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary 綁定 sso token
         * @param {UserProfileBindSsoTokenRq} [userProfileBindSsoTokenRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileBindssotoken(userProfileBindSsoTokenRq?: UserProfileBindSsoTokenRq, options?: any): AxiosPromise<void> {
            return localVarFp.userprofileBindssotoken(userProfileBindSsoTokenRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除 當前 user 綁定 sso 帳號
         * @param {UserProfileDeleteCurrentUserBindSsoAccountRq} [userProfileDeleteCurrentUserBindSsoAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq?: UserProfileDeleteCurrentUserBindSsoAccountRq, options?: any): AxiosPromise<void> {
            return localVarFp.userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢當前使用者綁定 sso 帳號清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileGetcurrentuserbindssoaccounts(options?: any): AxiosPromise<Array<UserProfileGetCurrentUserBindSsoAccountsRs>> {
            return localVarFp.userprofileGetcurrentuserbindssoaccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 current user phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileGetphonenumber(options?: any): AxiosPromise<FEUserProfileGetPhoneNumberRs> {
            return localVarFp.userprofileGetphonenumber(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除當前用戶圖像
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileRemoveuseravatar(options?: any): AxiosPromise<void> {
            return localVarFp.userprofileRemoveuseravatar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 請求 email 變更
         * @param {FEUserProfileRequestEmailChangeRq} [fEUserProfileRequestEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq?: FEUserProfileRequestEmailChangeRq, options?: any): AxiosPromise<FEUserProfileRequestEmailChangeRs> {
            return localVarFp.userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 重新寄送驗證碼
         * @param {FEUserProfileResendVerificationCodeRq} [fEUserProfileResendVerificationCodeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq?: FEUserProfileResendVerificationCodeRq, options?: any): AxiosPromise<FEUserProfileResendVerificationCodeRs> {
            return localVarFp.userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 名稱變更
         * @param {FEUserProfileUpdateNameRq} [fEUserProfileUpdateNameRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatename(fEUserProfileUpdateNameRq?: FEUserProfileUpdateNameRq, options?: any): AxiosPromise<void> {
            return localVarFp.userprofileUpdatename(fEUserProfileUpdateNameRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 密碼變更
         * @param {FEUserProfileUpdatePasswordRq} [fEUserProfileUpdatePasswordRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatepassword(fEUserProfileUpdatePasswordRq?: FEUserProfileUpdatePasswordRq, options?: any): AxiosPromise<FEUserProfileUpdatePasswordRs> {
            return localVarFp.userprofileUpdatepassword(fEUserProfileUpdatePasswordRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 手機號碼變更
         * @param {FEUserProfileUpdatePhoneNumberRq} [fEUserProfileUpdatePhoneNumberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq?: FEUserProfileUpdatePhoneNumberRq, options?: any): AxiosPromise<void> {
            return localVarFp.userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 上傳用戶圖像
         * @param {File} [file] file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileUploadimage(file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.userprofileUploadimage(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 驗證 email 變更
         * @param {FEUserProfileVerifyEmailChangeRq} [fEUserProfileVerifyEmailChangeRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq?: FEUserProfileVerifyEmailChangeRq, options?: any): AxiosPromise<FEUserProfileVerifyEmailChangeRs> {
            return localVarFp.userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendUserProfileApi - object-oriented interface
 * @export
 * @class FrontendUserProfileApi
 * @extends {BaseAPI}
 */
export class FrontendUserProfileApi extends BaseAPI {
    /**
     * 
     * @summary 綁定 sso token
     * @param {UserProfileBindSsoTokenRq} [userProfileBindSsoTokenRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileBindssotoken(userProfileBindSsoTokenRq?: UserProfileBindSsoTokenRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileBindssotoken(userProfileBindSsoTokenRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除 當前 user 綁定 sso 帳號
     * @param {UserProfileDeleteCurrentUserBindSsoAccountRq} [userProfileDeleteCurrentUserBindSsoAccountRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq?: UserProfileDeleteCurrentUserBindSsoAccountRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileDeletecurrentuserbindssoaccount(userProfileDeleteCurrentUserBindSsoAccountRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢當前使用者綁定 sso 帳號清單
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileGetcurrentuserbindssoaccounts(options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileGetcurrentuserbindssoaccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 current user phone number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileGetphonenumber(options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileGetphonenumber(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除當前用戶圖像
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileRemoveuseravatar(options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileRemoveuseravatar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 請求 email 變更
     * @param {FEUserProfileRequestEmailChangeRq} [fEUserProfileRequestEmailChangeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq?: FEUserProfileRequestEmailChangeRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileRequestemailchange(fEUserProfileRequestEmailChangeRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 重新寄送驗證碼
     * @param {FEUserProfileResendVerificationCodeRq} [fEUserProfileResendVerificationCodeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq?: FEUserProfileResendVerificationCodeRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileResendverificationcode(fEUserProfileResendVerificationCodeRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 名稱變更
     * @param {FEUserProfileUpdateNameRq} [fEUserProfileUpdateNameRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileUpdatename(fEUserProfileUpdateNameRq?: FEUserProfileUpdateNameRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileUpdatename(fEUserProfileUpdateNameRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 密碼變更
     * @param {FEUserProfileUpdatePasswordRq} [fEUserProfileUpdatePasswordRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileUpdatepassword(fEUserProfileUpdatePasswordRq?: FEUserProfileUpdatePasswordRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileUpdatepassword(fEUserProfileUpdatePasswordRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 手機號碼變更
     * @param {FEUserProfileUpdatePhoneNumberRq} [fEUserProfileUpdatePhoneNumberRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq?: FEUserProfileUpdatePhoneNumberRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileUpdatephonenumber(fEUserProfileUpdatePhoneNumberRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 上傳用戶圖像
     * @param {File} [file] file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileUploadimage(file?: File, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileUploadimage(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 驗證 email 變更
     * @param {FEUserProfileVerifyEmailChangeRq} [fEUserProfileVerifyEmailChangeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendUserProfileApi
     */
    public userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq?: FEUserProfileVerifyEmailChangeRq, options?: AxiosRequestConfig) {
        return FrontendUserProfileApiFp(this.configuration).userprofileVerifyemailchange(fEUserProfileVerifyEmailChangeRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagsTagApi - axios parameter creator
 * @export
 */
export const TagsTagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 建立標 主籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagCreate: async (mainTagUpdateRq?: MainTagUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mainTagUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除 主標籤
         * @param {MainTagDeleteRq} [mainTagDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagDelete: async (mainTagDeleteRq?: MainTagDeleteRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mainTagDeleteRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {TagExportAllRq} [tagExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagExportall: async (tagExportAllRq?: TagExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {TagExportSelectedRq} [tagExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagExportselected: async (tagExportSelectedRq?: TagExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 資料列表
         * @param {TagQueryAllRq} [tagQueryAllRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQueryall: async (tagQueryAllRq?: TagQueryAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/QueryAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagQueryAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 資料列表明細
         * @param {TagQueryDetailRq} [tagQueryDetailRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerydetail: async (tagQueryDetailRq?: TagQueryDetailRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/QueryDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagQueryDetailRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {QuerySubtotalRq} [querySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerysubtotal: async (querySubtotalRq?: QuerySubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/QuerySubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(querySubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 標籤明細
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerytaginfo: async (mainTagId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/QueryTagInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mainTagId !== undefined) {
                localVarQueryParameter['mainTagId'] = mainTagId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新 主標籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagUpdate: async (mainTagUpdateRq?: MainTagUpdateRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Tags/Tag/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mainTagUpdateRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsTagApi - functional programming interface
 * @export
 */
export const TagsTagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsTagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 建立標 主籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagCreate(mainTagUpdateRq?: MainTagUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagCreate(mainTagUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除 主標籤
         * @param {MainTagDeleteRq} [mainTagDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagDelete(mainTagDeleteRq?: MainTagDeleteRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagDelete(mainTagDeleteRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {TagExportAllRq} [tagExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagExportall(tagExportAllRq?: TagExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagExportall(tagExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {TagExportSelectedRq} [tagExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagExportselected(tagExportSelectedRq?: TagExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagExportselected(tagExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 資料列表
         * @param {TagQueryAllRq} [tagQueryAllRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagQueryall(tagQueryAllRq?: TagQueryAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagQueryAllRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagQueryall(tagQueryAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagQueryall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 資料列表明細
         * @param {TagQueryDetailRq} [tagQueryDetailRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagQuerydetail(tagQueryDetailRq?: TagQueryDetailRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagQueryDetailRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagQuerydetail(tagQueryDetailRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagQuerydetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {QuerySubtotalRq} [querySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagQuerysubtotal(querySubtotalRq?: QuerySubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagQuerysubtotal(querySubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagQuerysubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 標籤明細
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagQuerytaginfo(mainTagId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MainTagUpdateRq>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagQuerytaginfo(mainTagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagQuerytaginfo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 更新 主標籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagUpdate(mainTagUpdateRq?: MainTagUpdateRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagUpdate(mainTagUpdateRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsTagApi.tagUpdate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TagsTagApi - factory interface
 * @export
 */
export const TagsTagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsTagApiFp(configuration)
    return {
        /**
         * 
         * @summary 建立標 主籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagCreate(mainTagUpdateRq?: MainTagUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.tagCreate(mainTagUpdateRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除 主標籤
         * @param {MainTagDeleteRq} [mainTagDeleteRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagDelete(mainTagDeleteRq?: MainTagDeleteRq, options?: any): AxiosPromise<void> {
            return localVarFp.tagDelete(mainTagDeleteRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {TagExportAllRq} [tagExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagExportall(tagExportAllRq?: TagExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.tagExportall(tagExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {TagExportSelectedRq} [tagExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagExportselected(tagExportSelectedRq?: TagExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.tagExportselected(tagExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 資料列表
         * @param {TagQueryAllRq} [tagQueryAllRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQueryall(tagQueryAllRq?: TagQueryAllRq, options?: any): AxiosPromise<Array<TagQueryAllRs>> {
            return localVarFp.tagQueryall(tagQueryAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 資料列表明細
         * @param {TagQueryDetailRq} [tagQueryDetailRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerydetail(tagQueryDetailRq?: TagQueryDetailRq, options?: any): AxiosPromise<Array<TagQueryDetailRs>> {
            return localVarFp.tagQuerydetail(tagQueryDetailRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 資料列表 - 小計數據
         * @param {QuerySubtotalRq} [querySubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerysubtotal(querySubtotalRq?: QuerySubtotalRq, options?: any): AxiosPromise<QuerySubtotalRs> {
            return localVarFp.tagQuerysubtotal(querySubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 標籤明細
         * @param {number} [mainTagId] 主標籤 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagQuerytaginfo(mainTagId?: number, options?: any): AxiosPromise<MainTagUpdateRq> {
            return localVarFp.tagQuerytaginfo(mainTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新 主標籤資料
         * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagUpdate(mainTagUpdateRq?: MainTagUpdateRq, options?: any): AxiosPromise<void> {
            return localVarFp.tagUpdate(mainTagUpdateRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagsTagApi - object-oriented interface
 * @export
 * @class TagsTagApi
 * @extends {BaseAPI}
 */
export class TagsTagApi extends BaseAPI {
    /**
     * 
     * @summary 建立標 主籤資料
     * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagCreate(mainTagUpdateRq?: MainTagUpdateRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagCreate(mainTagUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除 主標籤
     * @param {MainTagDeleteRq} [mainTagDeleteRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagDelete(mainTagDeleteRq?: MainTagDeleteRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagDelete(mainTagDeleteRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案 (csv)
     * @param {TagExportAllRq} [tagExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagExportall(tagExportAllRq?: TagExportAllRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagExportall(tagExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案 (csv)
     * @param {TagExportSelectedRq} [tagExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagExportselected(tagExportSelectedRq?: TagExportSelectedRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagExportselected(tagExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 資料列表
     * @param {TagQueryAllRq} [tagQueryAllRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagQueryall(tagQueryAllRq?: TagQueryAllRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagQueryall(tagQueryAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 資料列表明細
     * @param {TagQueryDetailRq} [tagQueryDetailRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagQuerydetail(tagQueryDetailRq?: TagQueryDetailRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagQuerydetail(tagQueryDetailRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 資料列表 - 小計數據
     * @param {QuerySubtotalRq} [querySubtotalRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagQuerysubtotal(querySubtotalRq?: QuerySubtotalRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagQuerysubtotal(querySubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 標籤明細
     * @param {number} [mainTagId] 主標籤 id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagQuerytaginfo(mainTagId?: number, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagQuerytaginfo(mainTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新 主標籤資料
     * @param {MainTagUpdateRq} [mainTagUpdateRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsTagApi
     */
    public tagUpdate(mainTagUpdateRq?: MainTagUpdateRq, options?: AxiosRequestConfig) {
        return TagsTagApiFp(this.configuration).tagUpdate(mainTagUpdateRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserMgmtCustomerApi - axios parameter creator
 * @export
 */
export const UserMgmtCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 刪除 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerDeletecurrentusercustomerregistrationlink: async (userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/DeleteCurrentUserCustomerRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateCustomerRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除客戶帳號
         * @param {UserMgmtDeleteCustomerAccount} [userMgmtDeleteCustomerAccount] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerDeletecustomeraccount: async (userMgmtDeleteCustomerAccount?: UserMgmtDeleteCustomerAccount, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/DeleteCustomerAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtDeleteCustomerAccount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtCustomerExportAllRq} [userMgmtCustomerExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerExportall: async (userMgmtCustomerExportAllRq?: UserMgmtCustomerExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtCustomerExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtCustomerExportSelectedRq} [userMgmtCustomerExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerExportselected: async (userMgmtCustomerExportSelectedRq?: UserMgmtCustomerExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtCustomerExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 產生 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerGeneratecurrentusercustomerregistrationlink: async (userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/GenerateCurrentUserCustomerRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateCustomerRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(客戶) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerGetcurrentuserpendingcustomerinvitationcount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/GetCurrentUserPendingCustomerInvitationCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycurrentusercustomerregistrationlink: async (userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/QueryCurrentUserCustomerRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateCustomerRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢當前使用者負責公司清單 (TOP 20)
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycurrentuserownedcompanies: async (term?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/QueryCurrentUserOwnedCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 客戶 - 小計數據
         * @param {UserMgmtQueryCustomerUserSubtotalRq} [userMgmtQueryCustomerUserSubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycustomersubtotal: async (userMgmtQueryCustomerUserSubtotalRq?: UserMgmtQueryCustomerUserSubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/QueryCustomerSubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtQueryCustomerUserSubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 客戶人員
         * @param {UserMgmtQueryCustomerUserRq} [userMgmtQueryCustomerUserRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycustomerusers: async (userMgmtQueryCustomerUserRq?: UserMgmtQueryCustomerUserRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/QueryCustomerUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtQueryCustomerUserRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移除客戶帳號所有權限 公司負責人 And 組織成員
         * @param {UserMgmtCustomerRemoveAllPermissionRq} [userMgmtCustomerRemoveAllPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerRemoveallpermission: async (userMgmtCustomerRemoveAllPermissionRq?: UserMgmtCustomerRemoveAllPermissionRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/RemoveAllPermission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtCustomerRemoveAllPermissionRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(客戶) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerResendcurrentuserallcustomerpendinginvitations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/ResendCurrentUserAllCustomerPendingInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 寄送 Customer 公司組織註冊邀請
         * @param {UserMgmtSendCustomerRegistrationInvitationRq} [userMgmtSendCustomerRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSendcustomerregistrationinvitation: async (userMgmtSendCustomerRegistrationInvitationRq?: UserMgmtSendCustomerRegistrationInvitationRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/SendCustomerRegistrationInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtSendCustomerRegistrationInvitationRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 驗證登入者是否是指定公司業務
         * @param {string} [companyUuid] company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerVerifycurrentuserascompanycontact: async (companyUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Customer/VerifyCurrentUserAsCompanyContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyUuid !== undefined) {
                localVarQueryParameter['companyUuid'] = companyUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMgmtCustomerApi - functional programming interface
 * @export
 */
export const UserMgmtCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserMgmtCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 刪除 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerDeletecurrentusercustomerregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除客戶帳號
         * @param {UserMgmtDeleteCustomerAccount} [userMgmtDeleteCustomerAccount] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerDeletecustomeraccount(userMgmtDeleteCustomerAccount?: UserMgmtDeleteCustomerAccount, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerDeletecustomeraccount(userMgmtDeleteCustomerAccount, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerDeletecustomeraccount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtCustomerExportAllRq} [userMgmtCustomerExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerExportall(userMgmtCustomerExportAllRq?: UserMgmtCustomerExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerExportall(userMgmtCustomerExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtCustomerExportSelectedRq} [userMgmtCustomerExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerExportselected(userMgmtCustomerExportSelectedRq?: UserMgmtCustomerExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerExportselected(userMgmtCustomerExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 產生 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGenerateCustomerRegistrationLinkRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerGeneratecurrentusercustomerregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(客戶) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerGetcurrentuserpendingcustomerinvitationcount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGetCurrentUserPendingCustomerInvitationCountRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerGetcurrentuserpendingcustomerinvitationcount(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerGetcurrentuserpendingcustomerinvitationcount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGenerateCustomerRegistrationLinkRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerQuerycurrentusercustomerregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢當前使用者負責公司清單 (TOP 20)
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerQuerycurrentuserownedcompanies(term?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMgmtQueryCurrentUserOwnedCompanyRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerQuerycurrentuserownedcompanies(term, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerQuerycurrentuserownedcompanies']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 客戶 - 小計數據
         * @param {UserMgmtQueryCustomerUserSubtotalRq} [userMgmtQueryCustomerUserSubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq?: UserMgmtQueryCustomerUserSubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtQueryCustomerUserSubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerQuerycustomersubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 客戶人員
         * @param {UserMgmtQueryCustomerUserRq} [userMgmtQueryCustomerUserRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerQuerycustomerusers(userMgmtQueryCustomerUserRq?: UserMgmtQueryCustomerUserRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMgmtQueryCustomerUserRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerQuerycustomerusers(userMgmtQueryCustomerUserRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerQuerycustomerusers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 移除客戶帳號所有權限 公司負責人 And 組織成員
         * @param {UserMgmtCustomerRemoveAllPermissionRq} [userMgmtCustomerRemoveAllPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq?: UserMgmtCustomerRemoveAllPermissionRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerRemoveallpermission']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(客戶) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerResendcurrentuserallcustomerpendinginvitations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerResendcurrentuserallcustomerpendinginvitations(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerResendcurrentuserallcustomerpendinginvitations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 寄送 Customer 公司組織註冊邀請
         * @param {UserMgmtSendCustomerRegistrationInvitationRq} [userMgmtSendCustomerRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq?: UserMgmtSendCustomerRegistrationInvitationRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerSendcustomerregistrationinvitation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 驗證登入者是否是指定公司業務
         * @param {string} [companyUuid] company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerVerifycurrentuserascompanycontact(companyUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtVerifyCurrentUserAsCompanyContactRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerVerifycurrentuserascompanycontact(companyUuid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtCustomerApi.customerVerifycurrentuserascompanycontact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UserMgmtCustomerApi - factory interface
 * @export
 */
export const UserMgmtCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserMgmtCustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary 刪除 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: any): AxiosPromise<void> {
            return localVarFp.customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除客戶帳號
         * @param {UserMgmtDeleteCustomerAccount} [userMgmtDeleteCustomerAccount] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerDeletecustomeraccount(userMgmtDeleteCustomerAccount?: UserMgmtDeleteCustomerAccount, options?: any): AxiosPromise<void> {
            return localVarFp.customerDeletecustomeraccount(userMgmtDeleteCustomerAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtCustomerExportAllRq} [userMgmtCustomerExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerExportall(userMgmtCustomerExportAllRq?: UserMgmtCustomerExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.customerExportall(userMgmtCustomerExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtCustomerExportSelectedRq} [userMgmtCustomerExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerExportselected(userMgmtCustomerExportSelectedRq?: UserMgmtCustomerExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.customerExportselected(userMgmtCustomerExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 產生 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: any): AxiosPromise<UserMgmtGenerateCustomerRegistrationLinkRs> {
            return localVarFp.customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(客戶) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerGetcurrentuserpendingcustomerinvitationcount(options?: any): AxiosPromise<UserMgmtGetCurrentUserPendingCustomerInvitationCountRs> {
            return localVarFp.customerGetcurrentuserpendingcustomerinvitationcount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 Customer 公司組織註冊連結
         * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: any): AxiosPromise<UserMgmtGenerateCustomerRegistrationLinkRs> {
            return localVarFp.customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢當前使用者負責公司清單 (TOP 20)
         * @param {string} [term] 關鍵字查詢
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycurrentuserownedcompanies(term?: string, options?: any): AxiosPromise<Array<UserMgmtQueryCurrentUserOwnedCompanyRs>> {
            return localVarFp.customerQuerycurrentuserownedcompanies(term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 客戶 - 小計數據
         * @param {UserMgmtQueryCustomerUserSubtotalRq} [userMgmtQueryCustomerUserSubtotalRq] req model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq?: UserMgmtQueryCustomerUserSubtotalRq, options?: any): AxiosPromise<UserMgmtQueryCustomerUserSubtotalRs> {
            return localVarFp.customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 客戶人員
         * @param {UserMgmtQueryCustomerUserRq} [userMgmtQueryCustomerUserRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerQuerycustomerusers(userMgmtQueryCustomerUserRq?: UserMgmtQueryCustomerUserRq, options?: any): AxiosPromise<Array<UserMgmtQueryCustomerUserRs>> {
            return localVarFp.customerQuerycustomerusers(userMgmtQueryCustomerUserRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移除客戶帳號所有權限 公司負責人 And 組織成員
         * @param {UserMgmtCustomerRemoveAllPermissionRq} [userMgmtCustomerRemoveAllPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq?: UserMgmtCustomerRemoveAllPermissionRq, options?: any): AxiosPromise<void> {
            return localVarFp.customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(客戶) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerResendcurrentuserallcustomerpendinginvitations(options?: any): AxiosPromise<void> {
            return localVarFp.customerResendcurrentuserallcustomerpendinginvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 寄送 Customer 公司組織註冊邀請
         * @param {UserMgmtSendCustomerRegistrationInvitationRq} [userMgmtSendCustomerRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq?: UserMgmtSendCustomerRegistrationInvitationRq, options?: any): AxiosPromise<void> {
            return localVarFp.customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 驗證登入者是否是指定公司業務
         * @param {string} [companyUuid] company uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerVerifycurrentuserascompanycontact(companyUuid?: string, options?: any): AxiosPromise<UserMgmtVerifyCurrentUserAsCompanyContactRs> {
            return localVarFp.customerVerifycurrentuserascompanycontact(companyUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserMgmtCustomerApi - object-oriented interface
 * @export
 * @class UserMgmtCustomerApi
 * @extends {BaseAPI}
 */
export class UserMgmtCustomerApi extends BaseAPI {
    /**
     * 
     * @summary 刪除 Customer 公司組織註冊連結
     * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerDeletecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除客戶帳號
     * @param {UserMgmtDeleteCustomerAccount} [userMgmtDeleteCustomerAccount] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerDeletecustomeraccount(userMgmtDeleteCustomerAccount?: UserMgmtDeleteCustomerAccount, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerDeletecustomeraccount(userMgmtDeleteCustomerAccount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案 (csv)
     * @param {UserMgmtCustomerExportAllRq} [userMgmtCustomerExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerExportall(userMgmtCustomerExportAllRq?: UserMgmtCustomerExportAllRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerExportall(userMgmtCustomerExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案 (csv)
     * @param {UserMgmtCustomerExportSelectedRq} [userMgmtCustomerExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerExportselected(userMgmtCustomerExportSelectedRq?: UserMgmtCustomerExportSelectedRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerExportselected(userMgmtCustomerExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 產生 Customer 公司組織註冊連結
     * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerGeneratecurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 登入者邀請帳號(客戶) 目前為待驗證狀態筆數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerGetcurrentuserpendingcustomerinvitationcount(options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerGetcurrentuserpendingcustomerinvitationcount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 Customer 公司組織註冊連結
     * @param {UserMgmtGenerateCustomerRegistrationLinkRq} [userMgmtGenerateCustomerRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq?: UserMgmtGenerateCustomerRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerQuerycurrentusercustomerregistrationlink(userMgmtGenerateCustomerRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢當前使用者負責公司清單 (TOP 20)
     * @param {string} [term] 關鍵字查詢
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerQuerycurrentuserownedcompanies(term?: string, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerQuerycurrentuserownedcompanies(term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 客戶 - 小計數據
     * @param {UserMgmtQueryCustomerUserSubtotalRq} [userMgmtQueryCustomerUserSubtotalRq] req model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq?: UserMgmtQueryCustomerUserSubtotalRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerQuerycustomersubtotal(userMgmtQueryCustomerUserSubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 客戶人員
     * @param {UserMgmtQueryCustomerUserRq} [userMgmtQueryCustomerUserRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerQuerycustomerusers(userMgmtQueryCustomerUserRq?: UserMgmtQueryCustomerUserRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerQuerycustomerusers(userMgmtQueryCustomerUserRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移除客戶帳號所有權限 公司負責人 And 組織成員
     * @param {UserMgmtCustomerRemoveAllPermissionRq} [userMgmtCustomerRemoveAllPermissionRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq?: UserMgmtCustomerRemoveAllPermissionRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerRemoveallpermission(userMgmtCustomerRemoveAllPermissionRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 重新發送 登入者邀請帳號(客戶) 未完成驗證相關帳號
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerResendcurrentuserallcustomerpendinginvitations(options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerResendcurrentuserallcustomerpendinginvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 寄送 Customer 公司組織註冊邀請
     * @param {UserMgmtSendCustomerRegistrationInvitationRq} [userMgmtSendCustomerRegistrationInvitationRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq?: UserMgmtSendCustomerRegistrationInvitationRq, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerSendcustomerregistrationinvitation(userMgmtSendCustomerRegistrationInvitationRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 驗證登入者是否是指定公司業務
     * @param {string} [companyUuid] company uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtCustomerApi
     */
    public customerVerifycurrentuserascompanycontact(companyUuid?: string, options?: AxiosRequestConfig) {
        return UserMgmtCustomerApiFp(this.configuration).customerVerifycurrentuserascompanycontact(companyUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserMgmtProfileApi - axios parameter creator
 * @export
 */
export const UserMgmtProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取消邀請
         * @param {UserCancelInvitationRq} [userCancelInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCancelinvitation: async (userCancelInvitationRq?: UserCancelInvitationRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Profile/CancelInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCancelInvitationRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 名單管理 - 摘要
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileQuerysummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Profile/QuerySummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 重寄驗證 email
         * @param {UserResendConfirmEmailRq} [userResendConfirmEmailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileResendconfirmemail: async (userResendConfirmEmailRq?: UserResendConfirmEmailRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Profile/ResendConfirmEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResendConfirmEmailRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMgmtProfileApi - functional programming interface
 * @export
 */
export const UserMgmtProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserMgmtProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取消邀請
         * @param {UserCancelInvitationRq} [userCancelInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCancelinvitation(userCancelInvitationRq?: UserCancelInvitationRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCancelinvitation(userCancelInvitationRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtProfileApi.profileCancelinvitation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 名單管理 - 摘要
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileQuerysummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileQuerySummaryRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileQuerysummary(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtProfileApi.profileQuerysummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 重寄驗證 email
         * @param {UserResendConfirmEmailRq} [userResendConfirmEmailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileResendconfirmemail(userResendConfirmEmailRq?: UserResendConfirmEmailRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileResendconfirmemail(userResendConfirmEmailRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtProfileApi.profileResendconfirmemail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UserMgmtProfileApi - factory interface
 * @export
 */
export const UserMgmtProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserMgmtProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary 取消邀請
         * @param {UserCancelInvitationRq} [userCancelInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCancelinvitation(userCancelInvitationRq?: UserCancelInvitationRq, options?: any): AxiosPromise<void> {
            return localVarFp.profileCancelinvitation(userCancelInvitationRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 名單管理 - 摘要
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileQuerysummary(options?: any): AxiosPromise<UserProfileQuerySummaryRs> {
            return localVarFp.profileQuerysummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 重寄驗證 email
         * @param {UserResendConfirmEmailRq} [userResendConfirmEmailRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileResendconfirmemail(userResendConfirmEmailRq?: UserResendConfirmEmailRq, options?: any): AxiosPromise<void> {
            return localVarFp.profileResendconfirmemail(userResendConfirmEmailRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserMgmtProfileApi - object-oriented interface
 * @export
 * @class UserMgmtProfileApi
 * @extends {BaseAPI}
 */
export class UserMgmtProfileApi extends BaseAPI {
    /**
     * 
     * @summary 取消邀請
     * @param {UserCancelInvitationRq} [userCancelInvitationRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtProfileApi
     */
    public profileCancelinvitation(userCancelInvitationRq?: UserCancelInvitationRq, options?: AxiosRequestConfig) {
        return UserMgmtProfileApiFp(this.configuration).profileCancelinvitation(userCancelInvitationRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 名單管理 - 摘要
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtProfileApi
     */
    public profileQuerysummary(options?: AxiosRequestConfig) {
        return UserMgmtProfileApiFp(this.configuration).profileQuerysummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 重寄驗證 email
     * @param {UserResendConfirmEmailRq} [userResendConfirmEmailRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtProfileApi
     */
    public profileResendconfirmemail(userResendConfirmEmailRq?: UserResendConfirmEmailRq, options?: AxiosRequestConfig) {
        return UserMgmtProfileApiFp(this.configuration).profileResendconfirmemail(userResendConfirmEmailRq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserMgmtStaffApi - axios parameter creator
 * @export
 */
export const UserMgmtStaffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 分配公司業務給 人員
         * @param {UserMgmtAssignCompanyContactToStaffRq} [userMgmtAssignCompanyContactToStaffRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffAssigncompanycontacttostaff: async (userMgmtAssignCompanyContactToStaffRq?: UserMgmtAssignCompanyContactToStaffRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/AssignCompanyContactToStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtAssignCompanyContactToStaffRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 切換人員角色
         * @param {UserMgmtChangeStaffRoleRq} [userMgmtChangeStaffRoleRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffChangestaffrole: async (userMgmtChangeStaffRoleRq?: UserMgmtChangeStaffRoleRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/ChangeStaffRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtChangeStaffRoleRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除公司業務 by 人員
         * @param {UserMgmtDeleteCompanyContactByStaff} [userMgmtDeleteCompanyContactByStaff] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletecompanycontactbystaff: async (userMgmtDeleteCompanyContactByStaff?: UserMgmtDeleteCompanyContactByStaff, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/DeleteCompanyContactByStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtDeleteCompanyContactByStaff, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除人員帳號
         * @param {UserMgmtDeleteStaffAccountRq} [userMgmtDeleteStaffAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletestaffaccount: async (userMgmtDeleteStaffAccountRq?: UserMgmtDeleteStaffAccountRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/DeleteStaffAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtDeleteStaffAccountRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletestaffregistrationlink: async (userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/DeleteStaffRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateStaffRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtStaffExportAllRq} [userMgmtStaffExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffExportall: async (userMgmtStaffExportAllRq?: UserMgmtStaffExportAllRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/ExportAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtStaffExportAllRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtStaffExportSelectedRq} [userMgmtStaffExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffExportselected: async (userMgmtStaffExportSelectedRq?: UserMgmtStaffExportSelectedRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/ExportSelected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtStaffExportSelectedRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 產生 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffGeneratestaffregistrationlink: async (userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/GenerateStaffRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateStaffRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(系統人員) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffGetcurrentuserpendingstaffinvitationcount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/GetCurrentUserPendingStaffInvitationCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢標記 admin, super user, user 人員 列表
         * @param {UserMgmtQueryStaffMemberRq} [userMgmtQueryStaffMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffmembers: async (userMgmtQueryStaffMemberRq?: UserMgmtQueryStaffMemberRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/QueryStaffMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtQueryStaffMemberRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 管理人員 - 小計數據
         * @param {UserMgmtQueryStaffMemberSubtotalRq} [userMgmtQueryStaffMemberSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffmembersubtotal: async (userMgmtQueryStaffMemberSubtotalRq?: UserMgmtQueryStaffMemberSubtotalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/QueryStaffMemberSubtotal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtQueryStaffMemberSubtotalRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffregistrationlink: async (userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/QueryStaffRegistrationLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtGenerateStaffRegistrationLinkRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(系統人員) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffResendcurrentuserallpendingstaffinvitations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/ResendCurrentUserAllPendingStaffInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 發送 - 人員註冊邀請
         * @param {UserMgmtSendStaffRegistrationInvitationRq} [userMgmtSendStaffRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffSendstaffregistrationinvitation: async (userMgmtSendStaffRegistrationInvitationRq?: UserMgmtSendStaffRegistrationInvitationRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/SendStaffRegistrationInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtSendStaffRegistrationInvitationRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 轉移人員權限, 來源跟目標必須是 admin or super 才可以操作
         * @param {UserMgmtTransferStaffPermissionRq} [userMgmtTransferStaffPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffTransferstaffpermission: async (userMgmtTransferStaffPermissionRq?: UserMgmtTransferStaffPermissionRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserMgmt/Staff/TransferStaffPermission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMgmtTransferStaffPermissionRq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMgmtStaffApi - functional programming interface
 * @export
 */
export const UserMgmtStaffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserMgmtStaffApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 分配公司業務給 人員
         * @param {UserMgmtAssignCompanyContactToStaffRq} [userMgmtAssignCompanyContactToStaffRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq?: UserMgmtAssignCompanyContactToStaffRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffAssigncompanycontacttostaff']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 切換人員角色
         * @param {UserMgmtChangeStaffRoleRq} [userMgmtChangeStaffRoleRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffChangestaffrole(userMgmtChangeStaffRoleRq?: UserMgmtChangeStaffRoleRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffChangestaffrole(userMgmtChangeStaffRoleRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffChangestaffrole']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除公司業務 by 人員
         * @param {UserMgmtDeleteCompanyContactByStaff} [userMgmtDeleteCompanyContactByStaff] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff?: UserMgmtDeleteCompanyContactByStaff, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffDeletecompanycontactbystaff']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除人員帳號
         * @param {UserMgmtDeleteStaffAccountRq} [userMgmtDeleteStaffAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffDeletestaffaccount(userMgmtDeleteStaffAccountRq?: UserMgmtDeleteStaffAccountRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffDeletestaffaccount(userMgmtDeleteStaffAccountRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffDeletestaffaccount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffDeletestaffregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtStaffExportAllRq} [userMgmtStaffExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffExportall(userMgmtStaffExportAllRq?: UserMgmtStaffExportAllRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffExportall(userMgmtStaffExportAllRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffExportall']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtStaffExportSelectedRq} [userMgmtStaffExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffExportselected(userMgmtStaffExportSelectedRq?: UserMgmtStaffExportSelectedRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffExportselected(userMgmtStaffExportSelectedRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffExportselected']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 產生 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGenerateStaffRegistrationLinkRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffGeneratestaffregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(系統人員) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffGetcurrentuserpendingstaffinvitationcount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGetCurrentUserPendingStaffInvitationCountRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffGetcurrentuserpendingstaffinvitationcount(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffGetcurrentuserpendingstaffinvitationcount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢標記 admin, super user, user 人員 列表
         * @param {UserMgmtQueryStaffMemberRq} [userMgmtQueryStaffMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffQuerystaffmembers(userMgmtQueryStaffMemberRq?: UserMgmtQueryStaffMemberRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMgmtStaffMemberRs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffQuerystaffmembers(userMgmtQueryStaffMemberRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffQuerystaffmembers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 管理人員 - 小計數據
         * @param {UserMgmtQueryStaffMemberSubtotalRq} [userMgmtQueryStaffMemberSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq?: UserMgmtQueryStaffMemberSubtotalRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtStaffMemberSubtotalRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffQuerystaffmembersubtotal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMgmtGenerateStaffRegistrationLinkRs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffQuerystaffregistrationlink']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(系統人員) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffResendcurrentuserallpendingstaffinvitations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffResendcurrentuserallpendingstaffinvitations(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffResendcurrentuserallpendingstaffinvitations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 發送 - 人員註冊邀請
         * @param {UserMgmtSendStaffRegistrationInvitationRq} [userMgmtSendStaffRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq?: UserMgmtSendStaffRegistrationInvitationRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffSendstaffregistrationinvitation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 轉移人員權限, 來源跟目標必須是 admin or super 才可以操作
         * @param {UserMgmtTransferStaffPermissionRq} [userMgmtTransferStaffPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffTransferstaffpermission(userMgmtTransferStaffPermissionRq?: UserMgmtTransferStaffPermissionRq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffTransferstaffpermission(userMgmtTransferStaffPermissionRq, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserMgmtStaffApi.staffTransferstaffpermission']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UserMgmtStaffApi - factory interface
 * @export
 */
export const UserMgmtStaffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserMgmtStaffApiFp(configuration)
    return {
        /**
         * 
         * @summary 分配公司業務給 人員
         * @param {UserMgmtAssignCompanyContactToStaffRq} [userMgmtAssignCompanyContactToStaffRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq?: UserMgmtAssignCompanyContactToStaffRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 切換人員角色
         * @param {UserMgmtChangeStaffRoleRq} [userMgmtChangeStaffRoleRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffChangestaffrole(userMgmtChangeStaffRoleRq?: UserMgmtChangeStaffRoleRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffChangestaffrole(userMgmtChangeStaffRoleRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除公司業務 by 人員
         * @param {UserMgmtDeleteCompanyContactByStaff} [userMgmtDeleteCompanyContactByStaff] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff?: UserMgmtDeleteCompanyContactByStaff, options?: any): AxiosPromise<void> {
            return localVarFp.staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除人員帳號
         * @param {UserMgmtDeleteStaffAccountRq} [userMgmtDeleteStaffAccountRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletestaffaccount(userMgmtDeleteStaffAccountRq?: UserMgmtDeleteStaffAccountRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffDeletestaffaccount(userMgmtDeleteStaffAccountRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出檔案 (csv)
         * @param {UserMgmtStaffExportAllRq} [userMgmtStaffExportAllRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffExportall(userMgmtStaffExportAllRq?: UserMgmtStaffExportAllRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffExportall(userMgmtStaffExportAllRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 輸出選取檔案 (csv)
         * @param {UserMgmtStaffExportSelectedRq} [userMgmtStaffExportSelectedRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffExportselected(userMgmtStaffExportSelectedRq?: UserMgmtStaffExportSelectedRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffExportselected(userMgmtStaffExportSelectedRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 產生 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: any): AxiosPromise<UserMgmtGenerateStaffRegistrationLinkRs> {
            return localVarFp.staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 登入者邀請帳號(系統人員) 目前為待驗證狀態筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffGetcurrentuserpendingstaffinvitationcount(options?: any): AxiosPromise<UserMgmtGetCurrentUserPendingStaffInvitationCountRs> {
            return localVarFp.staffGetcurrentuserpendingstaffinvitationcount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢標記 admin, super user, user 人員 列表
         * @param {UserMgmtQueryStaffMemberRq} [userMgmtQueryStaffMemberRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffmembers(userMgmtQueryStaffMemberRq?: UserMgmtQueryStaffMemberRq, options?: any): AxiosPromise<Array<UserMgmtStaffMemberRs>> {
            return localVarFp.staffQuerystaffmembers(userMgmtQueryStaffMemberRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 管理人員 - 小計數據
         * @param {UserMgmtQueryStaffMemberSubtotalRq} [userMgmtQueryStaffMemberSubtotalRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq?: UserMgmtQueryStaffMemberSubtotalRq, options?: any): AxiosPromise<UserMgmtStaffMemberSubtotalRs> {
            return localVarFp.staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢 - 人員註冊連結
         * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: any): AxiosPromise<UserMgmtGenerateStaffRegistrationLinkRs> {
            return localVarFp.staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 重新發送 登入者邀請帳號(系統人員) 未完成驗證相關帳號
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffResendcurrentuserallpendingstaffinvitations(options?: any): AxiosPromise<void> {
            return localVarFp.staffResendcurrentuserallpendingstaffinvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 發送 - 人員註冊邀請
         * @param {UserMgmtSendStaffRegistrationInvitationRq} [userMgmtSendStaffRegistrationInvitationRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq?: UserMgmtSendStaffRegistrationInvitationRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 轉移人員權限, 來源跟目標必須是 admin or super 才可以操作
         * @param {UserMgmtTransferStaffPermissionRq} [userMgmtTransferStaffPermissionRq] rq model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffTransferstaffpermission(userMgmtTransferStaffPermissionRq?: UserMgmtTransferStaffPermissionRq, options?: any): AxiosPromise<void> {
            return localVarFp.staffTransferstaffpermission(userMgmtTransferStaffPermissionRq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserMgmtStaffApi - object-oriented interface
 * @export
 * @class UserMgmtStaffApi
 * @extends {BaseAPI}
 */
export class UserMgmtStaffApi extends BaseAPI {
    /**
     * 
     * @summary 分配公司業務給 人員
     * @param {UserMgmtAssignCompanyContactToStaffRq} [userMgmtAssignCompanyContactToStaffRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq?: UserMgmtAssignCompanyContactToStaffRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffAssigncompanycontacttostaff(userMgmtAssignCompanyContactToStaffRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 切換人員角色
     * @param {UserMgmtChangeStaffRoleRq} [userMgmtChangeStaffRoleRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffChangestaffrole(userMgmtChangeStaffRoleRq?: UserMgmtChangeStaffRoleRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffChangestaffrole(userMgmtChangeStaffRoleRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除公司業務 by 人員
     * @param {UserMgmtDeleteCompanyContactByStaff} [userMgmtDeleteCompanyContactByStaff] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff?: UserMgmtDeleteCompanyContactByStaff, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffDeletecompanycontactbystaff(userMgmtDeleteCompanyContactByStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除人員帳號
     * @param {UserMgmtDeleteStaffAccountRq} [userMgmtDeleteStaffAccountRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffDeletestaffaccount(userMgmtDeleteStaffAccountRq?: UserMgmtDeleteStaffAccountRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffDeletestaffaccount(userMgmtDeleteStaffAccountRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除 - 人員註冊連結
     * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffDeletestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出檔案 (csv)
     * @param {UserMgmtStaffExportAllRq} [userMgmtStaffExportAllRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffExportall(userMgmtStaffExportAllRq?: UserMgmtStaffExportAllRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffExportall(userMgmtStaffExportAllRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 輸出選取檔案 (csv)
     * @param {UserMgmtStaffExportSelectedRq} [userMgmtStaffExportSelectedRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffExportselected(userMgmtStaffExportSelectedRq?: UserMgmtStaffExportSelectedRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffExportselected(userMgmtStaffExportSelectedRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 產生 - 人員註冊連結
     * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffGeneratestaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 登入者邀請帳號(系統人員) 目前為待驗證狀態筆數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffGetcurrentuserpendingstaffinvitationcount(options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffGetcurrentuserpendingstaffinvitationcount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢標記 admin, super user, user 人員 列表
     * @param {UserMgmtQueryStaffMemberRq} [userMgmtQueryStaffMemberRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffQuerystaffmembers(userMgmtQueryStaffMemberRq?: UserMgmtQueryStaffMemberRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffQuerystaffmembers(userMgmtQueryStaffMemberRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 管理人員 - 小計數據
     * @param {UserMgmtQueryStaffMemberSubtotalRq} [userMgmtQueryStaffMemberSubtotalRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq?: UserMgmtQueryStaffMemberSubtotalRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffQuerystaffmembersubtotal(userMgmtQueryStaffMemberSubtotalRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢 - 人員註冊連結
     * @param {UserMgmtGenerateStaffRegistrationLinkRq} [userMgmtGenerateStaffRegistrationLinkRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq?: UserMgmtGenerateStaffRegistrationLinkRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffQuerystaffregistrationlink(userMgmtGenerateStaffRegistrationLinkRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 重新發送 登入者邀請帳號(系統人員) 未完成驗證相關帳號
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffResendcurrentuserallpendingstaffinvitations(options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffResendcurrentuserallpendingstaffinvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 發送 - 人員註冊邀請
     * @param {UserMgmtSendStaffRegistrationInvitationRq} [userMgmtSendStaffRegistrationInvitationRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq?: UserMgmtSendStaffRegistrationInvitationRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffSendstaffregistrationinvitation(userMgmtSendStaffRegistrationInvitationRq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 轉移人員權限, 來源跟目標必須是 admin or super 才可以操作
     * @param {UserMgmtTransferStaffPermissionRq} [userMgmtTransferStaffPermissionRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMgmtStaffApi
     */
    public staffTransferstaffpermission(userMgmtTransferStaffPermissionRq?: UserMgmtTransferStaffPermissionRq, options?: AxiosRequestConfig) {
        return UserMgmtStaffApiFp(this.configuration).staffTransferstaffpermission(userMgmtTransferStaffPermissionRq, options).then((request) => request(this.axios, this.basePath));
    }
}



